import 'nouislider/dist/nouislider.css';
import polylabel from "polylabel";
import {
  _does,
  cmToFt,
  degToRad,
  devAndPolyIntersects,
  doesDeviceFitRoom,
  ftToCm,
  getDeviceRealPoints,
  getRoomAreaCM2,
  isPointOnSegment,
  isPointValid,
  line_line_intersect,
  NumToXYPoly,
  P_numtoxy,
  P_xytonum,
  rotatePointAroundAnotherXY,
  roundTo,
  snapAngleTo45,
  snapDeviceToWall,
  uMath,
  vectorRotationDegree,
  wallClosestPointToPoint,
  XYto2DArr,
  XYtoNumPoly
} from "src/components/Planner/planner/uMath";
import {
  MEASURE_LINE_MIN_PXLEN
} from "src/components/Planner/planner/wallModHelper";
import {
  deleteModdedWallModConns,
  deleteRoomWallModConns,
  entitySelectClick,
  entitySelectUpdate,
  redrawWallSelectInput,
  redrawWallSelectLine,
  wallModHelperDOM,
  wallSelectStart,
  wallSelectUpdate
} from "src/components/Planner/planner/wallModHelper-dom";
import $ from "jquery";
import * as d3 from "d3";
import {PlannerGlobals} from "src/components/Planner/planner/planner-globals";
import {
  getDColsNum,
  getDRowsNum,
  SERIAL_SPACING
} from "src/components/Planner/planner/serial-layout";
import {
  GET_SER_MARG,
  getDeviceById,
  getDistinctGroupsOfDevs,
  getDistinctSerialConnectionsOfDevs,
  getFirstOccurrenceOfDev,
  getFrameWidth,
  getGroupOfDevice,
  getGroupsOfDevice,
  getNote,
  getRoomById,
  getSerialById,
  getSerialCenter2d,
  getSerialCenterPos2,
  getSerialOfDeviceId,
  ghostDevProps,
  isD3DevSnapped,
  isDevChangeInProgress,
  isDInGroup,
  isRoomOutside,
  rebuildWallsCache,
  thereWasGhostDevice,
  uDev,
  UDevGlobals,
  wallsOfRoom
} from "src/components/Planner/planner/uDev";
import {
  canBeDevMerged,
  deleteDevNote,
  getMergedDevice,
  isDevSingle,
  modDevNote,
  removeDevAllOccurrences,
  sendDevNote,
  uDevDOM
} from "src/components/Planner/planner/uDev-dom";
import {
  areDevicesGroupableAllRules,
  recalcSwitchPNIDs,
  redrawGroups,
  showGroupInvalidMsgIfAnyIsInvalid
} from "src/components/Planner/planner/grouping";
import {
  drawDraggedMotionSensor,
  isCamera,
  isMotionSensorMode
} from "src/components/Planner/planner/movsen";
import {
  redrawDevice,
  redrawDevices,
  redrawSerial
} from "src/components/Planner/planner/deviceDrawing";
import {ROOT_URI} from "src/utils/constants"
import {getFrontendURL} from "src/utils/url"
import {ts, ts2} from "src/utils/translate"
import {
  cmToInch,
  inchToCm,
  squareMeterToSquareFoot,
} from "src/utils/imperialConverter";
import {
  getSerialConnCenterPos,
  getSerialConnectedPair,
  getSerialConnectionProps
} from "src/components/Planner/planner/serialConnections";
import {
  ajaxSetSerialProps,
  connectSerials,
  highlightSerial,
  removeDeviceFromSerial,
  serialOnClick
} from "src/components/Planner/planner/serialConnections-dom";
import {
  CreateRoomAction,
  ModifyRoomAction
} from "src/components/Planner/planner/history/room-actions";
import {
  CreateSingleDeviceAction,
  DeleteMultipleDevicesAction,
  RotateDeviceAction
} from "src/components/Planner/planner/history/device-actions";
import swal from 'sweetalert';
import {
  ModifyDevSizeNoErrorAction,
  ModifyScaleErrorAction,
  ModifyScaleNoErrorAction
} from "src/components/Planner/planner/history/scale-actions";
import {
  CreateOuterWallsAction
} from "src/components/Planner/planner/history/outerwall-actions";
import {
  ControllerGlobals,
  deepCopy,
  FADE_LENGTH,
  genericXHRErrorHandler,
  getAuthHeader,
  isMobile,
  isMouseInsideWindow,
  MC,
  MODKEYS_STATE,
  startLoading,
  stopLoading,
  toastError,
  toastErrorSingle,
  toastInfo,
  toastInfoSingle,
  toastRemoveAll,
  toastSuccess,
  whenAll
} from "src/components/Planner/controller";
import {
  DEBUG_updateNSend
} from "src/components/Planner/planner/deviceSizeTransition";
import {SVG_TEXT_HELPER} from "src/utils/svgTextHelper";
import {
  draw_measureMeMove,
  filterInvalidMeasurements,
  getMeasurementsOfD,
  getMeasurementsOfDevice,
  getMeasurementsOfSerial,
  getMeasurementsOfWallModConn,
  isDInMeasures,
  measureHelper,
  measurePrepareCleanup,
  redrawMeasurements,
  redrawMeasurementsOf,
  removeDeviceFromMeasuresLocal,
  resetMeasureProps,
  showMeasureDelTool,
  toggleMeasurements
} from "src/components/Planner/planner/measurement";
import {
  dragNote,
  highlightNote,
  redrawNotes,
  showNoteTools
} from "src/components/Planner/planner/notes";
import {
  doDragChecks,
  dragdev,
  mouseMoveDraggedDevHandler,
  roomCircleDragHandler,
  showDragAndDropOverlay
} from "src/components/Planner/planner/draganddrop";
import {
  instantCalcOuter,
  outerWallModCleanup,
  redrawOuterWalls,
  saveOuterWalls,
  selectOuterWalls,
  willCalcOuter
} from "src/components/Planner/planner/outerwall";
import {
  getToolSize,
  showRotateTool,
  showTools
} from "src/components/Planner/planner/deviceTools";
import {
  isCategoryLocked,
  isCategoryShown
} from "src/components/Planner/planner/categoryDisplayHandler";
import {genericAlertSwal} from "src/utils/swal";
import {
  hasPermissionForFuncInRole
} from "src/utils/controllerHasPermissionsAdapter";
import {
  refreshFloorView
} from "src/components/Planner/planner/plannerCacheInvalidation";

/**
 * @typedef {Object} Device
 * @property {number} x The x coordinate of the device's top left corner
 * @property {number} y The y coordinate of the device's top left corner
 * @property {number} deviceId The device's identifier
 * @property {string} image The URI of the device's icon
 * @property {boolean} input If true, the device is an input, else it's an output
 * @property {number} roomId The room that the device resides in
 * @property {boolean} groupable If true, the device can be put in a group
 * @property {boolean} serializable If true, the device can be put in a mounting frame
 * @property {number} category_id The id of the category that the device is in
 * @property {number} angle Rotation of the device
 * @property {number} rotate_value Rotation of the device
 * @property {number} product_name_id Identifier of the placed product
 * @property {boolean} is_loxone Is device a Loxone smart home item
 * @property {boolean} has_design Has a device another design
 * @property {boolean} hasNote Does device have a note
 * @property {number} noteId ID of the device's note
 * @property {string} noteTxt Text of the device's note
 * @property {string} noteColor Color of the device's note
 * @property {boolean} noteGhost Is the dev's note being deleted
 * @property {number} qty If the device is merged, this is the count in the device badge.
 * @property {number[]} similarDeviceIds If the device is merged, these are the grouped deviceIds.
 */


/**
 * @typedef {Object} Product
 * @property {string} id For example "product_100". Contains the PNID
 * @property {string} icon Tree icon of device
 * @property {string} image Planner image of device
 * @property {string} text Name of device
 * @property {boolean} groupable Is the device groupable
 * @property {boolean} serializable Is the device in a frame
 * @property {boolean} input Is the device an input if in a group
 * @property {boolean} is_loxone Is the device made by Loxone
 * @property {boolean} has_design Has a device another design
 * @property {string} note_message The default note of the device, if it has one, otherwise empty string
 * @property {string} parent For example "category_9"
 * @property {"device" | "custom_device" | "_" | ""} type
 */

/**
 * @typedef {Object} D3Device
 * @property {number | null} id exists if d3dev is a serial
 * @property {number | null} connId exists if d3dev contains connected serials
 * @property {Device[]} devices
 * @property {number} x
 * @property {number} y
 * @property {number} angle
 * @property {number} roomId
 */

/**
 * @typedef {Object} Serial
 * @property {number} id The serial's identifier
 * @property {number[]} deviceIds The devices' identifiers that the serial contains
 * @property {number} angle Rotation of the serial
 * @property {number} roomId The room that the serial resides in
 * @property {number?} height
 * @property {"vertical" | "horizontal"} direction
 */

/**
 * @typedef {Object} SerialConnection
 * @property {number} id The id of the connection
 * @property {number[]} serialIds The frames that the connection contains
 */

/**
 * @typedef {Object} Group
 * @property {number} id The serial's identifier
 * @property {number[]} deviceIds The devices' identifiers that the group contains
 */

/**
 * @typedef {Object} Point
 * @property {number} x The X coordinate of the point
 * @property {number} y The Y coordinate of the point
 */

/**
 * @typedef {[number, number]} NPoint
 */

/**
 * @typedef {[number,number][]} NPoly
 */

/**
 * @typedef {Object} PolyPoint
 * @property {number} x The X coordinate of the point
 * @property {number} y The Y coordinate of the point
 * @property {number} order_index index of the point in its array
 * @property {number} id unique identifier of the point
 */

/**
 * Will be deprecated - lines should be infinite, these were used for *segments*
 * @typedef {Object} Line
 * @property {number} x1 Starting x coordinate of the line
 * @property {number} y1 Starting y coordinate of the line
 * @property {number} x2 Ending x coordinate of the line
 * @property {number} y2 Ending y coordinate of the line
 */

/**
 * @typedef {Object} Segment
 * @property {number} x1 Starting x coordinate of the line segment
 * @property {number} y1 Starting y coordinate of the line segment
 * @property {number} x2 Ending x coordinate of the line segment
 * @property {number} y2 Ending y coordinate of the line segment
 */

/**
 * @typedef {Object} Wall
 * @property {number} x1 Starting x coordinate of the wall
 * @property {number} y1 Starting y coordinate of the wall
 * @property {number} x2 Ending x coordinate of the wall
 * @property {number} y2 Ending y coordinate of the wall
 * @property {number} roomId The ID of the room that the wall is in
 * @property {number} id ID of the wall
 * @property {number} order_index index of the wall
 */

/**
 * @typedef {Object} Room
 * @property {number} id The unique identifier of the room
 * @property {PolyPoint[]} poly The room's polygon
 * @property {string} roomname The name of the room that is displayed
 * @property {number} airm3 Air capacity of the room in cubic meters
 * @property {number} room_headroom Headroom of the room in centimeters
 * @property {number} area Area of the room in square centimeters
 * @property {number} room_area Area of the room in square centimeters
 * @property {[number, number]} labelPlace
 * @property {number} room_type_id
 * @property {number} room_airspace
 */

/**
 * @typedef {Object} MeasurementConnection
 * @property {number} id
 * @property {MeasurementTarget} source
 * @property {MeasurementTarget} target
 * @property {number} id
 * @property {boolean} invalid
 */

/**
 * @typedef {Object} MeasurementTarget
 * @property {number} id
 * @property {string} type
 * @property {Point?} center
 * @property {Point?} measurePtOverride if exists, and a Point, it will become the point for measurement
 */

/**
 * @typedef {Object} WallMod
 * @property {number} connId
 * @property {number} id
 * @property {boolean} isSingle
 * @property {WallMod?} pair
 * @property {[Point, Point]} points
 * @property {number} roomId
 * @property {number[]} wallIds
 * @property {"window" | "door"} type "window" or "door"
 */

/**
 * @typedef {Object} WallModConnection
 * @property {number} id
 * @property {WallMod[]} rooms
 * @property {"window" | "door"} type "window" or "door"
 */

/**
 * @typedef {Object} Rect
 * @property {number} x
 * @property {number} y
 * @property {number} width
 * @property {number} height
 */

/**
 * @typedef {Object} Note
 * @property {number} note_id
 * @property {number} x
 * @property {number} y
 * @property {string} text
 * @property {string} color
 * @property {boolean} ghost
 */
let _plannerCallbacks = {
  onBulkDeleteDevice: null,
  onSelectDevice: null,
  onScaleSaved: null,
  onFullscreenChange: null
};

export function setPlannerCallbacks({
  onBulkDeleteDevice,
  onSelectDevice,
  onScaleSaved,
  onFullscreenChange
}) {
    _plannerCallbacks.onBulkDeleteDevice = onBulkDeleteDevice;
    _plannerCallbacks.onSelectDevice = onSelectDevice;
    _plannerCallbacks.onScaleSaved = onScaleSaved;
    _plannerCallbacks.onFullscreenChange = onFullscreenChange;
}

let margin = { top: -5, right: -5, bottom: -5, left: -5 },
    width = 960 - margin.left - margin.right,
    height = 500 - margin.top - margin.bottom;


export const MEASURE_TYPES = {
  wall: 1,
  device: 2,
  serial: 3,
  userCustomItem: 4,
  wallMod: 5
};

export const MEASURE_DEFAULT_MAX_CM = 2500;
export const MEASURE_DEFAULT_MAX_IN = 1000;

export const MEASURE_DEFAULT_MIN_CM = 90;
export const MEASURE_DEFAULT_MIN_IN = 35;

export const SWI_PNID = {
  onepole_101: 368,
  switch_106: 16,
  twopole_102: 17,
  chandelier_105: 18,
  cross_107: 19,
  double_106p6: 20,
  dimmer: 305
};

export const DIMMED_ITEMS = [305, 303, 304];

export function isPNIDDimmed(pnid) {
  return _does([305, 303, 304]).contain(+pnid);
}

export function setIsTheScaleChecked(plannerFloorId)
{
  getAuthHeader(function (headers) {
    $.ajax({
      method: "post",
      headers: headers,
      url: ROOT_URI + '/floor/set-scale-checked',
      data: {
        floor_id: plannerFloorId,
      },
      success: function (resp) {

      },
      error: function (resp) {

      }
    });
  });
}
//setting up initial variables

let BASE_DEVICE_SIZE = 10;

export function showActualSizeBtn() {
  $('[id^="planner-devsize"]').hide();
  $('#planner-devsize-' + PlannerGlobals.DEVICE_SIZE_MODS[PlannerGlobals.DEVICE_SIZE_MOD || 25].btn).show();
}

let hideNoteCopyTimeout = null;

let wizardListTimeout = null;

export function isPlannerMetric() {
  return PlannerGlobals.PLANNER_MEASUREMENT_SYSTEM === "metric";
}

export function isPlannerImperial() {
  return PlannerGlobals.PLANNER_MEASUREMENT_SYSTEM === "imperial";
}

/**
 * possible values for device sizes, and values that come after them
 */
let devSizes = {
  '10': { next: '15' },
  '15': { next: '25' },
  '25': { next: '10' }
};


export function objValid(obj) {
  if ($.isEmptyObject(obj)) return false;
  for (var i in obj) {
    if (!obj[i] && obj[i] != 0) {
      return false;
    }
  }
  return true;
}

export function changedWallIds() {
  return Object.keys(PlannerGlobals.changedWalls).map(function (n) { return +n });
}

export function checkAndPanDraw() {
  if (!document.hasFocus()) {
    return;
  }
  var extent = 750;
  var SPEED_INCREASE_WITH_SCALE = 1 / 4;
  var dir = panForDrawingDirection(70, 18);

  var currTranslate = P_numtoxy(PlannerGlobals.translatevar);
  if (dir.x != 0 || dir.y != 0) {
    var mod = (1 + (PlannerGlobals.scalevar - 1) * SPEED_INCREASE_WITH_SCALE);
    var newX = currTranslate.x - dir.x * mod;
    if (newX < -PlannerGlobals.scalevar * extent && dir.x > 0 || newX > PlannerGlobals.scalevar * extent && dir.x < 0) {
      newX = currTranslate.x;
    }
    var newY = currTranslate.y - dir.y * mod;
    if (newY < -PlannerGlobals.scalevar * extent && dir.y > 0 || newY > PlannerGlobals.scalevar * extent && dir.y < 0) {
      newY = currTranslate.y;
    }
    setTranslateTo(newX, newY, PlannerGlobals.scalevar, PlannerGlobals.DRAW_PAN_TIME);
    // update elements that depend on mousemove after autopanning
    draw_mouseMove();
    draw_groupMeMove();
    draw_measureMeMove();
    wallSelectUpdate();
    mouseMoveDraggedDevHandler();
    dragdev(null, PlannerGlobals.DRAG_HELPER.draggedD3Dev);
    dragNote(null, PlannerGlobals.DRAG_HELPER.draggedNote);
    if (PlannerGlobals.draggedRoomCircle) {
      roomCircleDragHandler(null, PlannerGlobals.draggedRoomCircle);
    }
  }
}

let PAGEXY = { x: 0, y: 0 };
let MIDBTNPRESSED = false;
let LEFTBTNPRESSED = false;

export function setPageXY(e) {
  if (e) {
    PAGEXY.x = e.pageX || 0;
    PAGEXY.y = e.pageY || 0;
    MIDBTNPRESSED = (e.buttons & 4) == 4 /* || (e.buttons & 1) == 1 */;
    LEFTBTNPRESSED = (e.buttons & 1) == 1;
  }
}

/**
 *
 * @param {any[]?} arr If supplied, elements with the given selector won't be disabled
 */
export function disablePlannerButtonsExcept(arr) {
  $('#svgAndChat').addClass('planner-buttons-disable-some');
  if (Array.isArray(arr)) {
    arr.forEach(function (elem) {
      $(elem).addClass('disable-exception');
    });
  }
}

export function enablePlannerButtons() {
  $('#svgAndChat').removeClass('planner-buttons-disable-some');
}

export function requireLeavingToolbarOnce() {
  var elem = $('#planner-buttons');
  elem.css('pointer-events', 'all').addClass('havent-exited');
  if (elem.is(':hover')) {
    elem.one('mouseleave', function (e) {
      $(this).css('pointer-events', '').removeClass('havent-exited');
    });
  }
  else {
    elem.css('pointer-events', '').removeClass('havent-exited');
  }
}

export function dontRequireLeavingToolbarOnce() {
  $('#planner-buttons').css('pointer-events', '');
  $('.havent-exited').removeClass('havent-exited');
}

export function isPlannerBusy() {
  if (!document.getElementById('svgAndChat')) {
    return false;
  }
  else if (typeof PlannerGlobals.sizeErrorHelper !== "undefined" && PlannerGlobals.sizeErrorHelper.errorCorrectMode) {
    return ts("p_err_fix_please", "Please fix the errors first.");
  }
  else if (typeof PlannerGlobals.plannerHistoryManager !== "undefined" && PlannerGlobals.plannerHistoryManager.busy || isDevChangeInProgress()) {
    return ts("p_history_busy", "Please wait, another operation is in progress.");
  }
  else {
    return false;
  }
}

/**
 * available modes
 *
 * BASIC: the default state. No button on the toolbar is pressed. You can press devices to make the chat, and the delete X appear.
 * Devices also can be moved
 *
 * DRAWING: only drawing a new room is available
 *
 * PREPARESELECT: the mode which allows selecting a room to be edited. when a room is selected, it brings the state to SELECTROOM
 *
 * SELECTROOM: a room is selected. moving the dots of its polygon is allowed.
 */

export function modeChanged(m) {
  PlannerGlobals.mode = m;
  showDragAndDropOverlay();
}
export const setMode = {
  /**
   * the default state. No button on the toolbar is pressed. You can press devices to make the chat, and the delete X appear.
   * Devices also can be moved
   */
  'basic': function (noRemoveToast = false) {
    CleanupAll(noRemoveToast);
    modeChanged('basic');
    $('#plannerSVG').attr('data-mode', PlannerGlobals.mode);
  },
  /**
   * only drawing a new room is available
   */
  'drawing': function (noRemoveToast) {
    var busyReason = isPlannerBusy();
    if (busyReason) {
      toastInfo(busyReason);
      return false;
    }
    CleanupAll(noRemoveToast);
    $('#toggle-drawing-btn').addClass('pressed');
    $('#modify-bg-btn').css("display", "none");
    if (!PlannerGlobals.isDrawing) {
      PlannerGlobals.svg.style('cursor', 'crosshair');
      PlannerGlobals.isDrawing = true;
      PlannerGlobals.drawRoomStartPoint = null;
    }

    disablePlannerButtonsExcept(['#toggle-drawing-btn', '#zen-mode-btn', '#planner-sizers']);
    requireLeavingToolbarOnce();

    modeChanged('drawing');
    $('#plannerSVG').attr('data-mode', PlannerGlobals.mode);
  },
  'drawOuterW': function () {
    var busyReason = isPlannerBusy();
    if (busyReason) {
      toastInfo(busyReason);
      return false;
    }
    CleanupAll();
    $('#toggle-drawouter-btn').addClass('pressed');
    $('#modify-bg-btn').css("display", "none");

    if (!PlannerGlobals.isDrawing) {
      PlannerGlobals.svg.style('cursor', 'crosshair');
      PlannerGlobals.isDrawing = true;
      PlannerGlobals.drawRoomStartPoint = null;
    }

    disablePlannerButtonsExcept(['#toggle-drawouter-btn', '#zen-mode-btn', '#planner-sizers']);

    // if (newTour.isOngoing() && newTour.currStepId === "draw_outer_wall") {
    //     newTour.addMustClickCircleSeries(newTour.getOuterBorderSteps());
    // }

    modeChanged('drawOuterW');
    $('#plannerSVG').attr('data-mode', PlannerGlobals.mode);
  },
  'modifyOuterW': function () {
    var busyReason = isPlannerBusy();
    if (busyReason) {
      toastInfo(busyReason);
      return false;
    }
    CleanupAll();

    requireLeavingToolbarOnce();

    $('#toggle-drawouter-btn').addClass('pressed');
    $('#modify-bg-btn').css("display", "none");
    $(".planner-buttons-cont").not('.planner-modify-item').addClass('hidden');
    $('#toggle-prepareSelect-btn').addClass('pressed');
    $('.planner-modify-item').removeClass('hidden').css('visibility', '');
    $('.planner-floor-manip').addClass('hidden');
    $('.planner-floormod-input').addClass('hidden');
    d3.select('#outerBorderLine').remove();

    modeChanged('modifyOuterW');

    //drawOuterWallModify();
    selectOuterWalls();
    $('#plannerSVG').attr('data-mode', PlannerGlobals.mode);
  },
  /**
   * aka wallSelect V2
   */
  'propSelect': function () {

  },
  /**
   * the mode which allows selecting a room to be edited. when a room is selected, it brings the state to SELECTROOM
   */
  'prepareSelect': function () {
    var busyReason = isPlannerBusy();
    if (busyReason) {
      toastInfo(busyReason);
      return false;
    }
    if (!PlannerGlobals.plannerIsLoaded) { return; }

    CleanupAll();
    $('#toggle-prepareSelect-btn').addClass('pressed');

    modeChanged('prepareSelect');

    $('#plannerSVG').attr('data-mode', PlannerGlobals.mode);
  },
  /**
   * a room is selected. moving the dots of its polygon is allowed.
   */
  'selectRoom': function () {
    var busyReason = isPlannerBusy();
    if (busyReason) {
      toastInfo(busyReason);
      return false;
    }
    if (!PlannerGlobals.plannerIsLoaded) { return; }

    d3.select('#measurements').remove();
    CleanupAll();
    $(".planner-buttons-cont").not('.planner-modify-item').addClass('hidden');
    $('#toggle-prepareSelect-btn').addClass('pressed');
    $('.planner-modify-item').removeClass('hidden').css('visibility', '');
    $('.planner-floor-manip').addClass('hidden');
    if (!isMobile && !PlannerGlobals.isInQuote) {
      $('#name-modify-input').focus();
    }
    PlannerGlobals.selectRoomUndoArr = [];
    PlannerGlobals.changedWalls = {};

    modeChanged('selectRoom');

    $('#plannerSVG').attr('data-mode', PlannerGlobals.mode);

    $('#name-modify-input').off('keyup.newtour');
  },
  /**
   * [UNUSED] the mode that allows selecting the first item for making a new group
   */
  'prepareGrouping': function () {
    CleanupAll();
    $('#toggle-grouping-btn').addClass('pressed');
    $('.device').css('cursor', 'pointer');
    modeChanged('prepareGrouping');
    $('#plannerSVG').attr('data-mode', PlannerGlobals.mode);
  },
  /**
   * [UNUSED] the mode that allows selecting items for a new group, and saving it
   */
  'grouping': function () {
    $('.planner-grouping-item').removeClass('hidden');
    modeChanged('grouping');
    $('#plannerSVG').attr('data-mode', PlannerGlobals.mode);
  },
  /**
   * [UNUSED] the mode that allows selecting devices to read their comment lines, and displays important comments
   * next to the devices
   */
  'commenting': function () {
    CleanupAll();
    chatMomentSVGTranslate = transformStringToXY(PlannerGlobals.translatevar);
    $('#toggle-commenting-btn').addClass('pressed');
    $('.device').css('cursor', 'pointer');
    modeChanged('commenting');
    showImportants();
    $('#plannerSVG').attr('data-mode', PlannerGlobals.mode);
  },
  /**
   * the mode that's turned on when a grouping line is dragged from a device
   */
  'groupMe': function (deviceId) {
    PlannerGlobals.groupMeSourceId = deviceId;
    PlannerGlobals.groupMeStartMousePt = getXYP();
    PlannerGlobals.groupMeXY = getDevicePositionCenter(getDeviceById(deviceId));

    highlightAllDevices('grp', tarDev => areDevicesGroupableAllRules(deviceId, tarDev.deviceId), 'rgb(0, 220, 44)', 'rgba(2, 86, 0, 0.98)');

    disablePlannerButtonsExcept();
    modeChanged('groupMe');
    $('#plannerSVG').attr('data-mode', PlannerGlobals.mode);
  },
  'measurePrepare': function (id) {
    var busyReason = isPlannerBusy();
    if (busyReason) {
      toastInfo(busyReason);
      return false;
    }
    CleanupAll();
    if (!PlannerGlobals.measurements_on) {
      toggleMeasurements();
    }
    $("#measure-distance-btn").addClass("pressed");
    if (!PlannerGlobals.measureSuccess) {
      toastRemoveAll();
      toastInfo(ts('p_measure_start_help', "Start dragging from a <b>Device</b> or a <b>Frame</b>, and keep the mouse button pressed down."));
    }

    disablePlannerButtonsExcept(['#measure-distance-btn', '#zen-mode-btn', '#planner-sizers']);

    rebuildWallsCache();
    PlannerGlobals.svg.style("cursor", "pointer");
    modeChanged('measurePrepare');
    $('#plannerSVG').attr('data-mode', PlannerGlobals.mode);
  },
  'measureMe': function (id) {
    if (!PlannerGlobals.measureSuccess && measureHelper.sourceType != "manual") {
      toastRemoveAll();
      toastInfo(ts('p_measure_me_help', "Select a target for your measurement, like a <b>Wall</b>, a <b>Device</b> or a <b>Frame</b>."));
    }
    if (!PlannerGlobals.measurements_on) {
      toggleMeasurements();
    }
    disablePlannerButtonsExcept(['#measure-distance-btn', '#zen-mode-btn', '#planner-sizers']);
    measureHelper.rebuildCaches();
    modeChanged('measureMe');

    $('#plannerSVG').attr('data-mode', PlannerGlobals.mode);
  },
  'rotateMe': function (gElem) {
    if (PlannerGlobals.sizeErrorHelper.errorCorrectMode) {
      return;
    }
    CleanupAll();
    unHighlight();
    $('#rotate-tool').off('mouseout');
    if (PlannerGlobals.rotateMeTimeout) {
      clearTimeout(PlannerGlobals.rotateMeTimeout);
    }
    PlannerGlobals.rotateMeTool = $('#rotate-tool');
    PlannerGlobals.rotateMeToolTransform = PlannerGlobals.rotateMeTool.attr('transform');
    PlannerGlobals.outOfRoomAlertShown = false;
    rotateMeSource = gElem;
    /* rotateMeDevCenter = null; */
    var d3GElem = d3.select(rotateMeSource);
    var d3Data = d3GElem.datum();
    if (d3Data.connId) {
      d3GElem = d3.select(rotateMeSource.parentNode);
    }

    if (d3Data.id) { //serial
      var firstDev = d3Data.devices[0];
      rotateMeStartXY = [
        firstDev.x + getFrameWidth(d3Data.devices.length) / 2,
        firstDev.y + PlannerGlobals.DEVICE_SIZE / 2
      ];
      if (!("angle" in d3Data && d3Data.angle)) {
        d3Data.angle = 0;
        firstDev.angle = 0;
      }
      rotateMeDevOrigiAngle = d3Data.angle;
    }
    else if (d3Data.connId) { // serial conn
      var firstDev = d3Data.devices[0];
      rotateMeStartXY = [
        firstDev.x + (PlannerGlobals.DEVICE_SIZE + SERIAL_SPACING) * getDColsNum(d3Data) / 2 - SERIAL_SPACING / 2,
        firstDev.y + (PlannerGlobals.DEVICE_SIZE + SERIAL_SPACING) * getDRowsNum(d3Data) / 2 - SERIAL_SPACING / 2
      ];
      if (!("angle" in d3Data && d3Data.angle)) {
        d3Data.angle = 0;
        firstDev.angle = 0;
      }
      rotateMeDevOrigiAngle = d3Data.angle;
    }
    else { //dev
      var dev = d3Data.devices[0];
      rotateMeStartXY = [dev.x + PlannerGlobals.DEVICE_SIZE / 2, dev.y + PlannerGlobals.DEVICE_SIZE / 2];
      if (!("angle" in dev && dev.angle)) {
        dev.angle = 0;
      }
      rotateMeDevOrigiAngle = dev.angle;
    }

    const sizes = getToolSize();


    const circleCenter = {
      x: (PlannerGlobals.DEVICE_SIZE + SERIAL_SPACING) * getDColsNum(d3Data) / 2 - SERIAL_SPACING / 2,
      y: PlannerGlobals.DEVICE_SIZE / 2
    }

    const touchPt = uMath.pointAtAngleDistance(circleCenter, -90, (sizes.size + sizes.padding) + PlannerGlobals.DEVICE_SIZE / 10);
    d3GElem.append('circle')
      .attr('cx', touchPt.x)
      .attr('cy', touchPt.y)
      .attr('r', (sizes.size + sizes.padding) / 2)
      .attr('fill', 'white')
      .attr('stroke', 'gray')
      .attr('stroke-width', 0)
      .attr('class', 'rotate-helper')
      .style('filter', 'drop-shadow(0px 0px 2px rgba(0, 0, 0, .40))');

    d3GElem.append("svg:image")
    .attr("x", touchPt.x - sizes.size / 2)
    .attr("y", touchPt.y - sizes.size / 2)
    .attr("width", sizes.size)
    .attr("height", sizes.size)
    .attr("xlink:href", `${getFrontendURL()}/images/planner_tools/rotate.svg`)
    .attr("class", "rotate-helper");

    var currxy = getXY();
    rotateMeStartMousePt = getXYP();
    var xy = [currxy[0] - rotateMeStartXY[0], currxy[1] - rotateMeStartXY[1]];
    rotateMeStartAngle = (180 / Math.PI * Math.atan2(xy[1], xy[0]));
    d3.select('#motionsensors').remove();
    var radiiElem = PlannerGlobals.container.append("g").attr('class', 'motionsensors').attr('id', 'motionsensors');
    modeChanged('rotateMe');

    /* if (!MODKEYS_STATE.shift && isCamera(d3Data.devices[0])) {
            toastInfoSingle(ts("p_cam_shift", "By holding Shift, the camera can be rotated to any angle."));
        }*/

    $('#plannerSVG').attr('data-mode', PlannerGlobals.mode);
  },
  /**
   * the mode that shows all of the devices' important comments at once, and also the numberings of the items
   */
  'showImportants': function () {
    CleanupAll();
    $('#toggle-importants-btn').addClass('pressed');
    modeChanged('showImportants');

    drawDevSymbols();
    //showImportants();
    $('#plannerSVG').attr('data-mode', PlannerGlobals.mode);
  },
  'wallSelect': function () {
    var busyReason = isPlannerBusy();
    if (busyReason) {
      toastInfo(busyReason);
      return false;
    }
    CleanupAll();
    $('#toggle-wallselect-btn').addClass('pressed');
    $('#modify-bg-btn').css("display", "none");
    PlannerGlobals.wallSelectStartPos = null;
    PlannerGlobals.wallSelectEndPos = null;
    if (!PlannerGlobals.serverConfirmedRatioPoints || !objValid(PlannerGlobals.serverConfirmedRatioPoints)) {
      //lastRatioPoints = null;
      // ha nincs beállítva, beállítunk egyet a kezdő inicializáláshoz
      PlannerGlobals.lastRatioPoints = {
        x1 : 183.42384338379,
        x2 : 524.43113438076,
        y1 : -56.08435821533,
        y2 : -56.7654105646,
      };
    }
    if (PlannerGlobals.lastRatioPoints && objValid(PlannerGlobals.lastRatioPoints)) { setMode.wallSelectModify(); return; }
    PlannerGlobals.svg.style('cursor', 'crosshair');

    zenModeOn();
    disablePlannerButtonsExcept(['#toggle-wallselect-btn', '#zen-mode-btn', '#planner-sizers']);

    modeChanged('wallSelect');

    $('#plannerSVG').attr('data-mode', PlannerGlobals.mode);
  },
  'wallSelectModify': function () {
    var busyReason = isPlannerBusy();
    if (busyReason) {
      toastInfo(busyReason);
      return false;
    }
    PlannerGlobals.wallInput.attr('class', '');
    PlannerGlobals.wallSelectStartPos = [PlannerGlobals.lastRatioPoints.x1, PlannerGlobals.lastRatioPoints.y1];
    PlannerGlobals.wallSelectEndPos = [PlannerGlobals.lastRatioPoints.x2, PlannerGlobals.lastRatioPoints.y2];
    var centerPt = [(PlannerGlobals.wallSelectEndPos[0] + PlannerGlobals.wallSelectStartPos[0]) / 2, (PlannerGlobals.wallSelectEndPos[1] + PlannerGlobals.wallSelectStartPos[1]) / 2];
    var diffX = Math.abs(PlannerGlobals.wallSelectEndPos[0] - PlannerGlobals.wallSelectStartPos[0]);
    var diffY = Math.abs(PlannerGlobals.wallSelectEndPos[1] - PlannerGlobals.wallSelectStartPos[1]);
    var vbWidth = +getViewBox().split(" ")[2] || 900;
    var vbHeight = +getViewBox().split(" ")[3] || 900;
    var scaleX = vbWidth / diffX;
    var scaleY = vbHeight / diffY;
    var smallerScale = Math.min(scaleX, scaleY);
    var nuScale = uMath.clamp(smallerScale * 0.85, 1, 5);
    highlightPoint(centerPt[0], centerPt[1], nuScale);
    /* highlightPoint(450, 450, 1); */
    setupWallSelectModify();

    zenModeOn();
    disablePlannerButtonsExcept(['#toggle-wallselect-btn', '#zen-mode-btn', '#planner-sizers']);

    modeChanged('wallSelectModify');

    $('#plannerSVG').attr('data-mode', PlannerGlobals.mode);
  },
  'doorSelect': function () {
    var busyReason = isPlannerBusy();
    if (busyReason) {
      toastInfo(busyReason);
      return false;
    }
    if (!PlannerGlobals.LENGTHOF1PX) {
      toastRemoveAll();
      return toastInfo(ts('p_wd_doornoprops', "You cannot select doors without setting up the background's proportions. <b>(Hotkey: 2)</b>").replace('2', '1'));
    }

    CleanupAll();
    disablePlannerButtonsExcept(['#toggle-doorselect-btn', '#zen-mode-btn', '#planner-sizers']);
    $('#toggle-doorselect-btn').addClass('pressed');
    setMode.entitySelect('door');
    $('#plannerSVG').attr('data-mode', PlannerGlobals.mode);

    // if (newTour.isOngoing() && newTour.currStepId === "draw_doors" && newTour.sampleRoomExists() && !newTour.sampleDoorExists()) {
    //     newTour.addMustClickCircleSeries(newTour.getDoorSteps());
    // }
  },
  'windowSelect': function () {
    var busyReason = isPlannerBusy();
    if (busyReason) {
      toastInfo(busyReason);
      return false;
    }
    if (!PlannerGlobals.LENGTHOF1PX) {
      toastRemoveAll();
      return toastInfo(ts('p_wd_winnoprops', "You cannot select windows without setting up the background's proportions. <b>(Hotkey: 2)</b>").replace('2', '1'));
    }
    CleanupAll();
    disablePlannerButtonsExcept(['#toggle-windowselect-btn', '#zen-mode-btn', '#planner-sizers']);

    $('#toggle-windowselect-btn').addClass('pressed');
    setMode.entitySelect('window');
    $('#plannerSVG').attr('data-mode', PlannerGlobals.mode);
  },
  'entitySelect': function (type) {
    rebuildWallsCache();
    PlannerGlobals.entitySelectType = type;
    PlannerGlobals.entitySelectStartPos = null;
    PlannerGlobals.entitySelectEndPos = null;
    modeChanged('entitySelect');

    PlannerGlobals.svg.style('cursor', 'crosshair');
    if (!couldSelectEntity()) {
      toastRemoveAll();
      toastInfo(ts('p_wd_begin', "In this mode, you can select windows and doors by <b>dragging your mouse</b> on a part of a <b>wall</b>."));
    }
    entitySelectUpdate();
    $('#plannerSVG').attr('data-mode', PlannerGlobals.mode);
  },
  'editPicture': function () {
    CleanupAll();
    modeChanged('editPicture');

    $('#reset-center-btn').click();
    $('#containerSVG').addClass('edit-picture');

    $(".planner-buttons-cont").addClass('hidden');
    $('#planner-buttons-crop').removeClass('hidden');

    $('#toggle-prepareSelect-btn').addClass('pressed');
    $('.planner-floor-manip').addClass('hidden');

    PlannerGlobals.svg.attr('viewBox', "0 0 900 900");

    PlannerGlobals.editPictureHelper.insertPicture();
    $('#plannerSVG').attr('data-mode', PlannerGlobals.mode);
  },
  'showBuildingMats': function () {
    CleanupAll();

    if (!PlannerGlobals.rooms.length) {
      return toastErrorSingle(ts("p_ceilmat_norooms_err", "There are no rooms yet"), false, 'no-rooms-yet');
    }

    const allPolies = PlannerGlobals.wallSegmentation.calculatedPolygons
    /* .filter(poly => poly.id.indexOf('ceiling_') === 0) */
    .filter(poly => poly.pts.length >= 3);

    if (!allPolies.length) {
      return toastErrorSingle(ts("p_ceilmat_nomats_err", "Please set the materials of the floor <b>(Hotkey: 6)</b>"), false, 'set-mats-pls');
    }

    modeChanged('showBuildingMats');


    redrawRooms();

    d3.selectAll('#devicesMain, #grouppaths, #measurements, #notes, .doorOrWindowContainer').style('opacity', 0.1);
    const polyCont = PlannerGlobals.container.insert('g', '.polygontexts').attr('id', 'build-mat-poly-cont');

    allPolies.forEach(poly => {
      polyCont.append('polygon')
        .attr('class', 'build-mat-poly')
        .attr('points', poly.pts.map(pt => pt[0] + "," + pt[1]).join(' '))
        .style('fill', poly.material.fillColor)
        .style('fill-opacity', 0.85)
        .style('stroke', 'black')
        .style('stroke-width', 0.6);
    });


    toolbarSwitchSet("building-mat-display", "on");
  }
};

export function couldSelectEntity() {
  return PlannerGlobals.entitySelectHadSuccess || PlannerGlobals.wallModConnections.length > 0;
}

//rotateme
let rotateMeSource;
let rotateMeStartXY;
let rotateMeStartMousePt;
let rotateMeStartAngle;
let rotateMeDevOrigiAngle;
let rotateMeDevCenter;

//variables for translating the chat window
let chatMomentSVGTranslate = null;
let chatRelDevice = null;
let chatRelDeviceTransform = null;
let chatContainer = null;
/**
 * contains the amount the user can move the plan
 */
const panExtent = {
  horizontal: 100,
  vertical: 230,
};

let origiPoly;
let selectedRoomDevices;

export function showCurrLeftouts() {
  //checking for left out devices of currently modified room
  unHighlight();

  if (!PlannerGlobals.modifiedRoom || !PlannerGlobals.modifiedRoom.id) { return; }

  var leftout = leftOutDevicesV2();
  if (leftout.length != 0) {
    if (!PlannerGlobals.leftoutAlertShown) {
      toastInfoSingle(ts('p_ow_intersect_d_err', "Walls can't intersect devices"), false, 'left-out-warning');
      PlannerGlobals.lleftoutAlertShown = true;
    }
    var fillColor = 'rgba(255, 0, 0, 0.35)';
    var strokeColor = 'rgba(150, 0, 0, 0.85)';
    const serHighlighted = {};
    for (var left of leftout) {
      var ser = getSerialOfDeviceId(left.deviceId);
      if (ser) {
        if (!serHighlighted[ser.id]) {
          serHighlighted[ser.id] = true;
          highlightSerial(ser.id, fillColor, strokeColor, true);
        }
      }
      else {
        highlightDeviceNoZoom(left.deviceId, null, fillColor, strokeColor, true, true);
      }
    }
  }
  /* else {
        leftoutAlertShown = false;
        toastRemoveClass('left-out-warning');
    } */
}

export function modifyWallStartPoint(elem) {
  if (!PlannerGlobals.modifiedPoly || !elem) {
    return false;
  }

  var elemIdx = PlannerGlobals.modifiedPoly.findIndex(function (pt) {
    return pt == elem;
  });
  var otherIdx;
  otherIdx = (elemIdx + PlannerGlobals.modifiedPoly.length - 1) % PlannerGlobals.modifiedPoly.length;

  return PlannerGlobals.modifiedPoly[otherIdx];
}

export function modifyWallOtherPoint(elem) {
  if (!PlannerGlobals.modifiedPoly || !elem) {
    return false;
  }
  var elemIdx = PlannerGlobals.modifiedPoly.findIndex(function (pt) {
    return pt == elem;
  });
  var otherIdx = (elemIdx + 1) % PlannerGlobals.modifiedPoly.length;
  return PlannerGlobals.modifiedPoly[otherIdx];
}

export function changeWall(d) {
  var walls = modifyWallsOfRoom();
  var idx = walls.findIndex(function (wall) {
    return wall.id == d.id;
  });
  var prevIdx = idx - 1;
  if (prevIdx == -1) {
    prevIdx = walls.length - 1;
  }
  if (!walls[idx] || !walls[prevIdx]) {
    return;
  }
  PlannerGlobals.changedWalls[walls[idx].id + ""] = true;
  PlannerGlobals.changedWalls[walls[prevIdx].id + ""] = true;
}

export function setupWallSelectModify() {
  // console.log('test');
  redrawWallSelectLine();

  let lineLenPx = Math.sqrt(Math.pow(PlannerGlobals.wallSelectEndPos[0] - PlannerGlobals.wallSelectStartPos[0], 2) + Math.pow(PlannerGlobals.wallSelectEndPos[1] - PlannerGlobals.wallSelectStartPos[1], 2));
  let writtenLineLen = lineLenPx * PlannerGlobals.LENGTHOF1PX;
  let minLineLen = MEASURE_DEFAULT_MIN_CM;
  let maxLineLen = MEASURE_DEFAULT_MAX_CM;
  if (isPlannerImperial()) {
    writtenLineLen = cmToInch(writtenLineLen);
    minLineLen = MEASURE_DEFAULT_MIN_IN;
    maxLineLen = MEASURE_DEFAULT_MAX_IN;
  }

  $('#wallSelectCenterInput input').val(uMath.clamp(Math.round(writtenLineLen), minLineLen, maxLineLen));
  setTimeout(function () {
    $('#wallSelectCenterInput input').trigger('select');
  });

  PlannerGlobals.wallSelectModData = [
    {
      type: 'start',
      t: [0, 0],
      pos: [PlannerGlobals.wallSelectStartPos[0], PlannerGlobals.wallSelectStartPos[1]]
    },
    {
      type: 'end',
      t: [0, 0],
      pos: [PlannerGlobals.wallSelectEndPos[0], PlannerGlobals.wallSelectEndPos[1]]
    },
  ]

  // if (newTour.isOngoing() && newTour.currStepId === 'set_scale') { return; }

  PlannerGlobals.container.append('g')
    .attr('class', 'wallSelectModifyCircles')
    .selectAll('circle').data(PlannerGlobals.wallSelectModData).enter()
    .append('circle')
    .attr('class', 'wallSelectModifyCircle')
    .attr('cx', function (d) { return +d.pos[0]; })
    .attr('cy', function (d) { return +d.pos[1]; })
    .attr('r', 3)
    .attr('fill', '#fff')
    .attr('stroke', '#000')
    .attr('stroke-width', 0.2)
    .style('cursor', 'ew-resize')
    .call(PlannerGlobals.dragWallSelectLine);
}

export function correctPos(draggedPos, placedPos) {
  var draggedPosXY = P_numtoxy(draggedPos);
  var placedPosXY = P_numtoxy(placedPos);
  if (uMath.pointDistance(draggedPosXY, placedPosXY) < MEASURE_LINE_MIN_PXLEN) {
    var angle = uMath.angleOfPoints(placedPosXY, draggedPosXY);
    var ptAtDist = uMath.pointAtAngleDistance(placedPosXY, angle, MEASURE_LINE_MIN_PXLEN + 1);
    draggedPos[0] = ptAtDist.x;
    draggedPos[1] = ptAtDist.y;
  }
}
const CANT_AUTOPAN_REASONS = {
  'WALLSELECTLINE_ACTIVE_BUT_NOT_DRAGGING': function () { return !PlannerGlobals.draggingRoomCircle && PlannerGlobals.mode === 'wallSelectModify'; },
  'GUIDE_IS_ACTIVE': function () { return false; },
  'NOT_DRAGGING_ANYTHING_IN_BASIC': function () { return PlannerGlobals.mode === 'basic' && !(PlannerGlobals.isDragging || ControllerGlobals.currentlyDraggedDevice); },
  'WIZARD_MODE_IS_ACTIVE': function () { return PlannerGlobals.mode === 'wizard'; },
  'PICTURE_MODE_IS_ACTIVE': function () { return PlannerGlobals.mode === 'editPicture'; },
  'BUILDINGMAT_MODE_IS_ACTIVE': function () { return PlannerGlobals.mode === 'showBuildingMats'; },
  'WIFI_MODE_IS_ACTIVE': function () { return PlannerGlobals.mode === 'wificalc'; },
  'MODIFYING_ROOM_OR_OUTERWALL': function () { return (PlannerGlobals.mode === "selectRoom" || PlannerGlobals.mode === "modifyOuterW"); },
  'WALL_SEGMENT_MODE_ACTIVE': function () { return PlannerGlobals.mode === 'wallSegmentation' && !PlannerGlobals.wallSegmentation.isMouseDown; },
  'MOUSE_IS_OUT_OF_WINDOW': function () { return !isMouseInsideWindow; },
  'MIDDLE_MOUSE_IS_PRESSED': function () { return MIDBTNPRESSED; },
  'MODAL_IS_ACTIVE': function () { return $('body > .modal').hasClass('in'); },
  'SWAL_IS_ACTIVE': function () { return !!$('body > .showSweetAlert').length; },
  'NOT_DRAGGING_WITH_LEFT_MOUSE': function () { return LEFTBTNPRESSED && !(PlannerGlobals.draggingRoomCircle || PlannerGlobals.mode === 'groupMe' || PlannerGlobals.mode === 'measureMe' || PlannerGlobals.isDragging || ControllerGlobals.currentlyDraggedDevice || PlannerGlobals.entitySelectStartPos || PlannerGlobals.wallSegmentation.isMouseDown); },
  'NEED_TO_EXIT_TOOLBAR_FIRST': function () { return !!$('#svgAndChat .havent-exited').length; },
}

export function cantAutoPan() {
  for (var i in CANT_AUTOPAN_REASONS) {
    if (CANT_AUTOPAN_REASONS[i]()) {
      return true;
    }
  }
  return false;
}

export function panForDrawingDirection(threshold = 70, multiplier = 18) {
  var direction = { x: 0, y: 0 };
  var $elem = $("#plannerSVG");
  var pageXY = PAGEXY;
  if (!$elem.length || !pageXY || cantAutoPan(pageXY, $elem)) {
    return { x: 0, y: 0 };
  }
  var offset = $elem.offset();
  var height = $elem.height();
  var width = $elem.width();
  var x = pageXY.x - offset.left;
  var y = pageXY.y - offset.top;
  var xRight = -x + width;
  var yBottom = -y + height;

  var outerThresholdTopBot = -threshold * 0.6;
  var innerThresholdTopBot = threshold * 0.4;

  var outerThresholdLeftRight = -threshold * 0.6;
  var innerThresholdLeftRight = threshold * 0.4;

  var isTop = y > outerThresholdTopBot && y <= innerThresholdTopBot && x > outerThresholdTopBot && xRight > outerThresholdTopBot;
  var isBottom = yBottom > outerThresholdTopBot && yBottom <= innerThresholdTopBot && x > outerThresholdTopBot && xRight > outerThresholdTopBot;

  var isLeft = x > outerThresholdLeftRight && x <= innerThresholdLeftRight && y > outerThresholdLeftRight && yBottom > outerThresholdLeftRight;
  var isRight = xRight > outerThresholdLeftRight && xRight <= innerThresholdLeftRight && y > outerThresholdLeftRight && yBottom > outerThresholdLeftRight;

  if (isLeft) {
    direction.x -= multiplier;
  }

  if (isRight) {
    direction.x += multiplier;
  }

  if (isTop) {
    direction.y -= multiplier;
  }

  if (isBottom) {
    direction.y += multiplier;
  }

  return direction;
}

export function initScaleLineInput() {
  let minMeasureVal = MEASURE_DEFAULT_MIN_CM;
  let maxMeasureVal = MEASURE_DEFAULT_MAX_CM;
  let measureUnit = "cm";
  let step = 10;

  if (isPlannerImperial()) {
    minMeasureVal = MEASURE_DEFAULT_MIN_IN;
    maxMeasureVal = MEASURE_DEFAULT_MAX_IN;
    measureUnit = 'in';
    step = 1;
  }

  PlannerGlobals.wallInput = d3.select("#svgAndChat").append('div')
  .attr('id', 'wallSelectCenterInput')
  .attr('class', 'wallInputHidden');

  PlannerGlobals.wallInput.append('div')
  .attr('class', 'wallSelectTitle')
  .text(ts('set_reference_length', 'Set Reference Length'));

  PlannerGlobals.wallInput.append('div').attr('class', 'wallSelectDivider');

  const wallInputRow = PlannerGlobals.wallInput.append('div').attr('class', 'wallSelectInputRow');

  const wallInputField = wallInputRow.append('div').attr('class', 'wallSelectField');
  wallInputField.append('label').attr('class', 'wallSelectFieldLabel').text(ts('length', 'Length'));
  wallInputField.append('input')
  .attr('type', 'number')
  .attr('min', minMeasureVal)
  .attr('max', maxMeasureVal)
  .attr('step', step)
  .attr('value', minMeasureVal);
  wallInputField.append('span').attr('class', 'wallSelectFieldUnit').text(measureUnit);

  wallInputRow.append('div')
  .attr('class', 'wallSelectCheck')
  .text(ts('p_wifi_ok', 'OK'));

  $('#wallSelectCenterInput input').val(minMeasureVal);
  $('#wallSelectCenterInput input').on('keyup', function (e) {
    e.stopImmediatePropagation();
    if (e.key == 'Enter') {
      wallSelectEnd();
    } else if (e.key == 'Escape') {
      zenModeOff();
      setMode.basic();
    }
  });

  $('.wallSelectCheck').on('click', function () {
    wallSelectEnd();
  });

  const svgDefs = PlannerGlobals.svg.append("defs");

  const grad = svgDefs
    .append('linearGradient')
    .attr('id', "MergeConnectGradient");

  const colors = [
    { offset: 5, color: 'rgb(0, 220, 44)' },
    { offset: 95, color: '#2196f36e' }
  ];

  colors.forEach(color => {
    grad
      .append('stop')
      .attr('offset', color.offset + "%")
      .attr('stop-color', color.color);
  });
}
/**
 * return correct viewbox for currently displayed image #floor_bg
 */
export function getViewBox() {
  var horizontal = 0;
  var vertical = 0;

  var horizTrans = 0;
  var verticTrans = 0;

  var src_image = document.getElementById('floor_bg');

  var src_width = 900;
  var src_height = 900;

  if (src_image) {
    src_width = src_image.naturalWidth; // horizontal
    src_height = src_image.naturalHeight; // vertical
  }

  if (src_height > src_width) {
    horizontal = 900 * src_width / src_height;
    vertical = 900;
    horizTrans = (vertical - horizontal) / 2;
  } else if (src_width > src_height) {
    horizontal = 900;
    vertical = 900 * src_height / src_width;
    verticTrans = (horizontal - vertical) / 2;
  } else {
    horizontal = 900;
    vertical = 900;
  }

  return horizTrans + ' ' + verticTrans + ' ' + horizontal + ' ' + vertical;
}

export function getViewBoxElem(elem) {
  var horizontal = 0;
  var vertical = 0;

  var horizTrans = 0;
  var verticTrans = 0;

  var src_image = $(elem)[0];

  var src_width = 900;
  var src_height = 900;

  if (src_image) {
    src_width = src_image.naturalWidth; // horizontal
    src_height = src_image.naturalHeight; // vertical
  }

  if (src_height > src_width) {
    horizontal = 900 * src_width / src_height;
    vertical = 900;
    horizTrans = (vertical - horizontal) / 2;
  } else if (src_width > src_height) {
    horizontal = 900;
    vertical = 900 * src_height / src_width;
    verticTrans = (horizontal - vertical) / 2;
  } else {
    horizontal = 900;
    vertical = 900;
  }

  return horizTrans + ' ' + verticTrans + ' ' + horizontal + ' ' + vertical;
}


/**
 * Removing a group by its ID
 *
 * @param {any} gid The group ID
 */
export function removeGroup(gid) {
  var idx = PlannerGlobals.groups.findIndex(function (group) {
    return group.id == gid;
  });
  if (idx != -1) {
    PlannerGlobals.groups.splice(idx, 1);
  }
  redrawGroups();
}


/**
 * Removes a device from its group remotely, and if it's successful, locally too
 *
 * @param {any} deviceId The device's ID
 */
export function removeDeviceFromGroup(deviceId, callback, errorCallback) {
  getAuthHeader(function (header) {
    $.ajax({
      headers: header,
      url: ROOT_URI + '/device/group-device',
      type: 'DELETE',
      dataType: 'JSON',
      data: {
        plan_object_id: deviceId
      },
      success: function (response) {
        removeDeviceFromGroupsLocal(deviceId);
        recalcSwitchPNIDs();

        if (typeof callback === "function") {
          callback();
        }
      },
      error: function (response) {
        if (response.responseJSON && response.responseJSON.message) {
          toastError(response.responseJSON.message);
        }
        if (typeof errorCallback === "function") {
          errorCallback();
        }
      }
    });
  });
}

/**
 * Removes a device from its group locally. Should not be used by itself, instead only called by its remote variant
 *
 * @param {any} deviceId The device's ID
 */
export function removeDeviceFromGroupsLocal(deviceId) {
  var devGroups = getGroupsOfDevice(deviceId);
  devGroups.forEach(function (devGroup) {
    var idx = devGroup.deviceIds.findIndex(function (deviceIdCurr) {
      return deviceIdCurr == deviceId;
    });
    if (idx != -1) {
      devGroup.deviceIds.splice(idx, 1);
      if (devGroup.deviceIds.length < 2) {
        removeGroup(devGroup.id);
      }
    }
  });
  if (!UDevGlobals.devIsChangingToObj[deviceId]) {
    redrawGroups();
  }
}

export function removeDeviceFromCacheLocal(device) {
  ['deviceId', 'fakeDeviceId', 'initialFakeDeviceId'].forEach(prop => {
    if (device[prop]) {
      delete UDevGlobals.cachedDevices['id_' + device[prop]];
    }
  });
}

export function sendDevRecursive(fakeSerial, defs, products, idx) {
  if (idx < products.length) {
    var product = products[idx];

    var noteToAddAfter = null;
    if (product.note_message) {
      noteToAddAfter = product.note_message;
    }

    var sendData = {
      x: product.x,
      y: product.y,
      room_id: product.roomId,
      product_name_id: product.product_name_id,
      device_alone: (idx == 0) ? 1 : 0
    };
    /* if (sendData.room_id == uDev.OUTDOORS_ROOM_ID && rooms.length > 0) {
            sendData.room_id = rooms[0].id;
        } */

    function continueCB() {
      requestAnimationFrame(function () {
        redrawSerial(fakeSerial.id);
        /* redrawDevices(); */
        sendDevRecursive(fakeSerial, defs, products, idx + 1);
        defs[idx].resolve();
      });
    }

    function continueErrorCB(resp) {
      product.errored = true;
      sendDevRecursive(fakeSerial, defs, products, idx + 1);
      genericXHRErrorHandler(resp);
      defs[idx].resolve();
    }

    getAuthHeader(function (header) {
      $.ajax({
        headers: header,
        type: 'POST',
        url: ROOT_URI + '/device',
        dataType: 'JSON',
        data: sendData,
        success: function (response) {
          var realDevId = parseInt(response.id);
          fakeSerial.deviceIds[idx] = realDevId;
          product.deviceId = realDevId;
          product.ghost = false;
          product.symbol_id = response.symbol_id;
          if (response.note_message) {
            product.noteId = response.default_note_id;
            product.noteTxt = response.note_message;
            product.noteColor = "#fffcc9";
            product.hasNote = true;
            if (product.prevent_note) {
              deleteDevNote(product);
              product.noteId = null;
              product.noteTxt = null;
              product.hasNote = false;
            }
          }

          if (!product.prevent_note) {
            if (noteToAddAfter && !product.noteTxt) {
              var strId = product.deviceId + "";
              var type = strId.indexOf('C_') === 0 ? 3 : 2;
              sendDevNote(type, "#fffcc9", noteToAddAfter, strId, product);
            }
            else if (noteToAddAfter && product.noteTxt && noteToAddAfter != product.noteTxt) {
              modDevNote(product, "#fffcc9", noteToAddAfter);
            }
          }

          if ('new_serial_id' in response) {
            fakeSerial.id = response.new_serial_id;
            ajaxSetSerialProps(fakeSerial);
          }

          if ('angle' in product && product.angle !== 0) {
            updateDevRotationAjax(product.deviceId, product.angle, continueCB, continueErrorCB);
          } else {
            continueCB();
          }
          showDragAndDropOverlay();

        },
        error: continueErrorCB
      });
    });
  }
}

export function placeFree(x, y) {
  var devs = getDevicesD3Style();
  var findIdx = devs.findIndex(function (device) {
    return device.x == x && device.y == y;
  });
  return findIdx == -1;
}

//Keywords: delete floor, floor delete, remove floor
/**
 * Deletes the currently displayed floor
 */
export function deleteFloor() {
  $('.sweet-alert').remove();
  var currId = PlannerGlobals.plannerFloorId;
  var delSwal = swal({
    title: ts('warning', 'warning'),
    text: ts('type_delete_please_floor', 'typeDeletePleaseFloor'),
    //type: "input",
    showCancelButton: true,
    closeOnConfirm: true,
    animation: "slide-from-top",
    inputPlaceholder: "",
    customClass: {
      confirmButton: 'delete-confirm-button-class',
      cancelButton: 'delete-cancel-button-class',
    },
  }, function (inputValue) {
    if (inputValue === false) return false;
    //success
    var $url = ROOT_URI + '/floor';

    getAuthHeader(function (header) {
      $.ajax({
        dataType: 'JSON',
        method: 'DELETE',
        url: $url,
        headers: header,
        data: {
          floor_id: currId
        },
        success: function (response) {
          if (PlannerGlobals.plannerFloorId == currId) {
            MC.fadeOut(FADE_LENGTH, function () {
              MC.html("");
            });
          }
          if (response.message) {
            toastSuccess(response.message);
          }
          //refreshProjectsFromServer();
          refreshFloorView();

          if (PlannerGlobals.PLANNER_ZEN_MODE) {
            zenModeOff();
          }

        },
        error: function (response) {
          if (response.responseJSON && response.responseJSON.message) {
            toastError(response.responseJSON.message);
          }
        }
      });
      swal.close();
      return true;
    });
  });
}


/**
 * Transforms a string in the form of 'translate(X,Y)' to an array
 *
 * @param {string} string Input string
 * @returns {number[]}
 */
export function transformStringToXY(string) {
  return string.toString().replace("translate(", "").replace(")", "").split(',').map(function (x) {
    return parseFloat(x)
  });
}

/**
 *
 * @param {number} roomId
 * @returns {boolean}
 */
export function roomIdIsWet(roomId) {
  var room = getRoomById(roomId);
  if (!room) {
    return null;
  }
  var roomIsOutside = uDev.outerBorderExists() && isRoomOutside(room, PlannerGlobals.outerBorder);
  return roomIsOutside || room.room_type_id == 7 || room.room_type_id == 8;
}


export function hideRotateAndDeviceTools() {
  hideTools();
  $('#rotate-tool').hide();
}

export function hideTools() {
  $('.device-tool-tooltip').remove();
  PlannerGlobals.svg.selectAll('.device-tool, .note-tool, .wall-tool').remove();
  if (PlannerGlobals.hideRedXTimeout) {
    clearTimeout(PlannerGlobals.hideRedXTimeout);
  }
  if (PlannerGlobals.wallToolTimeout) {
    clearTimeout(PlannerGlobals.wallToolTimeout);
  }
}

/**
 *
 * @param {*} d
 * @returns {Point}
 */
export function getCenterOfD(d) {
  if (d.id) {
    return getSerialCenterPos2(getSerialById(d.id));
  }
  else if (d.connId) {
    return P_numtoxy(getSerialConnCenterPos(d));
  }
  else {
    return P_numtoxy(getDevicePositionCenter(d.devices[0]));
  }
}

export function handleLongPress(deviceId) {
  var dev = getDeviceById(deviceId);
  if (!dev) {
    return;
  }

  if (isDevCabinet(dev)) {
    return;
  }

  if (dev.dragTestInProgress && !('nopermission' in dev)) {
    // prevent open?
    console.log('shouldnt have clicked');
  }

  if (dev.nopermission) {
    return;
  }

  _plannerCallbacks.onBulkDeleteDevice?.(deviceId);
}

export function showDelConfirm(deviceId, type) {
  var devicesElem = $('#devicesMain');
  var containerElem = $('#containerSVG');
  genericAlertSwal(ts2("p_alldel_confirm", "Confirm deleting plan object by clicking OK button below."),
      function () {
        devicesElem.css('pointer-events', 'none');
        containerElem.css('opacity', 0.6);
        removeDevAllOccurrences(deviceId, type === "room", function (deletedDevs, groups, measures, serConns) {
          var action = new DeleteMultipleDevicesAction(deletedDevs, groups, measures, serConns);
          PlannerGlobals.plannerHistoryManager.addHistoryEntry(action);
          devicesElem.css('pointer-events', '');
          containerElem.css('opacity', '');
        });
      }, true);
}

let newGroupId = 100;
let newGroupConnections = [];

function resolveDeviceTreeKey(elem) {
  var elemData = d3.select(elem).data()[0];
  var product_name_id = elemData.product_name_id;

  if (isNaN(product_name_id)) {
    if (elemData.type == "electrical cabinet") return "electrical_cabinet";
    if (elemData.type == "rack cabinet") return "rack_cabinet";
    if ("user_custom_item_id" in elemData) return "user_custom_item_" + elemData.user_custom_item_id;
    return null;
  }
  return String(product_name_id);
}

function buildSelectDevicePayload(elem) {
  const elemData = d3.select(elem).data()[0];
  const productNameId = resolveDeviceTreeKey(elem);
  if (productNameId == null) return null;
  return {
    productNameId: productNameId,
    productId: isNaN(elemData.product_id) ? null : Number(elemData.product_id),
    roomId: isNaN(elemData.roomId) ? null : Number(elemData.roomId),
  };
}

export function showDevOnLeft(elem) {
  const payload = buildSelectDevicePayload(elem);
  if (payload != null) {
    _plannerCallbacks.onSelectDevice?.(payload);
  }
}

export function deviceOnClick(e) {
  if (PlannerGlobals.mode == 'prepareGrouping' || PlannerGlobals.mode == 'grouping') {
    if (PlannerGlobals.mode == 'prepareGrouping') {
      setMode.grouping();
    }

    var deviceId;
    var notContains;

    deviceId = d3.select(this).attr('data-deviceId');

    notContains = newGroupConnections.findIndex(function (connection) {
      return connection.deviceId == deviceId;
    }) == -1 && !getGroupOfDevice(deviceId);

    if (notContains) {
      newGroupConnections.push(deviceId);
    }

  } else if (PlannerGlobals.mode == 'commenting') {
    // TODO: moveplannercode - chat.js
    // showComments(this);
  } else if (!ControllerGlobals.currentlyDraggedDevice && (PlannerGlobals.mode == 'basic' || PlannerGlobals.mode == 'prepareSelect')) {
    if (hasPermissionForFuncInRole("planner_sect.select_dev", PlannerGlobals.userRoleInProject)) {
      showDevOnLeft(this);
      var devId = d3.select(this).attr('data-deviceId')
      var ser = getSerialOfDeviceId(devId);
      if (ser) {
        highlightSerial(ser.id, undefined, undefined, undefined, devId);
      }
      else {
        highlightDeviceNoZoom(devId);
      }
      e.stopPropagation();
    }
  }
}

export function deviceOnMouseEnter(e) {
  if (PlannerGlobals.mode == 'basic' && !PlannerGlobals.isDragging) {
    var elem = this;
    showTools(elem);
  }
}

export function rotatableOnMouseEnter(e) {
  if (PlannerGlobals.mode == 'basic' && !PlannerGlobals.isDragging) {
    var elem = $(this).closest('.planner-rotatable')[0];
    showRotateTool(elem);
  }
}

export function initDeviceEvents() {
  if (PlannerGlobals.isInQuote) {
    return;
  }
  $('.device').on('click', deviceOnClick);
  $('.device').on('mouseenter', deviceOnMouseEnter);
  $('.planner-rotatable').on('mouseenter', rotatableOnMouseEnter);
  $('.serial').on('click', serialOnClick);
}

export function addRoom(arr2d) {
  var poly = arr2d.map(function (array) {
    return {
      x: array[0],
      y: array[1]
    };
  });

  var room = {
    roomname: "",
    poly: poly,
    id: -1,
    needSend: true
  };

  PlannerGlobals.rooms.push(room);
}

export function draw_mouseMove() {
  if (!PlannerGlobals.isDrawing || !PlannerGlobals.drawRoomStartPoint || PlannerGlobals.isZooming && !isCurrentlyAutoPanning()) return;
  var xy = getXY();

  if (!MODKEYS_STATE.shift) {
    // snap to 45 degrees
    var res = P_xytonum(uMath.getSnappedEnd(P_numtoxy(PlannerGlobals.drawRoomStartPoint), P_numtoxy(xy)));
    if (Number.isNaN(res[0]) || Number.isNaN(res[1])) {
      console.log(PlannerGlobals.drawRoomStartPoint, xy, res);
    }
    xy = res;

  }

  d3.select('#drawLinePreview').remove();
  d3.select('.drawPoly').insert('line', '.drawCircle')
  .attr('x1', PlannerGlobals.drawRoomStartPoint[0])
  .attr('y1', PlannerGlobals.drawRoomStartPoint[1])
  .attr('x2', xy[0])
  .attr('y2', xy[1])
  .attr('id', 'drawLinePreview')
  .attr('stroke', PlannerGlobals.mode == 'drawOuterW' ? 'orange' : '#53DBF3')
  .attr('stroke-width', 0.5);
}

export function draw_groupMeMove() {
  if (PlannerGlobals.mode != 'groupMe') return;
  var xy = getXY();
  d3.select('.new-groupme-line').remove();
  var line = d3.select('#grouppaths').insert('line')
  .attr('class', 'new-groupme-line')
  .attr('x1', PlannerGlobals.groupMeXY[0])
  .attr('y1', PlannerGlobals.groupMeXY[1])
  .attr('x2', xy[0])
  .attr('y2', xy[1])
  .attr('stroke', '#53DBF3')
  .attr('stroke-width', 0.5);
}

let rotateMeCurrIdx = 0;
let ROTATEMEINCREMENT = 2;

export function getDevTransform(d) {
  var transform = "translate(" + d.x + "," + d.y + ")";
  if (d.angle) {
    if (d.connId) {
      const serCent2d = getSerialCenter2d(d.allColsNum, d.allRowsNum)
      transform += `rotate(${d.angle} ${serCent2d})`;
    }
    else if (d.id) {
      const cols = d.direction === "horizontal" ? d.devices.length : 1;
      const rows = d.direction === "horizontal" ? 1 : d.devices.length;
      transform += `rotate(${d.angle} ${getSerialCenter2d(cols, rows)})`;
      /* transform += "rotate(" + d.angle + " " + getSerialCenter(d.devices.length) + ")"; */
    }
    else {
      transform += "rotate(" + d.angle + " " + PlannerGlobals.DEVICE_SIZE / 2 + " " + PlannerGlobals.DEVICE_SIZE / 2 + ")";

    }
  }
  return transform;
}

const ANGLE_SNAP_THRESHOLD = 15;

export function rotateMeUpdate() {
  if (PlannerGlobals.mode !== 'rotateMe' || ++rotateMeCurrIdx % ROTATEMEINCREMENT != 0) return;
  rotateMeCurrIdx = 0;
  var d3Elem = d3.select(rotateMeSource);
  var d3Data = d3Elem.datum();
  if (d3Data.connId) {
    d3Elem = d3.select(rotateMeSource.parentNode);
  }

  if (d3Data.haunted || d3Data.devices[0].nopermission) return;

  var currxy = getXY();
  var xy = [currxy[0] - rotateMeStartXY[0], currxy[1] - rotateMeStartXY[1]];
  var angle = (180 / Math.PI * Math.atan2(xy[1], xy[0])) - rotateMeStartAngle + rotateMeDevOrigiAngle;

  if (!MODKEYS_STATE.shift && !isCamera(d3Data.devices[0])) {
    angle = snapAngleTo45(angle, ANGLE_SNAP_THRESHOLD);
  }

  if (d3Data.connId) { // connected serials
    d3Data.serials.forEach(ser => {
      var ser = getSerialById(ser.serialId);
      if (ser) {
        ser.angle = angle;
      }
    });
    d3Data.devices.forEach(dev => {
      var realDev = getDeviceById(dev.deviceId);
      if (realDev) {
        realDev.angle = angle;
      }
    })
  }
  else if (d3Data.id) { // single serial
    var ser = getSerialById(d3Data.id);
    ser.angle = angle;
    d3Data.devices.forEach(function (dev) {
      var realDev = getDeviceById(dev.deviceId);
      if (realDev) {
        realDev.angle = angle;
      }
    });
  }
  else { // single dev
    d3Data.devices[0].angle = angle;
  }

  d3Data.angle = angle;

  var toRotate = $(rotateMeSource).closest('.planner-rotatable');
  toRotate.attr('transform', getDevTransform(d3Data));

  // redraw groups and measurements in case dev is in either of them
  if (++PlannerGlobals.CURR_REDRAW_COUNTER % PlannerGlobals.CAN_REDRAW_EVERY_FRAME == 0) {
    if (isDInGroup(d3Data)) {
      redrawGroups(true, d3Data);
    }
    if (isDInMeasures(d3Data)) {
      /* redrawMeasurements(); */
      redrawMeasurementsOf(d3Data);
    }
    PlannerGlobals.CURR_REDRAW_COUNTER = 0;
  }
  var isValid = doDragChecks(d3Data, []);
  if (!isValid) {
    addErrorMarker(d3Data);
  }
  else {
    removeErrorMarker(d3Data);
  }

  // redraw notes
  if (PlannerGlobals.symbols_on || PlannerGlobals.notes_on) {
    d3Elem.selectAll('.quote-symbol, .devices .note-elem').remove();
    d3Data.devices.forEach(function (dev) {
      d3.select('[data-deviceId="' + dev.deviceId + '"]').each(function (d) {
        drawDevSymbolForDev(d, this);
      });
    });
  }
  // redraw quantity badges
  d3Elem.selectAll('.quote-number').remove();
  d3Data.devices.forEach(function (dev) {
    d3.select('[data-deviceId="' + dev.deviceId + '"]').each(function (d) {
      redrawQuantityBadgeForDev(d, this)
    });
  });
  // rotate height text if needed
  if (d3Data.id || d3Data.connId) {
    const normalizedAngle = uMath.normalizeAngle(angle);
    const textRotation = normalizedAngle > 91 && normalizedAngle < 269 ? 180 : 0;
    const rotateElem = d3Data.id ? rotateMeSource : rotateMeSource.parentNode;
    d3.select(rotateElem).selectAll('.height-txt').each(function () {
      const d3This = d3.select(this);
      const bbox = d3This.node().getBBox();
      const rotateCenter = {
        x: bbox.x + bbox.width / 2,
        y: bbox.y + bbox.height / 2
      }
      d3This.attr('transform', `rotate(${textRotation} ${rotateCenter.x} ${rotateCenter.y})`);
    });
  }

  if (isCamera(d3Data.devices[0])) {
    drawDraggedMotionSensor(d3Data.devices[0]);
  }
}

export function rotateMeUndo() {
  if ($('#motionsensors').length) {
    d3.select('#motionsensors').remove();
  }

  var d3Data = d3.select(rotateMeSource).datum();
  if (d3Data.connId) { // serial connection
    d3Data.serials.forEach(x => {
      const ser = getSerialById(x.id);
      ser.angle = rotateMeDevOrigiAngle;
      ser.deviceIds.forEach(id => {
        const dev = getDeviceById(id);
        if (dev) {
          dev.angle = rotateMeDevOrigiAngle;
        }
      });
    });
  }
  else if (d3Data.id) { // serial
    var ser = getSerialById(d3Data.id);
    ser.angle = rotateMeDevOrigiAngle;
    ser.deviceIds.forEach(id => {
      const dev = getDeviceById(id);
      if (dev) {
        dev.angle = rotateMeDevOrigiAngle;
      }
    });
  }
  else { // single dev
    d3Data.devices[0].angle = rotateMeDevOrigiAngle;
  }

  $('#rotate-tool').remove();
  redrawDevice(d3Data.devices[0].deviceId);
  setMode.basic();
}

export function rotateMeEnd() {
  if ($('#motionsensors').length) {
    d3.select('#motionsensors').remove();
  }
  var d3Data = d3.select(rotateMeSource).datum();
  if (!(d3Data.haunted || d3Data.devices[0].nopermission)) {
    var foundValidRoom = anyRoomContainsDeviceAllpts(d3Data);
    if (!foundValidRoom) {
      toastErrorSingle(ts("p_dev_wall_intersect_err", "Make sure the device doesn't intersect any walls."), false, 'dev-place-err');
      if (d3Data.connId) {
        d3Data.serials.forEach(serObj => {
          var ser = getSerialById(serObj.serialId);
          ser.angle = rotateMeDevOrigiAngle;
          d3Data.devices.forEach(dev => dev.angle = rotateMeDevOrigiAngle);
        })
      }
      else if (d3Data.id) {
        var ser = getSerialById(d3Data.id);
        ser.angle = rotateMeDevOrigiAngle;
      }
      else {
        d3Data.devices[0].angle = rotateMeDevOrigiAngle;
      }
    } else {
      // put
      var action = new RotateDeviceAction(d3Data.devices[0].deviceId, rotateMeDevOrigiAngle, d3Data.id ? d3Data.angle : d3Data.devices[0].angle);
      PUTDevData(d3Data, undefined, function () {
        PlannerGlobals.plannerHistoryManager.addHistoryEntry(action);
      });
    }
  }

  $('#rotate-tool').remove();
  redrawDevice(d3Data.devices[0].deviceId);
  setMode.basic();
}
export const WALLSELECT_COLOR = '#D9B606';

export function wallSelectEnd() {
  if (PlannerGlobals.mode != 'wallSelect' && PlannerGlobals.mode != 'wallSelectModify') return;

  var inputValue = +$('#wallSelectCenterInput input').val();
  if ($.isNumeric(inputValue)) {
    if (isPlannerMetric() && (inputValue < MEASURE_DEFAULT_MIN_CM || inputValue > MEASURE_DEFAULT_MAX_CM)) {
      toastErrorSingle(
          ts(
              "scale_size_error_metric",
              "The specified value is out of range ( The value should be between {min}cm-{max}cm)",
              [
                {template: '{min}', value: MEASURE_DEFAULT_MIN_CM},
                {template: '{max}', value: MEASURE_DEFAULT_MAX_CM}
              ]
          ));
    } else if (isPlannerImperial() && (inputValue < MEASURE_DEFAULT_MIN_IN || inputValue > MEASURE_DEFAULT_MAX_IN)) {
      toastErrorSingle(
          ts(
              "scale_size_error_imperial",
              "The specified value is out of range ( The value should be between {min}inch-{max}inch)",
              [
                {template: '{min}', value: MEASURE_DEFAULT_MIN_IN},
                {template: '{max}',value: MEASURE_DEFAULT_MAX_IN}
              ]
          ));
    }
    else {
      const wssd = PlannerGlobals.wallSegmentation.getSaveData();

      var lineLength = Math.sqrt(
          Math.pow(PlannerGlobals.wallSelectEndPos[0] - PlannerGlobals.wallSelectStartPos[0], 2) +
          Math.pow(PlannerGlobals.wallSelectEndPos[1] - PlannerGlobals.wallSelectStartPos[1], 2)
      );

      if (isPlannerImperial()) {
        inputValue = inchToCm(inputValue);
      }

      const origiLengthOf1Px = PlannerGlobals.LENGTHOF1PX;
      PlannerGlobals.lastGoodLengthOf1Px = PlannerGlobals.LENGTHOF1PX;
      PlannerGlobals.lastGoodRatioPoints = $.extend(true, {}, PlannerGlobals.serverConfirmedRatioPoints);
      PlannerGlobals.lastGoodScaleMod = PlannerGlobals.DEVICE_SIZE_MOD;

      PlannerGlobals.sizeErrorHelper.moddingTo = PlannerGlobals.DEVICE_SIZE_MOD;
      PlannerGlobals.sizeErrorHelper.lastGoodScaleMod = PlannerGlobals.DEVICE_SIZE_MOD;
      PlannerGlobals.sizeErrorHelper.lastGoodLengthOf1Px = PlannerGlobals.LENGTHOF1PX;
      PlannerGlobals.sizeErrorHelper.lastGoodRatioPoints = $.extend(true, {}, PlannerGlobals.serverConfirmedRatioPoints);

      PlannerGlobals.LENGTHOF1PX = inputValue / lineLength;

      redrawMeasurements();
      recalcAllRoomsDynamicProps();
      recalcBaseDevSize();
      redrawRooms();

      PlannerGlobals.lastRatioPoints = {
        x1: PlannerGlobals.wallSelectStartPos[0],
        y1: PlannerGlobals.wallSelectStartPos[1],
        x2: PlannerGlobals.wallSelectEndPos[0],
        y2: PlannerGlobals.wallSelectEndPos[1]
      };
      if (!PlannerGlobals.sizeErrorHelper.errorCorrectMode) {
        var origisrv = PlannerGlobals.serverConfirmedRatioPoints;
        saveProportionRelatedProps()
        .done(function () {
          var action = new ModifyScaleNoErrorAction(origisrv, origiLengthOf1Px, PlannerGlobals.lastRatioPoints, PlannerGlobals.LENGTHOF1PX, wssd);
          PlannerGlobals.plannerHistoryManager.addHistoryEntry(action);
          instantCalcOuter();
          PlannerGlobals.wallSegmentation.recalcPreserveSave(wssd);
          _plannerCallbacks.onScaleSaved?.();
        });
      }

      zenModeOff();
      setMode.basic();
    }
  }
}

export function saveProportionRelatedProps() {
  var finalPromise = $.Deferred();
  var d1 = saveLengthProportion();
  var d2 = saveLastRatioPoints();
  $.when(d1, d2)
  .done(function () {
    sendAllRooms()
    .done(function () {
      finalPromise.resolve();
      willCalcOuter();
    })
    .fail(function () {
      finalPromise.reject();
    });
  })
  .fail(function () {
    finalPromise.reject();
  });

  return finalPromise;
}

export function wallSelectToLastGood() {
  PlannerGlobals.lastRatioPoints = $.extend(true, {}, PlannerGlobals.lastGoodRatioPoints);
  PlannerGlobals.wallSelectStartPos = [PlannerGlobals.lastRatioPoints.x1, PlannerGlobals.lastRatioPoints.y1];
  PlannerGlobals.wallSelectEndPos = [PlannerGlobals.lastRatioPoints.x2, PlannerGlobals.lastRatioPoints.y2];
  PlannerGlobals.LENGTHOF1PX = PlannerGlobals.lastGoodLengthOf1Px;
  redrawMeasurements();
  recalcAllRoomsDynamicProps();
  recalcBaseDevSize();
  saveProportionRelatedProps();
}

export function saveLastRatioPoints() {
  var def = $.Deferred();
  getAuthHeader(function (header) {
    $.ajax({
      headers: header,
      url: ROOT_URI + '/floor/update-ratio-line',
      data: $.extend(true, {}, PlannerGlobals.lastRatioPoints, { floor_id: PlannerGlobals.plannerFloorId }),
      type: 'POST',
      success: function () {
        PlannerGlobals.serverConfirmedRatioPoints = $.extend(true, {}, PlannerGlobals.lastRatioPoints);
        // newTour.triggerEvent({ done: 'set_scale' });
        def.resolve();
      },
      error: function () {
        def.reject();
      }
    });
  });
  return def;
}

export function saveLengthProportion() {
  var def = $.Deferred();
  getAuthHeader(function (header) {
    $.ajax({
      headers: header,
      url: ROOT_URI + '/floor/modify',
      type: 'POST',
      dataType: 'JSON',
      data: {
        floor_id: PlannerGlobals.plannerFloorId,
        length_proportion: PlannerGlobals.LENGTHOF1PX
      },
      success: function () {
        PlannerGlobals.lastGoodLengthOf1Px = PlannerGlobals.LENGTHOF1PX;
        def.resolve();
      },
      error: function (resp) {
        def.reject();
        genericXHRErrorHandler(resp);
      }
    });
  });
  return def;
}

export function recalcSingleRoomDynamicProps(room) {
  room.area = getRoomAreaCM2(room);
  room.airm3 = getRoomAirM3(room);
}

export function recalcAllRoomsDynamicProps() {
  for (var i = 0; i < PlannerGlobals.rooms.length; i++) {
    recalcSingleRoomDynamicProps(PlannerGlobals.rooms[i]);
  }
}

/**
 * @returns {JQuery.Deferred<any,any,any>}
 */
export function sendAllRooms() {
  var roomDefs = [];
  getAuthHeader(function (header) {
    PlannerGlobals.rooms.forEach(function (room) {
      var roomDef = $.Deferred();
      roomDefs.push(roomDef);
      $.ajax({
        headers: header,
        url: ROOT_URI + '/floor/room',
        data: {
          room_id: room.id,
          room_name: room.roomname,
          room_polygons: JSON.stringify(room.poly),
          headroom: room.room_headroom,
          room_type_id: room.room_type_id,
          area: room.area,
          airspace: room.airm3
        },
        dataType: 'JSON',
        type: 'PUT',
        success: function (resp) {
          roomDef.resolve();
        },
        error: function (resp) {
          roomDef.reject();
        }
      });
    });
  });
  return $.when.apply($, roomDefs);
}

export function getRoomAirM3(room) {
  var areaM2 = room.area / 10000; //original area is in CM^2 -> M^2 = 100^2CM^2
  var headroomM = room.room_headroom / 100; //original headroom is in CM -> 1M = 100CM
  return areaM2 * headroomM;
}
/**
 *
 * @param {Device} device
 * @returns {[number, number]}
 */
export function getDevicePositionCenter(device) {
  var first = getFirstOccurrenceOfDev(device);
  if (thereWasGhostDevice()) {
    var props = ghostDevProps();
    if (props.entityType == "device" && props.entityId == device.deviceId) {
      return [props.cx, props.cy];
    }
  }
  return P_xytonum(uDev.getCenterOfDevice_NoDOM(first.deviceId));
}


/**
 *
 * @param {Point} xy
 */
export function getRoomByPoint(xy) {
  return PlannerGlobals.rooms.find(function (room) {
    var poly = XYtoNumPoly(room.poly);
    return d3.polygonContains(poly, [xy.x, xy.y]);
  });
}

export function downloadImages(devices) {
  for (let i = 0; i < devices.length; i++) {
    let dev = devices[i];
    $.ajax({
      async: false,
      url: dev.image,
      cache: true,
      success: function (resp) {
        let respsvg = $(resp).find('svg');
        if (!respsvg[0]) return;
        respsvg.find("path").attr("fill", dev.image_color);
        dev.image = "data:image/svg+xml;base64," + btoa(respsvg[0].outerHTML);
      }
    })
  }
}

export function convertWallMods(respWallMods) {
  var mapped = respWallMods.map(function (grp) {
    return {
      id: grp.segment_group_id,
      type: grp.type,
      rooms: grp.segment_parts.map(function (part) {
        return {
          id: part.segment_part_id,
          points: [
            { x: part.x1, y: part.y1 },
            { x: part.x2, y: part.y2 },
          ],
          wallIds: part.wall_ids,
          type: part.type,
          roomId: part.room_id
        }
      })
    }
  });

  return mapped;
}

export function processMats(mats) {
  for (var i in mats) {
    var mat = mats[i] || {};
    mats[i] = {
      id: mat['id'],
      '2_4': mat['_2_4Ghz_attenuation'],
      '5': mat['_5Ghz_attenuation'],
    }
  }
}

export const projectIdOfFloorCache = new Map();

export function closestPoint(pathNode, point) {
  var pathLength = pathNode.getTotalLength(),
      precision = 8,
      best,
      bestLength,
      bestDistance = Infinity;

  for (var scan, scanLength = 0, scanDistance; scanLength <= pathLength; scanLength += precision) {
    if ((scanDistance = distance2(scan = pathNode.getPointAtLength(scanLength))) < bestDistance) {
      best = scan;
      bestLength = scanLength;
      bestDistance = scanDistance;
    }
  }

  precision /= 2;
  while (precision > 0.5) {
    var before,
        after,
        beforeLength,
        afterLength,
        beforeDistance,
        afterDistance;
    if ((beforeLength = bestLength - precision) >= 0 && (beforeDistance = distance2(before = pathNode.getPointAtLength(beforeLength))) < bestDistance) {
      best = before;
      bestLength = beforeLength;
      bestDistance = beforeDistance;
    } else if ((afterLength = bestLength + precision) <= pathLength && (afterDistance = distance2(after = pathNode.getPointAtLength(afterLength))) < bestDistance) {
      best = after;
      bestLength = afterLength;
      bestDistance = afterDistance;
    } else {
      precision /= 2;
    }
  }

  best = [best.x, best.y];
  best.distance = Math.sqrt(bestDistance);
  return best;

  function distance2(p) {
    var dx = p.x - point[0],
        dy = p.y - point[1];
    return dx * dx + dy * dy;
  }
}


export function isThingShown(thing) {
  if (thing.type == "device") {
    const dev = getDeviceById(thing.id);
    return dev && isCategoryShown(dev.category_id);
  }
  else if (thing.type == "serial") {
    var ser = getSerialById(thing.id);
    if (!ser) {
      return false;
    }
    for (var i = 0; i < ser.deviceIds.length; i++) {
      var dev = getDeviceById(ser.deviceIds[i]);
      if (dev && isCategoryShown(dev.category_id)) {
        return true;
      }
    }
    return false;
  }
  return true;
}

/**
 *
 * @param {string} id
 * @param {"on" | "off" | "loading"} state
 */
export function toolbarSwitchSet(id, state) {
  if (PlannerGlobals.toolbarIdStates[id] == state) return;
  PlannerGlobals.toolbarIdStates[id] = state;
  if (state == "on" || state == "off") {
    var color = state == "on" ? "limegreen" : "#ec0000";
    $('#' + id).html('<i class="fa fa-toggle-' + state + '" style="font-size:12px;color: ' + color + ';font-weight:800;"></i>');
  }
  else if (state == "loading") {
    $('#' + id).html('<i class="fa fa-spinner anim-rotating" style="font-size:12px;color:#2d2d2d;font-weight:800;"></i>');
  }
  else {
    console.debug("unsupported call in toolbarSwitchSet");
  }
}



export function redrawQuantityBadgeForDev(d, elem) {
  if (d.ghost && d.serializable) {
    return;
  }
  var qty_text = d.qty;
  if (!qty_text || qty_text < 2) {
    return;
  }
  if (!isCategoryShown(d.category_id)) {
    return;
  }

  qty_text = ("" + qty_text).trim();
  var textLength = qty_text.length;

  var d3this = d3.select(elem);
  var parent = d3.select(elem.parentNode);
  var badgeId = d.deviceId;
  var fontSize = PlannerGlobals.DEVICE_SIZE / 3 * 0.9;

  var fontWidth = fontSize * 3 / 5;

  var startPosX = +d3this.attr("x") + PlannerGlobals.DEVICE_SIZE / 2;
  var startPosY = +d3this.attr("y") + fontSize / 2 + PlannerGlobals.DEVICE_SIZE * 0.96;

  var textElem = parent.append('text')
  .attr('data-badgeofdevid', badgeId)
  .attr('id', 'qty_badge_' + badgeId)
  .attr('class', 'quote-number')
  .attr('x', startPosX)
  .attr('y', startPosY)
  .attr('font-size', fontSize)
  .attr('font-weight', '600')

  .attr('fill', 'black')
  .attr('text-anchor', 'middle')
  .attr('transform', `rotate(${-d.angle} ${startPosX} ${startPosY - fontSize / 2})`)
  .text(qty_text);

  var paddingX = PlannerGlobals.DEVICE_SIZE / 8;
  var paddingY = PlannerGlobals.DEVICE_SIZE / 20;
  parent.insert('rect', '#qty_badge_' + badgeId)
  .attr('data-badgeofdevid', badgeId)
  .attr('class', 'quote-number')
  .attr('x', startPosX - fontWidth * textLength / 2 - paddingX)
  .attr('y', startPosY - fontSize + PlannerGlobals.DEVICE_SIZE / 24 - paddingY)
  .attr('width', fontWidth * textLength + paddingX * 2)
  .attr('height', fontSize + paddingY * 2)
  .attr('rx', PlannerGlobals.DEVICE_SIZE / 5)
  .attr('ry', PlannerGlobals.DEVICE_SIZE / 5)
  .attr('fill', '#fafa00')
  .attr('transform', `rotate(${-d.angle} ${startPosX} ${startPosY - fontSize / 2})`);

}

export function redrawQuantityBadges() {
  PlannerGlobals.svg.selectAll('.device, .dev-ghost')
  .each(function (d) {
    redrawQuantityBadgeForDev(d, this);
  });
}


export function hideDevSymbols() {
  PlannerGlobals.svg.selectAll('.quote-numbers').remove();
}

/**
 *
 * @param {Device} dev
 * @param {*} devElem
 * @returns
 */
export function drawDevSymbolForDev(dev, devElem) {

  if (!isCategoryShown(dev.category_id)) {
    return;
  }

  var quote_number = dev.symbol_id;
  if (PlannerGlobals.notes_on) {
    if (dev.noteTxt) {
      quote_number = dev.noteTxt;
    }
    else {
      return;
    }
  }
  var d3this = d3.select(devElem);
  var parent = d3.select(devElem.parentNode);
  var currTextId = dev.deviceId;

  const ser = dev.serializable ? getSerialOfDeviceId(dev.deviceId) : null;
  const connectedPair = ser ? getSerialConnectedPair(ser.id) : null;
  const noteShouldBeRight = ser ? ser.direction === "vertical" : false;
  const noteShouldBeTop = !noteShouldBeRight && connectedPair && connectedPair.height > ser.height;

  var textAnchor;
  var nAngle = uMath.normalizeAngle(dev.angle);
  if (noteShouldBeTop) {
    if (nAngle > 20 && nAngle < 160) {
      textAnchor = 'start';
    }
    else if (nAngle > 200 && nAngle < 340) {
      textAnchor = 'end';
    }
    else {
      textAnchor = 'middle';
    }
  }
  else if (noteShouldBeRight) {
    if (nAngle > 110 && nAngle < 250) {
      textAnchor = 'end';
    }
    else if (nAngle > 290 || nAngle < 70) {
      textAnchor = 'start';
    }
    else {
      textAnchor = 'middle';
    }

  }
  else {
    if (nAngle > 20 && nAngle < 160) {
      textAnchor = 'end';
    }
    else if (nAngle > 200 && nAngle < 340) {
      textAnchor = 'start';
    }
    else {
      textAnchor = 'middle';
    }
  }


  var fontSize = PlannerGlobals.DEVICE_SIZE * (85 / 300);
  var textX;
  var textY;

  if (noteShouldBeTop) {
    textX = +d3this.attr('x') + PlannerGlobals.DEVICE_SIZE / 2;
    textY = +d3this.attr('y') - GET_SER_MARG() * 2 - fontSize / 3;
  }
  else if (noteShouldBeRight) {
    textX = +d3this.attr('x') + PlannerGlobals.DEVICE_SIZE * 1.3;
    textY = +d3this.attr('y') + PlannerGlobals.DEVICE_SIZE / 2 + fontSize / 5;
  }
  else {
    textX = +d3this.attr('x') + PlannerGlobals.DEVICE_SIZE / 2;
    textY = +d3this.attr('y') + PlannerGlobals.DEVICE_SIZE + fontSize + GET_SER_MARG() * 2;
  }

  if (noteShouldBeRight) {

  }
  else {
    if (textAnchor === 'end' || textAnchor === 'start') {
      textY -= fontSize / 2;
    }
  }


  var clsName = PlannerGlobals.symbols_on ? 'quote-symbol' : 'note-elem';
  var textclsName = PlannerGlobals.symbols_on ? '' : ' dev-note-text';

  var textElem = parent.append('text')
  .attr('class', clsName + textclsName)
  .attr('x', textX)
  .attr('y', textY)
  .attr('font-size', fontSize)
  .attr('font-weight', '400')
  .attr('fill', 'black')
  .attr('text-anchor', textAnchor)
  .attr('id', clsName + '_text_' + currTextId)
  .attr('transform', `rotate(${-nAngle} ${textX} ${textY})`)
  .attr('data-deviceid', dev.deviceId)
  .style('pointer-events', 'none');

  if (PlannerGlobals.symbols_on && quote_number) {
    if (dev.qty > 1) {
      let mergeDeviceArray = PlannerGlobals.mergedDevice.filter(merged => merged.merge_plan_objects_id === dev.deviceId);
      for (var i = 0; i < mergeDeviceArray.length; i++) {
        for (var k = 0; k < PlannerGlobals.devices.length; k++) {
          if (PlannerGlobals.devices[k].deviceId === mergeDeviceArray[i].merged_plan_objects_id) {
            quote_number += "-" + PlannerGlobals.devices[k].symbol_id.split('_')[1];
          }
        }
      }
      //quote_number += "-...";
    }
    var parts = quote_number.split('_');

    parts[0] && textElem.append('tspan')
      .attr('x', textX)
      .attr('dy', 0)
      .text(parts[0])

    parts[1] && textElem.append('tspan')
      .attr('x', textX)
      .attr('dy', fontSize)
      .text(parts[1])
  }
  else if (PlannerGlobals.notes_on) {
    var parts = SVG_TEXT_HELPER.wrapLabelWithForcedLineBreak(quote_number, textAnchor === 'middle' ? PlannerGlobals.DEVICE_SIZE : PlannerGlobals.DEVICE_SIZE * 3, fontSize, '_');

    parts.forEach(function (part, idx) {
      textElem.append('tspan')
        .attr('x', textX)
        .attr('dy', idx === 0 ? 0 : fontSize)
        .text(part);
    });

    textElem = getTextCoordinate({
      noteShouldBeTop,
      textAnchor,
      nAngle,
      textY,
      fontSize,
      parts,
      noteShouldBeRight,
      textElem,
    });
  }

  var bbox = textElem.node().getBBox();

  parent.insert('rect', '#' + clsName + '_text_' + currTextId)
  .attr('class', clsName + " dev-note-rect")
  .attr('x', bbox.x - 1)
  .attr('y', bbox.y)
  .attr('height', bbox.height)
  .attr('width', bbox.width + 2)
  .attr('rx', bbox.height / 6)
  .attr('ry', bbox.height / 6)
  .attr('fill-opacity', 0.7)
  .attr('fill', PlannerGlobals.notes_on && dev.noteColor ? dev.noteColor : 'white')
  .attr('transform', `rotate(${-nAngle} ${textX} ${textY})`)
  .attr('data-noteId', PlannerGlobals.notes_on ? currTextId : null)
  /* .style('cursor', notes_on ? 'pointer' : null) */
  .on('click', PlannerGlobals.notes_on ? function (e) {
    highlightNote(currTextId, "dev");
    e.stopImmediatePropagation();
  } : function () { })
  .on('mouseenter', function () {
    showNoteTools(currTextId, "dev");
  });


  // 2x ne generálja le a közös tárólót amibena note és a symból is benne van.
  if (PlannerGlobals.notes_on) {
    return;
  }

  // Összeállítunk egy elemet amibena note és a szimbol is benne van hogy a dokumentation-ben meg tudjuk jelenítenni
  const clsNameForNoteAndSymbol = 'dev-note-and-symbol-text'
  var textElemForNoteAndSymbol = parent.append('text')
  .attr('class', 'dev-note-and-symbol ' + clsNameForNoteAndSymbol)
  .attr('x', textX)
  .attr('y', textY)
  .attr('font-size', fontSize)
  .attr('font-weight', '400')
  .attr('fill', 'black')
  .attr('text-anchor', textAnchor)
  .attr('id', clsNameForNoteAndSymbol + '_text_' + currTextId)
  .attr('transform', `rotate(${-nAngle} ${textX} ${textY})`)
  .attr('data-deviceid', dev.deviceId);
  // .style('display', 'none');


  let mergedTextArray = [];
  if (dev.symbol_id) {
    mergedTextArray = dev.symbol_id.split('_');
  }

  if (dev.noteTxt) {
    const partsNote = SVG_TEXT_HELPER.wrapLabelWithForcedLineBreak(dev.noteTxt, textAnchor === 'middle' ? PlannerGlobals.DEVICE_SIZE : PlannerGlobals.DEVICE_SIZE * 3, fontSize, '_');
    if (dev.symbol_id) {
      mergedTextArray = [...partsNote, ...['-'], ...dev.symbol_id.split('_')];
    } else {
      mergedTextArray = [...partsNote];
    }
  }

  mergedTextArray.forEach(function (part, idx) {
    textElemForNoteAndSymbol.append('tspan')
      .attr('x', textX)
      .attr('dy', idx === 0 ? 0 : fontSize)
      .text(part);
  });

  textElemForNoteAndSymbol = getTextCoordinate({
    noteShouldBeTop,
    textAnchor,
    nAngle,
    textY,
    fontSize,
    parts: mergedTextArray,
    noteShouldBeRight,
    textElem: textElemForNoteAndSymbol,
  });

  var bboxNoteAndSymbol = textElemForNoteAndSymbol.node().getBBox();

  $('.dev-note-and-symbol').hide()

  parent.insert('rect', '#' + clsName + '_text_' + currTextId)
  .attr('class', "dev-note-and-symbol dev-note-and-symbol-rect")
  .attr('x', bboxNoteAndSymbol.x - 1)
  .attr('y', bboxNoteAndSymbol.y)
  .attr('height', bboxNoteAndSymbol.height)
  .attr('width', bboxNoteAndSymbol.width + 2)
  .attr('rx', bboxNoteAndSymbol.height / 6)
  .attr('ry', bboxNoteAndSymbol.height / 6)
  .attr('fill-opacity', 0.7)
  .attr('fill', dev.noteColor ? dev.noteColor : 'white')
  .attr('transform', `rotate(${-nAngle} ${textX} ${textY})`)
  .attr('data-noteId', PlannerGlobals.notes_on ? currTextId : null);

}

export function getTextCoordinate(props){
  let {
    noteShouldBeTop,
    textAnchor,
    nAngle,
    textY,
    fontSize,
    parts,
    noteShouldBeRight,
    textElem,
  } = props;

  if (noteShouldBeTop && textAnchor === 'middle') {
    if (nAngle >= 160 && nAngle <= 200) {
      textElem.attr('y', textY + fontSize / 2);
    }
    else {
      textElem.attr('y', textY - (parts.length - 1) * fontSize);
    }
  }
  else if (noteShouldBeRight && textAnchor === 'middle') {
    if (nAngle > 250 && nAngle < 290) {
      textElem.attr('y', textY - (parts.length - 1) * fontSize);
    }
    else if (nAngle > 70 && nAngle < 110) {
      textElem.attr('y', textY + fontSize / 2);
    }
  }
  else if (nAngle >= 160 && nAngle <= 200) {
    textElem.attr('y', textY - (parts.length - 1.5) * fontSize);
  }
  else if (textAnchor === 'end' || textAnchor === 'start') {
    textElem.attr('y', textY - (parts.length / 2 - 1) * fontSize);
  }

  return textElem
}

/**
 * this function also removes the quote numbers, so it's basically a redraw
 *
 */
export function drawDevSymbols() {

  if (!PlannerGlobals.isInQuote) {
    PlannerGlobals.svg.selectAll('.quote-symbol, .devices .note-elem').remove();
  }

  PlannerGlobals.svg.selectAll('.device')
  .each(function (d) {
    drawDevSymbolForDev(d, this);
  });
}
/**
 * @returns {D3Device[]}
 */
export function getDevicesD3Style() {
  var devices_d3_new = d3.selectAll('#devicesMain > g');
  if (devices_d3_new.empty()) {
    return [];
  }
  var d3Devs = [];
  var deviceNodes = devices_d3_new.nodes();
  for (var i = 0; i < deviceNodes.length; i++) {
    d3Devs.push(d3.select(deviceNodes[i]).data()[0]);
  }
  d3Devs.forEach(d3Dev => {
    if (d3Dev && d3Dev.devices.length) {
      ['x', 'y', 'roomId', 'angle'].forEach(propKey => {
        d3Dev[propKey] = d3Dev.devices[0][propKey];
      });
    }
  });
  return d3Devs;
}

export function firstOfType(pnid, roomId) {

  // TODO LEHET NEM KELL a canBeDevMerged mer már nem vonjuk össze minden esetben

  if (isDevSingle(pnid) && canBeDevMerged(pnid) && PlannerGlobals.roomDevs[roomId] && PlannerGlobals.roomDevs[roomId][pnid]) {
    return PlannerGlobals.roomDevs[roomId][pnid][0];
  }
  return false;
}

export function recalcRoomDevs() {
  PlannerGlobals.roomDevs = {};
  uDev.roomsExtendedWithUnassigned.forEach(function (room) {
    PlannerGlobals.roomDevs[room.id] = {};
  });
  PlannerGlobals.devices.forEach(function (dev) {
    if (dev.product_name_id in PlannerGlobals.roomDevs[dev.roomId]) {
      PlannerGlobals.roomDevs[dev.roomId][dev.product_name_id].push(dev);
    }
    else {
      PlannerGlobals.roomDevs[dev.roomId][dev.product_name_id] = [dev];
    }
  });
}

export function pxToCM(px) {
  return PlannerGlobals.LENGTHOF1PX * px;
}

export function CMToPx(CM) {
  return CM / PlannerGlobals.LENGTHOF1PX;
}

export function redrawRooms() {
  d3.select('.rooms').remove();
  d3.select('.polygontexts').remove();
  PlannerGlobals.svg.selectAll('.roomdivname').remove();


  const isShowMaterialMode = PlannerGlobals.mode === "showBuildingMats";
  const roomOpacity = isShowMaterialMode || PlannerGlobals.plannerEditableWallViewEnable === true ? 0.5 : PlannerGlobals.plannerOpacity / 100;

  PlannerGlobals.container.insert("g", "#plannerIMAGE + *")
  .attr("class", "rooms")
  .selectAll("polygon")
  .data(PlannerGlobals.rooms)
  .enter().append("polygon")
  .attr("points", function (d) {
    return d.poly.map(function (d) {
      return [d.x, d.y].join(",");
    }).join(" ");
  })
  .attr("stroke", "#3FD5C0")
  .attr("stroke-width", 0.5)
  .attr("fill-opacity", roomOpacity)
  .attr("class", "poly uplan-touchable")
  .attr("data-roomId", function (d) {
    return d.id;
  });

  /* if (uDev.outerBorderExists()) { */
  var linesPerSide = 30;

  var lineLen = 900 / linesPerSide;
  var lineWidth = lineLen * 1 / 3;
  var spaceWidth = lineLen * 2 / 3;
  var dashoffset = lineWidth / 2;
  d3.select('.rooms')
    .insert('polygon', ':first-child')
    .attr('points', "0,0 0,900 900,900 900,0")
    .attr('id', "outdoorPoly")
    .attr('stroke', 'black')
    .attr('stroke-width', 0.25)
    .attr('stroke-dasharray', lineWidth + " " + spaceWidth)
    .attr('stroke-dashoffset', dashoffset)
    .attr('fill-opacity', 0)
    .attr('class', 'poly uplan-touchable')
    .attr('data-roomId', uDev.OUTDOORS_ROOM_ID);
  /* } */

  d3.select('.rooms')
    .insert('polygon', ':first-child')
    .attr('points', "0,0 0,900 900,900 900,0")
    .attr('id', "unassignedPoly")
    .attr('stroke', 'transparent')
    .attr('stroke-width', 0)
    .attr('fill-opacity', 0)
    .attr('class', 'poly')
    .attr('data-roomId', uDev.UNASSIGNED_ROOM_ID)
    .style('pointer-events', 'none');

  if (PlannerGlobals.planNamesShown || isShowMaterialMode) {
    PlannerGlobals.rooms.forEach(function (room) {
      room.labelPlace = polylabel([XYto2DArr(room.poly)]);
    });
    const whereToInsert = isShowMaterialMode || PlannerGlobals.plannerEditableWallViewEnable === true ? '#build-mat-poly-cont + *' : '.rooms + *';
    var textcont = PlannerGlobals.container.insert("g", whereToInsert)
    .attr("class", "polygontexts")
    .selectAll("text")
    .data(PlannerGlobals.rooms)
    .enter();

    const textOpacity = isShowMaterialMode ? '0.65' : '0.23';

    textcont
    .append("text")
    .attr("x", function (d) { return d.labelPlace[0]; })
    .attr("y", function (d) { return d.labelPlace[1] - 4; })
    .attr('font-size', '8px')
    .attr("fill-opacity", textOpacity)
    .attr("data-roomId", function (d) { return d.id; })
    .text(function (d) { return d.roomname; })
    .attr("class", "polyt")
    .attr("text-anchor", "middle");

    const areaCont = textcont
    .append("text")
    .attr("x", function (d) { return d.labelPlace[0]; })
    .attr("y", function (d) { return d.labelPlace[1] + 4; })
    .attr('font-size', '8px')
    .attr("fill-opacity", textOpacity)
    .attr("data-roomId", function (d) { return d.id; })
    .attr("class", "polyt")
    .attr("text-anchor", "middle")

    areaCont
    .append("tspan")
    .text(function (d) {
      if (!d.area || Number.isNaN(+d.area)) { return ""; }

      const areaM2 = d.area / 10000;
      const areaFt2 = squareMeterToSquareFoot(areaM2);
      const writtenAreaNum = isPlannerMetric() ? areaM2 : areaFt2;
      const writtenAreaUnit = isPlannerMetric() ? "m" : "ft";

      return `${(+writtenAreaNum).toFixed(2)} ${writtenAreaUnit}`;
    });

    areaCont.append("tspan")
    .attr("baseline-shift", "super")
    .attr('font-size', '5px')
    /* .attr('dy', '0.5px') */
    .text(function (d) {
      if (!d.area || Number.isNaN(+d.area)) { return ""; }
      return 2;
    });

    if (PlannerGlobals.mode === "showBuildingMats") {
      textcont
      .append("text")
      .attr("x", function (d) { return d.labelPlace[0]; })
      .attr("y", function (d) { return d.labelPlace[1] + 12; })
      .attr('font-size', '8px')
      .attr("fill-opacity", textOpacity)
      .text(function (d) {
        const roomMat = PlannerGlobals.wallSegmentation.calculatedPolygons.find(poly => poly.id === "ceiling_" + d.id);
        if (!roomMat) { return ""; }
        else {
          return roomMat.material.name;
        }
      })
      .attr("class", "polyt")
      .attr("text-anchor", "middle");
    }
  }

  wallModHelperDOM.redrawWallMods();
  if (PlannerGlobals.mode != 'modifyOuterW') {
    redrawOuterWalls();
  }
  recalcAllRoomsDynamicProps();
}

export function calculateWallMidpoints(polygon) {
  var minWallLengthPx = PlannerGlobals.LENGTHOF1PX ? (50 / PlannerGlobals.LENGTHOF1PX) : 0;
  var midpoints = [];
  for (var i = 0; i < polygon.length; i++) {
    var p1 = polygon[i];
    var p2 = polygon[(i + 1) % polygon.length];
    var wallLength = Math.sqrt(Math.pow(p2.x - p1.x, 2) + Math.pow(p2.y - p1.y, 2));
    if (wallLength >= minWallLengthPx) {
      midpoints.push({
        x: (p1.x + p2.x) / 2,
        y: (p1.y + p2.y) / 2,
        wallIndex: i
      });
    }
  }
  return midpoints;
}

export function redrawModifyCircles() {
  // if (newTour.isOngoing() && newTour.currStepId === "draw_rooms") { return; }

  if (PlannerGlobals.modifiedRoom && PlannerGlobals.modifiedRoom.id !== uDev.OUTDOORS_ROOM_ID && PlannerGlobals.modifiedRoom.id !== uDev.UNASSIGNED_ROOM_ID) {
    PlannerGlobals.container.select(".modifyCircles").remove();
    var circlesGroup = PlannerGlobals.container.append('g').attr('class', 'modifyCircles');

    circlesGroup.selectAll('circle.modifyCircle')
      .data(PlannerGlobals.modifiedPoly).enter()
      .append('circle')
      .attr('class', 'modifyCircle')
      .attr('cx', function (d) { return d.x; })
      .attr('cy', function (d) { return +d.y; })
      .attr('r', (PlannerGlobals.DRAW_CIRCLE_R * 2) / PlannerGlobals.scalevar)
      .attr('fill', '#fff')
      .attr('stroke', '#000')
      .attr('stroke-width', PlannerGlobals.DRAW_CIRCLE_STROKE_WIDTH / PlannerGlobals.scalevar)
      .style('cursor', 'default')
      .call(PlannerGlobals.dragRoomCircle);

    var midpoints = calculateWallMidpoints(PlannerGlobals.modifiedPoly);

    circlesGroup.selectAll('circle.modifyMidpointCircle')
      .data(midpoints)
      .enter()
      .append('circle')
      .attr('class', 'modifyMidpointCircle')
      .attr('cx', function (d) { return d.x; })
      .attr('cy', function (d) { return d.y; })
      .attr('r', (PlannerGlobals.DRAW_CIRCLE_R * 2) / PlannerGlobals.scalevar)
      .attr('fill', '#fff')
      .attr('stroke', '#000')
      .attr('stroke-width', PlannerGlobals.DRAW_CIRCLE_STROKE_WIDTH / PlannerGlobals.scalevar)
      .attr('data-wall-index', function (d) { return d.wallIndex; })
      .style('cursor', 'pointer')
      .call(PlannerGlobals.dragRoomCircle);
  }
}
export function redrawModifyPolyline() {
  var selectPoints = PlannerGlobals.modifiedPoly.map(function (currXY) {
    return [+currXY.x, +currXY.y];
  });

  selectPoints.push(selectPoints[0]);
  d3.select('.selectPolyline').remove();
  var selectPolyline = PlannerGlobals.container.insert('polyline', '.modifyCircles')
  .attr('class', 'selectPolyline')
  .attr('points', selectPoints)
  .style('fill', 'none')
  .attr('stroke', PlannerGlobals.mode == 'modifyOuterW' ? 'orange' : 'red')
  .attr('stroke-width', PlannerGlobals.MODIFY_POLYLINE_STROKE / PlannerGlobals.scalevar);
}

export function unHighlight(cls) {
  if (!isPlannerVisible() || !PlannerGlobals.svg) { return; }
  var clsPost = cls ? ('-' + cls) : '';
  PlannerGlobals.svg.selectAll('.highlights' + clsPost).remove();

  $('#devicesMain')
  .find('.serial-conn-hover-highlight, .serial-mrg-hover-highlight')
  .removeClass('serial-conn-hover-highlight serial-mrg-hover-highlight');

  $('#containerSVG .note-rect-selected').removeClass('note-rect-selected');
  PlannerGlobals.currentlySelectedElement = null;
}

/**
 *
 * @param {Room} room
 */
export function getRoomBBoxZoomScaleAndPt(room) {
  try {
    var roomBBox = uMath.getRoomBoundingBox(room);

    var centerPt = [roomBBox.centerX, roomBBox.centerY];
    var vbWidth = +getViewBox().split(" ")[2] || 900;
    var vbHeight = +getViewBox().split(" ")[3] || 900;
    var scaleX = vbWidth / roomBBox.width;
    var scaleY = vbHeight / roomBBox.height;
    var scale = Math.min(scaleX, scaleY);

    return { centerPt, scale };
  }
  catch (err) {
    console.debug(err);
    return { centerPt: [0, 0], scale: 1 };
  }
}

export function highlightRoom(roomId) {
  try {
    var room = getRoomById(roomId);
    if (room) {
      var roomBBox = getRoomBBoxZoomScaleAndPt(room);

      var scale = uMath.clamp(roomBBox.scale * 0.85, 1, 5);
      var center = roomBBox.centerPt;
      if (typeof uDev === "object" && uDev && (uDev.OUTDOORS_ROOM_ID == room.id || uDev.UNASSIGNED_ROOM_ID == room.id)) {
        scale = 1;
      }

      highlightPoint(center[0], center[1], scale);
    }
  }
  catch (err) {
    console.debug(err);
  }
}
export function setTranslateTo(x, y, scale, duration) {
  PlannerGlobals.svg.transition()
    .duration(duration)
    .ease(d3.easeLinear)
    .call(PlannerGlobals.zoom.transform, d3.zoomIdentity.translate(x, y).scale(scale));
}

export function highlightPoint(x, y, scale, duration = 350) {
  PlannerGlobals.svg.transition()
    .duration(duration)
    .call(
        PlannerGlobals.zoom.transform,
        d3.zoomIdentity.translate(450 - x * scale, 450 - y * scale).scale(scale)
    );
}

export function highlightDevice(deviceId, fillColor, strokeColor) {
  var highlightedPosition = highlightDeviceNoZoom(deviceId, null, fillColor, strokeColor);
  highlightPoint(highlightedPosition[0], highlightedPosition[1], 4);
}

export function currCenterPoint() {
  return [-(PlannerGlobals.translatevar[0] - 450) / PlannerGlobals.scalevar, -(PlannerGlobals.translatevar[1] - 450) / PlannerGlobals.scalevar];
}
export function highlightAllDevices(cls, devFilterCallback, fillColor = "rgba(0, 220, 165, 0.1)", strokeColor = "rgba(0, 183, 137, 0.87)") {
  var clsPost = cls ? '-' + cls : '';
  unHighlight(cls);
  var highlightCont = PlannerGlobals.container.insert('g', '.devices')
  .attr('class', 'highlights' + clsPost)
  .style('pointer-events', 'none');

  getDevicesD3Style().forEach(function (d) {
    var devs = d.devices;
    if (typeof devFilterCallback === "function") {
      devs = devs.filter(devFilterCallback);
    }
    devs.forEach(function (device) {
      var center = uDev.getCenterOfDevice_NoDOM(device.deviceId);
      highlightCont.insert('rect')
      .attr('class', 'highlight' + clsPost)
      .attr('x', center.x - PlannerGlobals.DEVICE_SIZE / 2 - PlannerGlobals.DEVICE_SIZE * 0.1 / 2)
      .attr('y', center.y - PlannerGlobals.DEVICE_SIZE / 2 - PlannerGlobals.DEVICE_SIZE * 0.1 / 2)
      .attr('width', PlannerGlobals.DEVICE_SIZE * 1.1)
      .attr('height', PlannerGlobals.DEVICE_SIZE * 1.1)
      .attr('transform', 'rotate(' + (d.angle ? d.angle : 0) + ' ' + center.x + ' ' + center.y + ')')
      .attr('fill', fillColor)
      .attr('stroke', strokeColor)
      .attr('stroke-width', '0.2px')
      .attr('rx', '0.2px')
      .attr('ry', '0.2px');
    });
  });

}

/**
 * @param {number|string} deviceId
 * @param {string|null} cls
 * @param {string|null} [fillColor]
 * @param {string|null} [strokeColor]
 * @param {boolean} [noUnHighlight]
 * @param {boolean} [noClipboard]
 */
export function highlightDeviceNoZoom(deviceId, cls, fillColor = null, strokeColor = null, noUnHighlight = false, noClipboard = false) {
  var clsPost = cls ? '-' + cls : '';
  var highlighted = getDeviceById(deviceId);
  if (isCategoryLocked(highlighted.category_id)) return;

  if (PlannerGlobals.selectionBeforeDrag && PlannerGlobals.selectionBeforeDrag.type == 'device' && PlannerGlobals.selectionBeforeDrag.content.deviceId == deviceId) {
    var ser = getSerialOfDeviceId(deviceId);
    if (ser) {
      unHighlight(clsPost);
      highlightSerial(ser.id, undefined, undefined, undefined, deviceId);
      return P_xytonum(uDev.getCenterOfDevice_NoDOM(deviceId));
    }
  }

  if (!noUnHighlight) {
    unHighlight(clsPost);
  }

  var highlightedPosition = P_xytonum(uDev.getCenterOfDevice_NoDOM(deviceId));

  if (!fillColor) {
    fillColor = ControllerGlobals.currentlyDraggedDevice && ControllerGlobals.currentlyDraggedDevice.id === "new_note" ? 'rgb(254, 250, 184)' : 'rgba(0, 220, 165, 0.1)';
  }
  if (!strokeColor) {
    strokeColor = ControllerGlobals.currentlyDraggedDevice && ControllerGlobals.currentlyDraggedDevice.id === "new_note" ? 'rgb(222, 218, 140)' : 'rgba(0, 183, 137, 0.87)';
  }

  PlannerGlobals.container.insert('g', '.devices').attr('class', 'highlights' + clsPost)
  .insert('rect')
  .attr('class', 'highlight' + clsPost)
  .attr('x', highlightedPosition[0] - PlannerGlobals.DEVICE_SIZE / 2 - PlannerGlobals.DEVICE_SIZE * 0.1 / 2)
  .attr('y', highlightedPosition[1] - PlannerGlobals.DEVICE_SIZE / 2 - PlannerGlobals.DEVICE_SIZE * 0.1 / 2)
  .attr('width', PlannerGlobals.DEVICE_SIZE * 1.1)
  .attr('height', PlannerGlobals.DEVICE_SIZE * 1.1)
  .attr('transform', 'rotate(' + (highlighted.angle ? highlighted.angle : 0) + ' ' + highlightedPosition[0] + ' ' + highlightedPosition[1] + ')')
  .attr('fill', fillColor ? fillColor : 'rgba(0, 220, 165, 0.1)')
  .attr('stroke', strokeColor ? strokeColor : 'rgba(0, 183, 137, 0.87)')
  .attr('stroke-width', '0.2px')
  .attr('rx', '0.2px')
  .attr('ry', '0.2px');

  if (!noClipboard) {
    PlannerGlobals.currentlySelectedElement = {
      type: 'device',
      content: highlighted
    };
  }

  return highlightedPosition;
}

export function addErrorMarker(d) {
  var fillColor = 'rgba(255, 0, 0, 0.35)';
  var strokeColor = 'rgba(150, 0, 0, 0.85)';
  var elem, width, height;
  if (d.id) {
    //serial
    elem = d3.select('[data-serialId="' + d.id + '"]');
    var devN = d.devices.length;
    width = devN * PlannerGlobals.DEVICE_SIZE + SERIAL_SPACING * (devN - 1);
    height = PlannerGlobals.DEVICE_SIZE;
    if (d.direction === "vertical") {
      const temp = width;
      width = height;
      height = temp;
    }
  }
  else if (d.connId) {
    //conn
    elem = d3.select('[data-serConnId="' + d.connId + '"]');
    width = d.allColsNum * (PlannerGlobals.DEVICE_SIZE + SERIAL_SPACING) - SERIAL_SPACING;
    height = d.allRowsNum * (PlannerGlobals.DEVICE_SIZE + SERIAL_SPACING) - SERIAL_SPACING;
  }
  else {
    //dev
    var dev = d.devices[0];
    elem = d3.select('[data-serDevId="' + dev.deviceId + '"]');
    width = PlannerGlobals.DEVICE_SIZE;
    height = PlannerGlobals.DEVICE_SIZE;
  }
  var elemSelect = elem.select('.errorHighlight')
  if (elemSelect.empty()) {
    elem
    /* .insert('rect', 'image') */
    .append('rect')
    .attr('class', 'errorHighlight')
    .attr('x', 0)
    .attr('y', 0)
    .attr('width', width)
    .attr('height', height)
    .attr('fill', fillColor)
    .attr('stroke', strokeColor)
    .attr('stroke-width', '0.2px')
    .attr('rx', '0.2px')
    .attr('ry', '0.2px');
  }
}

export function removeErrorMarker(d) {
  var elem;
  if (d.id) {
    elem = PlannerGlobals.svg.select('[data-serialId="' + d.id + '"]');
  }
  else if (d.connId) {
    elem = PlannerGlobals.svg.select('[data-serConnId="' + d.connId + '"]');
  }
  else {
    var dev = d.devices[0];
    elem = PlannerGlobals.svg.select('[data-serDevId="' + dev.deviceId + '"]');
  }
  elem.select('.errorHighlight').remove();
}

/**
 * Selects the room for modifying with given ID
 * @param {Number} id room id to select. -1 means the newly created room that is not sent to the server
 * @param {Boolean} forceZoom if given and True, the room will be zoomed to
 */
export function selectRoom(id, forceZoom = false) {

  unHighlight();

  // don't select again if already modifying, or if we're not preparing for select right now
  if (PlannerGlobals.modifying || !(PlannerGlobals.mode == 'prepareSelect' || PlannerGlobals.mode == 'modifyOuterW')) {
    return;
  }

  if (PlannerGlobals.mode == 'prepareSelect') {
    setMode.selectRoom();
  }

  var isModdingPredefRoom = id == uDev.OUTDOORS_ROOM_ID || id == uDev.UNASSIGNED_ROOM_ID;
  var isModdingOuterBorder = PlannerGlobals.mode == "modifyOuterW";

  var selectedRoom = uDev.roomsExtended.find(function (room, idx) {
    if (room.id == id) {
      PlannerGlobals.rooms.splice(idx, 1);
      PlannerGlobals.modifiedRoom = room;
      redrawRooms();
      return true;
    }
    return false;
  });


  if (!selectedRoom) {
    //this shouldn't happen, but still..
    setMode.basic();
    return;
  }

  selectedRoomDevices = PlannerGlobals.devices.filter(function (device) {
    return parseInt(device.roomId) === parseInt(selectedRoom.id);
  });

  PlannerGlobals.modifying = true;

  //cloning the variables
  origiPoly = convertPoly(selectedRoom.poly);// selectedRoom.poly.map(function (xy) { return { x: xy.x, y: xy.y }; });
  PlannerGlobals.modifiedPoly = selectedRoom.poly.map(function (x) { return x; });

  if (!isModdingPredefRoom) {
    //remove modify circles that were drawn before and add new ones
    redrawModifyCircles();
  }

  redrawModifyPolyline();

  if (isModdingPredefRoom) {
    $("#type-modify-input").addClass("hidden");
    $("#height-modify-input").closest('.planner-modify-item').addClass('hidden');
    $("#delete-modify-btn").addClass('hidden');
  }
  else {
    $("#type-modify-input").removeClass("hidden");
    if (PlannerGlobals.modifiedRoom.id > 0) {
      $("#height-modify-input").closest('.planner-modify-item').removeClass('hidden');

    }
    if (isModdingOuterBorder) {
      $("#delete-modify-btn").removeClass('hidden');
    }
    else {
      $("#delete-modify-btn").addClass('hidden');
    }
  }


  //enter modified room name to name input field
  $('#name-modify-input').val(PlannerGlobals.modifiedRoom.roomname);
  let heightVal = !PlannerGlobals.modifiedRoom.needSend ? PlannerGlobals.modifiedRoom.room_headroom : PlannerGlobals.floorHeadroom;
  if (isPlannerImperial()) {
    heightVal = cmToFt(heightVal);
  }
  $('#height-modify-input').val(heightVal);
  if (PlannerGlobals.modifiedRoom.room_type_id) {
    $('#type-modify-input').val(PlannerGlobals.modifiedRoom.room_type_id);
  } else {
    $('#type-modify-input').prop("selectedIndex", 0);
  }

  // zoom to selected room
  if (forceZoom) {
    var normalizedPoly = XYtoNumPoly(origiPoly);
    var roomCentroid = d3.polygonCentroid(normalizedPoly);

    PlannerGlobals.svg.transition()
      .duration(500)
      .call(
          PlannerGlobals.zoom.transform,
          d3.zoomIdentity.translate(450 - roomCentroid[0] * 1.2, 450 - roomCentroid[1] * 1.2).scale(1.2)
      );
  }
}

/**
 * undomodify, undo modify, cancelmodify, cancel modify, modify cancel, modifycancel
 */
/**
 * Restores variables affected by modification to their original values
 */
export function modifyCleanup() {
  if (PlannerGlobals.mode == 'selectRoom' || PlannerGlobals.mode == 'prepareSelect' || PlannerGlobals.mode == 'modifyOuterW') {
    $('#name-modify-input').val('');
    PlannerGlobals.leftoutAlertShown = false;
    selectedRoomDevices = [];
    PlannerGlobals.modifying = false;
    PlannerGlobals.modifiedRoom = undefined;
    origiPoly = [];
    PlannerGlobals.modifiedPoly = [];
    PlannerGlobals.changedWalls = {};
    unHighlight();
    redrawRooms();
    redrawDevices();
    d3.select('.selectPolyline').remove();
    PlannerGlobals.svg.selectAll('.modifyCircles').remove();
    $(".planner-buttons-cont").not('.planner-modify-item').not('#planner-buttons-crop').removeClass('hidden');
    return true;
  }
  return false;
}


/**
 * Deletes the currently selected room
 * deleteroom, roomdelete, delete room, room delete, modify delete, delete modify, deletemodify
 * @param {Function} callback
 */
export function modifyDelete(callback) {
  if (PlannerGlobals.modifying) {
    var currRoom = PlannerGlobals.modifiedRoom;
    deleteRoomAjax(currRoom, callback, callback);
  }
}

export function roomModifySaveLocal(roomData) {
  if (!PlannerGlobals.modifiedRoom) {
    return null;
  }

  var deletedD3s = [],
      enframedD3s = [],
      leftOutD3s = [],
      deletedWallModConns = [],
      deletedMeasurements = [],
      deletedGroups = [];

  /* var leftoutDevices = []; */
  var isOutdoors = PlannerGlobals.modifiedRoom.id == uDev.OUTDOORS_ROOM_ID;
  var isPredefRoom = PlannerGlobals.modifiedRoom.id == uDev.OUTDOORS_ROOM_ID || PlannerGlobals.modifiedRoom.id == uDev.UNASSIGNED_ROOM_ID;

  var roomDevs = uDev.devicesOfRoom(PlannerGlobals.modifiedRoom.id).filter(function (dev) { return !dev.ghost; });
  var deletedGroups = deepCopy(getDistinctGroupsOfDevs(roomDevs));
  var deletedSerConns = deepCopy(getDistinctSerialConnectionsOfDevs(roomDevs));

  if (!isPredefRoom) {
    PlannerGlobals.modifiedRoom.poly = PlannerGlobals.modifiedPoly;
    PlannerGlobals.rooms.push(PlannerGlobals.modifiedRoom);

    const movedDevs = PlannerGlobals.modifiedRoom.id == -2 ? uDevDOM.refreshDevRoomsForOuterBorderModify() : uDevDOM.refreshDevRoomsForRoomModify(PlannerGlobals.modifiedRoom.id);
    deletedD3s = movedDevs.removedD3Devs;
    enframedD3s = movedDevs.enframedD3Devs;
    leftOutD3s = movedDevs.leftOutD3Devs;
  }

  PlannerGlobals.modifiedRoom.roomname = roomData.room_name;
  PlannerGlobals.modifiedRoom.room_headroom = +roomData.headroom;
  PlannerGlobals.modifiedRoom.room_type_id = +roomData.room_type_id;
  PlannerGlobals.modifying = false;

  if (isOutdoors) {
    uDev.OUTDOORS_ROOM_NAME = PlannerGlobals.modifiedRoom.roomname;
  }
  else {
    deletedMeasurements = filterInvalidMeasurements();
    deletedMeasurements = deletedMeasurements.concat(PlannerGlobals.wallModConnections
    .filter(function (wmc) {
      return +wmc.rooms[0].roomId === +PlannerGlobals.modifiedRoom.id || wmc.rooms[1] && +wmc.rooms[1].roomId === +PlannerGlobals.modifiedRoom.id;
    })
    .map(function (wm) {
      return getMeasurementsOfWallModConn(wm.id);
    })
    .reduce(function (p, c) { return p.concat(c); }, []));
    deletedWallModConns = deleteModdedWallModConns();
    willCalcOuter();
  }

  deletedD3s.forEach(function (d3d) {
    d3d.removedMeasures = d3d.id ? getMeasurementsOfSerial(d3d.id) : [];
    d3d.devices.forEach(function (dev) {
      var deviceId = dev.deviceId;
      var origiNote = getNote(deviceId, "dev");
      var origiGroups = getGroupsOfDevice(deviceId);
      dev.removedDevParams = {
        note: origiNote,
        removedMeasures: getMeasurementsOfDevice(deviceId),
        groupIds: origiGroups.map(function (grp) { return grp.id; })
      }
    });
  });

  recalcSwitchPNIDs();

  return {
    deletedD3s,
    enframedD3s,
    leftOutD3s,
    deletedWallModConns,
    deletedMeasurements,
    deletedGroups,
    deletedSerConns,
  }
}

export function convertPoly(poly) {
  return poly.map(function (coord) {
    var nc = {
      x: +coord.x,
      y: +coord.y,
      room_id: +coord.room_id,
      order_index: +coord.order_index,
      id: +coord.id
    };
    return nc;
  });
}

/**
 *
 * @param {Device[]} enframedDevs NOT D3Devs, please convert with uDevDOM.devicesOfD3Ds first
 * @param {number} roomId
 */
export function moveEnframedDevsToRoom(enframedDevs, roomId, callback) {
  return new Promise((res, rej) => {

    function resolveEnframe(i) {
      return function () {
        console.log(i, enframedDevs[i], proms[i])
        enframedDevs[i].roomId = roomId;
        proms[i].resolve();
      };
    }

    var proms = [];

    for (var i = 0; i < enframedDevs.length; i++) {
      var devCopy = Object.assign({}, enframedDevs[i]);

      if (devCopy.roomId == roomId) { continue; }

      devCopy.roomId = roomId;

      var prom = $.Deferred();
      proms.push(prom);
      var putdata = {
        roomId: roomId,
        x: devCopy.x,
        y: devCopy.y,
        devices: [devCopy]
      };
      PUTDevData(putdata, true, resolveEnframe(i), () => prom.reject());
    }

    $.when.apply($, proms)
    .done(function () {
      if (typeof callback == "function") {
        callback();
      }
      return res();
    })
    .fail(function () {
      return rej();
    });
  });
}

//confirmmodify, modifyconfirm
export function roomModifySave() {
  if (PlannerGlobals.modifying) {
    var isPredefRoom = PlannerGlobals.modifiedRoom && (PlannerGlobals.modifiedRoom.id == uDev.OUTDOORS_ROOM_ID || PlannerGlobals.modifiedRoom.id == uDev.UNASSIGNED_ROOM_ID);

    if ($('#name-modify-input').val().trim().length < 1) {
      toastInfo(ts('room_name_needed', 'roomNameNeeded'));
      if (!PlannerGlobals.isInQuote) {
        $('#name-modify-input').focus();
      }
      return;
    }

    var origiState = deepCopy(PlannerGlobals.modifiedRoom);
    origiState.poly = deepCopy(origiPoly);

    var normalModroomPoly = XYtoNumPoly(PlannerGlobals.modifiedPoly);

    var preventMod = false;
    try {
      var testRes;

      if (AnyLineIntersectsSelfMod()) {
        if (PlannerGlobals.mode == 'drawOuterW') {
          toastInfo(ts('p_ow_intersect_s_err', "Walls can't intersect themselves."));
        }
        else {
          toastInfo(ts('intersect_s_err', 'intersectSErr'));
        }
        preventMod = true;
      }
      else if (testRes = AnyLineIntersectsARoomMod(), testRes) {
        if (PlannerGlobals.mode == 'modifyOuterW' || testRes.wasBorder) {
          toastInfo(ts('p_ow_intersect_o_err', "Walls can't intersect rooms."));
        }
        else {
          toastInfo(ts('intersect_o_err', 'intersectOErr'));
        }
        preventMod = true;
      }
      else if (uDevDOM.polygonIntersectsAnyDev(PlannerGlobals.modifiedPoly)) {
        /* if (mode != 'modifyOuterW') { */
        toastInfoSingle(ts('p_ow_intersect_d_err', "Walls can't intersect devices"), false, 'left-out-warning');
        preventMod = true;
        /* } */
      }
      else if (PlannerGlobals.mode == 'selectRoom' && !isPredefRoom && roomContainsAnother(normalModroomPoly)) {
        toastInfo(ts('contain_err', 'containErr'));
        preventMod = true;
      }

    }
    catch (err) {
      console.log(err);
    }

    if (preventMod) {
      return;
    }

    var currRoom = PlannerGlobals.modifiedRoom;

    var preModState = JSON.parse(JSON.stringify(currRoom));
    preModState.poly = origiPoly;

    currRoom.poly = currRoom.poly.map(function (coords) {
      return {
        x: +coords.x,
        y: +coords.y
      };
    });

    let heightVal = +$('#height-modify-input').val();
    if (isPlannerImperial()) {
      heightVal = ftToCm(heightVal);
    }

    currRoom.room_headroom = heightVal;

    recalcSingleRoomDynamicProps(currRoom);

    /**
     * Submitting a new room
     */
    if (PlannerGlobals.modifiedRoom.needSend) {
      PlannerGlobals.modifiedRoom.needSend = false;
      getAuthHeader(function (header) {
        var roomData = {
          floor_id: PlannerGlobals.plannerFloorId,
          room_name: $('#name-modify-input').val(),
          room_polygons: JSON.stringify(PlannerGlobals.modifiedPoly),
          headroom: currRoom.room_headroom,
          room_type_id: $('#type-modify-input').val(),
          area: currRoom.area,
          airspace: currRoom.airm3
        };
        const wssd = PlannerGlobals.wallSegmentation.getSaveData();
        $.ajax({
          headers: header,
          url: ROOT_URI + '/floor/room',
          data: roomData,
          dataType: 'JSON',
          type: 'POST',
          success: function (resp) {
            currRoom.id = parseInt(resp.id);
            PlannerGlobals.modifiedPoly = convertPoly(resp.wall_polies);
            const saveDetails = roomModifySaveLocal(roomData);
            redrawRooms();

            // TODO: moveplannercode probably unnecessary
            // setTimeout(function () {
            //   ProjectTreeGlobals.previousNode = null;
            // }, 1000);

            setMode.basic();

            if (saveDetails) {
              var action = new CreateRoomAction(currRoom, wssd, saveDetails.enframedD3s);
              PlannerGlobals.plannerHistoryManager.addHistoryEntry(action);
            }

            // newTour.triggerEvent({ done: 'draw_rooms' });

            PlannerGlobals.wallSegmentation.recalcPreserveSave(wssd);
          },
          error: function (resp) {
            PlannerGlobals.modifying = false;
            setMode.drawing();
            genericXHRErrorHandler(resp);
          }
        });
      });
    } else {
      /**
       * Submitting a modified room
       */
      getAuthHeader(function (header) {
        for (var i = 0; i < PlannerGlobals.modifiedPoly.length; i++) {
          PlannerGlobals.modifiedPoly[i].order_index = i;
          PlannerGlobals.modifiedPoly[i].room_id = currRoom.id;
        }
        var roomData = {
          room_id: currRoom.id,
          room_name: $('#name-modify-input').val(),
          room_polygons: JSON.stringify(isPredefRoom ? [] : PlannerGlobals.modifiedPoly),
          headroom: currRoom.room_headroom,
          room_type_id: $('#type-modify-input').val(),
          area: currRoom.area,
          airspace: currRoom.airm3
        };
        $.ajax({
          headers: header,
          url: ROOT_URI + '/floor/room',
          data: roomData,
          dataType: 'JSON',
          type: 'PUT',
          success: function (resp) {
            PlannerGlobals.modifiedPoly = convertPoly(resp.wall_polies);
            var deleteProps = roomModifySaveLocal(roomData);
            var postModState = deepCopy(currRoom);
            var action = new ModifyRoomAction(origiState, postModState, deleteProps.deletedD3s, deleteProps.deletedWallModConns, deleteProps.deletedGroups, deleteProps.deletedMeasurements, PlannerGlobals.selectRoomBeginMatSaveState, deleteProps.deletedSerConns, deleteProps.enframedD3s, deleteProps.leftOutD3s);
            PlannerGlobals.plannerHistoryManager.addHistoryEntry(action);
            setMode.basic();
            PlannerGlobals.wallSegmentation.recalcPreserveSave(PlannerGlobals.selectRoomBeginMatSaveState);

            var groupsOfRoom = getDistinctGroupsOfDevs(uDev.devicesOfRoom(currRoom.id).filter(function (dev) { return !dev.ghost; }));
            showGroupInvalidMsgIfAnyIsInvalid(groupsOfRoom);
          },
          error: function (resp) {
            setMode.basic();
            genericXHRErrorHandler(resp);
          }
        });
      });
    }
  }
}

/**
 *
 * @param {Room} room
 * @param {function} callback
 * @param {function} errorCallback
 */
export function createRoomAjax(room, callback, errorCallback, dontRefreshTree = false) {
  return new Promise((res, rej) => {
    getAuthHeader(function (header) {
      var roomData = {
        floor_id: PlannerGlobals.plannerFloorId,
        room_name: room.roomname,
        room_polygons: JSON.stringify(room.poly),
        headroom: room.room_headroom,
        room_type_id: room.room_type_id,
        area: room.area,
        airspace: room.airm3
      };

      $.ajax({
        headers: header,
        url: ROOT_URI + '/floor/room',
        data: roomData,
        dataType: 'JSON',
        type: 'POST',
        success: function (resp) {
          if (!dontRefreshTree) {
            refreshFloorView();
          }
          room.id = parseInt(resp.id);
          room.poly = convertPoly(resp.wall_polies);
          room.roomname = roomData.room_name;
          room.room_headroom = +roomData.headroom;
          room.room_type_id = +roomData.room_type_id;
          PlannerGlobals.rooms.push(room);
          redrawRooms();
          willCalcOuter();
          if (typeof callback === "function") {
            callback();
          }
          return res(resp);
        },
        error: function (resp) {
          toastError(resp.responseJSON.message);
          if (typeof errorCallback === "function") {
            errorCallback();
          }
          return rej(resp);
        }
      });
    });
  });
}

/**
 *
 * @param {Room} room
 * @param {function} callback
 * @param {function} errorCallback
 */
export function deleteRoomFromPlanner(roomId) {
  const deletedRoomD3Devs = getDevicesD3Style().filter(function (d3d) {
    return +d3d.roomId === +roomId;
  });

  const deletedGroups = deepCopy(getDistinctGroupsOfDevs(uDevDOM.devicesOfD3Ds(deletedRoomD3Devs)));

  const removedSerConns = PlannerGlobals.serialConnections.filter(conn => conn.serialIds.find(serId => {
    const ser2 = getSerialById(serId);
    return ser2 && ser2.roomId == roomId;
  }));

  processDeletedD3Devs(deletedRoomD3Devs);

  const deletedWallModConns = PlannerGlobals.wallModConnections.filter(function (wmc) {
    return wmc.rooms.find(function (wm) { return wm.roomId === roomId; });
  });

  PlannerGlobals.rooms = PlannerGlobals.rooms.filter(function (curr) {
    return curr.id !== roomId;
  });

  PlannerGlobals.devices = PlannerGlobals.devices.filter(function (device) {
    if (parseInt(device.roomId) !== parseInt(roomId)) {
      return true;
    }
    else {
      removeDeviceFromGroupsLocal(device.deviceId);
      removeDeviceFromSerial(device.deviceId, true);
      removeDeviceFromMeasuresLocal(device.deviceId);
      removeDeviceFromCacheLocal(device);
      return false;
    }
  });

  let removedMeasurements = PlannerGlobals.wallModConnections
  .filter(function (wmc) {
    return +wmc.rooms[0].roomId === +roomId || wmc.rooms[1] && +wmc.rooms[1].roomId === +roomId;
  })
  .map(function (wm) {
    return getMeasurementsOfWallModConn(wm.id);
  })
  .reduce(function (p, c) { return p.concat(c); }, []);

  deleteRoomWallModConns(roomId);

  removedMeasurements = removedMeasurements.concat(filterInvalidMeasurements(true));
  PlannerGlobals.measurements = PlannerGlobals.measurements.filter(function (meas) {
    return !removedMeasurements.find(function (rMeas) { return rMeas.id === meas.id });
  });

  if (!modifyCleanup()) {
    redrawRooms();
    redrawDevices();
  }
  willCalcOuter();
  recalcSwitchPNIDs();

  return { deletedRoomD3Devs, deletedWallModConns, deletedGroups, removedMeasurements, removedSerConns };
}

export function deleteRoomAjax(room, callback, errorCallback) {
  return new Promise((res, rej) => {
    getAuthHeader(function (header) {
      $.ajax({
        headers: header,
        url: ROOT_URI + '/floor/room',
        data: {
          room_id: room.id,
        },
        dataType: 'JSON',
        type: 'DELETE',
        success: function (resp) {
          refreshFloorView();
          const result = deleteRoomFromPlanner(room.id);

          if (typeof callback === "function") {
            callback(result.deletedRoomD3Devs, result.deletedWallModConns, result.deletedGroups, result.removedMeasurements, result.removedSerConns);
          }

          return res(result.deletedRoomD3Devs, result.deletedWallModConns, result.deletedGroups, result.removedMeasurements, result.removedSerConns);
        },
        error: function (resp, status, error) {
          modifyUndo();
          if (typeof errorCallback === "function") {
            errorCallback();
          }
          if (room.id != -1) {
            genericXHRErrorHandler(resp);
          }
          return rej(resp);
        }
      });
    });
  });
}

/**
 *
 * @param {D3Device[]} roomDevsToDel
 * @returns
 */
export function processDeletedD3Devs(roomDevsToDel) {
  var removedGroups = {};

  roomDevsToDel.forEach(function (d3d) {
    d3d.removedMeasures = d3d.id ? getMeasurementsOfSerial(d3d.id) : [];
    d3d.devices.forEach(function (dev) {
      var deviceId = dev.deviceId;
      var origiNote = getNote(deviceId, "dev");
      var origiGroups = getGroupsOfDevice(deviceId);
      dev.removedDevParams = {
        note: origiNote,
        removedMeasures: getMeasurementsOfDevice(deviceId),
        groupIds: origiGroups.map(function (grp) { return grp.id; })
      };
      origiGroups.forEach(function (grp) {
        if (!(grp.id in removedGroups)) {
          removedGroups[grp.id] = deviceId;
        }
      });
    });
  });
  for (var key in removedGroups) {
    removedGroups[key] = deepCopy(getGroupsOfDevice(removedGroups[key]));
  }
  return removedGroups;
}
/**
 *
 * @param {Room} room
 * @param {function} callback
 * @param {function} errorCallback
 */
export function modifyRoomAjax(room, callback, errorCallback) {
  return new Promise((res, rej) => {
    var isPredefRoom = room && (room.id == uDev.OUTDOORS_ROOM_ID || room.id == uDev.UNASSIGNED_ROOM_ID);

    getAuthHeader(function (header) {
      for (var i = 0; i < room.poly.length; i++) {
        room.poly[i].order_index = i;
        room.poly[i].room_id = room.id;
      }
      var roomData = {
        room_id: room.id,
        room_name: room.roomname,
        room_polygons: JSON.stringify(isPredefRoom ? [] : room.poly),
        headroom: room.room_headroom,
        room_type_id: room.room_type_id,
        area: room.area,
        airspace: room.airm3
      };
      $.ajax({
        headers: header,
        url: ROOT_URI + '/floor/room',
        data: roomData,
        dataType: 'JSON',
        type: 'PUT',
        success: function (resp) {
          PlannerGlobals.rooms = PlannerGlobals.rooms.filter(function (curr) {
            return curr.id !== room.id;
          });
          PlannerGlobals.rooms.push(room);
          PlannerGlobals.modifiedPoly = convertPoly(resp.wall_polies);
          roomModifySaveLocal(roomData);
          redrawRooms();
          if (typeof callback === "function") {
            callback();
          }
          return res();
        },
        error: function (resp) {
          toastError(resp.responseJSON.message);
          if (typeof errorCallback === "function") {
            errorCallback();
          }
          return rej();
        }
      });
    });
  });
}

// undo modify room
export function modifyUndo() {
  var isPredefRoom = PlannerGlobals.modifiedRoom && (PlannerGlobals.modifiedRoom.id == uDev.OUTDOORS_ROOM_ID || PlannerGlobals.modifiedRoom.id == uDev.UNASSIGNED_ROOM_ID);

  if (!isPredefRoom && PlannerGlobals.modifying && PlannerGlobals.mode != 'modifyOuterW') {
    if (!PlannerGlobals.modifiedRoom.needSend) {
      PlannerGlobals.modifiedRoom.poly = origiPoly;
      PlannerGlobals.rooms.push(PlannerGlobals.modifiedRoom);

    } else {
      PlannerGlobals.modifiedRoom.needSend = false;
    }
  }

  modifyCleanup();
}
let importantElems = [];
let importantPromiseQueue = [];
let importantXHRQueue = [];

export function showImportants() {
  importantPromiseQueue = [];
  importantXHRQueue = [];
  startLoading();
  importantElems = [];
  var $svgAndChat = $('#svgAndChat');
  var $importantTemplate = $('#important-msg-template');

  var $devices = $('.device');
  $devices.each(function (device, elem) {
    var top, left;
    var elemId = d3.select(elem).attr('data-deviceId') ^ 0;

    var $elemImportant = $importantTemplate.clone();
    $elemImportant.removeAttr('id');

    getAuthHeader(function (header) {
      var promise = $.Deferred();
      importantPromiseQueue.push(promise);
      importantXHRQueue.push($.ajax({
        headers: header,
        url: ROOT_URI + '/device/important-comment?plan_object_id=' + elemId,
        dataType: 'json',
        success: function (resp) {
          $elemImportant.html('<p>' + resp + '</p>');
          $elemImportant['hasMsg'] = true;
          promise.resolve();
        },
        error: function (resp) {
          if (resp.readyState == 4 && resp.status == 400) {
            $elemImportant['hasMsg'] = false;
            promise.resolve();
          }
        }
      }));
    });

    $elemImportant['relatedDevice'] = elem;
    importantElems.push($elemImportant);
    $svgAndChat.append($elemImportant);
  });

  $.when.apply($, importantPromiseQueue)
  .done(function () {
    importantElems.forEach(function (elem) {
      if (elem.hasMsg) {
        elem.css('display', 'block');
      }
    });
  })
  .always(function () {
    stopLoading();
  });

  adjustChatbox();
}

export function adjustChatbox(force) {
  var $svgAndChat = $('#svgAndChat');
  var svgOffset = $svgAndChat.offset();
  if ( /* mode == 'showImportants' || force */ true) {
    importantElems.forEach(function ($importantElem) {
      var boundingRect = $importantElem['relatedDevice'].getBoundingClientRect();

      $importantElem.css('left', (boundingRect.left - svgOffset.left) + 'px');
      $importantElem.css('top', (boundingRect.bottom - svgOffset.top) + 'px');
    });

  }

}

export function isCurrentlyAutoPanning() {
  var panDir = panForDrawingDirection(70, 18);
  return panDir.x != 0 || panDir.y != 0;
}

export function zoomed(event) {
  PlannerGlobals.isZooming = true;
  if (event.sourceEvent) {
    if (PlannerGlobals.sizeErrorHelper.errorCorrectMode) {
      PlannerGlobals.sizeErrorHelper.userZoomed = true;
      $('#show-next-bad-btn').removeClass('hidden');
    }
  }

  var isRTS = isCurrentlyAutoPanning();
  var tryingToZoomWhileRTS = isRTS && event.sourceEvent && event.sourceEvent.type == "wheel";

  if (tryingToZoomWhileRTS) {
    PlannerGlobals.container.transition();
    PlannerGlobals.container.interrupt();
    if (PlannerGlobals.zoomAnimFrame) {
      cancelAnimationFrame(PlannerGlobals.zoomAnimFrame);
    }
  }

  PlannerGlobals.translatevar = [event.transform.x, event.transform.y];
  PlannerGlobals.scalevar = event.transform.k;

  var swalVisible = !!document.querySelector('.sweet-alert.showSweetAlert');

  if (swalVisible) {
    PlannerGlobals.svg.node().__zoom = d3.zoomIdentity
      .translate(PlannerGlobals.prevTranslate[0], PlannerGlobals.prevTranslate[1])
      .scale(PlannerGlobals.prevScale);
    PlannerGlobals.translatevar = PlannerGlobals.prevTranslate;
    PlannerGlobals.scalevar = PlannerGlobals.prevScale;
    PlannerGlobals.zoomAnimFrame = requestAnimationFrame(function () {
      PlannerGlobals.container.attr("transform", "translate(" + PlannerGlobals.translatevar + ")scale(" + PlannerGlobals.scalevar + ")");
      PlannerGlobals.isZooming = false;
    });
    return;
  }

  if (isRTS && !tryingToZoomWhileRTS) {
    PlannerGlobals.scalevar = PlannerGlobals.prevScale;
  }
  if (PlannerGlobals.scalevar != PlannerGlobals.prevScale) {
    if (tryingToZoomWhileRTS) {
      PlannerGlobals.container.transition();
      PlannerGlobals.container.interrupt();
      if (PlannerGlobals.zoomAnimFrame) {
        cancelAnimationFrame(PlannerGlobals.zoomAnimFrame);
      }
    }
    /**
     * Draw dot properties
     */
    if (PlannerGlobals.isDrawing) {
      var drawCircles = PlannerGlobals.svg.selectAll('.drawCircle');
      drawCircles.attr("r", PlannerGlobals.DRAW_CIRCLE_R / event.transform.k);
      drawCircles.attr("stroke-width", PlannerGlobals.DRAW_CIRCLE_STROKE_WIDTH / PlannerGlobals.scalevar);
    }

    /**
     * Modify properties
     */
    if (PlannerGlobals.mode == 'selectRoom' || PlannerGlobals.mode == 'modifyOuterW') {
      var modifyCircles = PlannerGlobals.svg.selectAll('.modifyCircle');
      modifyCircles.attr("r", PlannerGlobals.DRAW_CIRCLE_R / event.transform.k);
      modifyCircles.attr("stroke-width", PlannerGlobals.DRAW_CIRCLE_STROKE_WIDTH / PlannerGlobals.scalevar);

      var midpointCircles = PlannerGlobals.svg.selectAll('.modifyMidpointCircle');
      midpointCircles.attr("r", PlannerGlobals.DRAW_CIRCLE_R / event.transform.k);
      midpointCircles.attr("stroke-width", PlannerGlobals.DRAW_CIRCLE_STROKE_WIDTH / PlannerGlobals.scalevar);

      var modifyPolyline = d3.select('.selectPolyline');
      modifyPolyline.attr('stroke-width', PlannerGlobals.MODIFY_POLYLINE_STROKE / PlannerGlobals.scalevar)
    }
  }

  if (PlannerGlobals.mode.indexOf('wallSelect') != -1) {
    redrawWallSelectInput();
  }
  /**
   * Chat important msgs properties
   */
  /* adjustChatbox(); */
  /**
   * Main SVG element properties
   */

  if (!PlannerGlobals.sliderPressed) {
    var sliderElem = document.getElementById('size-slider');
    if (sliderElem) {
      var slider = sliderElem.noUiSlider;
      if (slider) {
        slider.set(PlannerGlobals.scalevar * 100 / PlannerGlobals.planner_maxZoom);
      }
    }
  }
  $('#reset-center-btn').removeClass('hidden');
  PlannerGlobals.prevTranslate = PlannerGlobals.translatevar;
  PlannerGlobals.prevScale = PlannerGlobals.scalevar;
  PlannerGlobals.zoomAnimFrame = requestAnimationFrame(function () {
    PlannerGlobals.container.attr("transform", "translate(" + PlannerGlobals.translatevar + ")scale(" + PlannerGlobals.scalevar + ")");
    PlannerGlobals.isZooming = false;
  });
  var wscInput = $('#wallSelectCenterInput input');

  if ((!PlannerGlobals.isInQuote) && !(wscInput.length && wscInput[0] === document.activeElement)) {
    $('#svgAndChat').attr('tabindex', 0).focus();
  }
}

/**
 *
 * @param {Device} dev
 */
export function isSingleDevInIntendedRoom(dev) {
  var center = uDev.getCenterOfDevice_NoDOM(dev.deviceId);
  return doesDeviceFitRoom(dev.roomId, { x: center.x - PlannerGlobals.DEVICE_SIZE / 2, y: center.y - PlannerGlobals.DEVICE_SIZE / 2 }, uDev.getAngleOfDevice(dev.deviceId), 1);
}

export function isDevCabinet(device) {
  return 'type' in device && device.type.toString().indexOf("cabinet") != -1;
}

export function isDeviceInIntendedRoom(d) {
  var devData = dataFromDeviceD(d);
  if (devData.roomId === uDev.OUTDOORS_ROOM_ID && isDevCabinet(d.devices[0])) {
    return false;
  }
  return doesDeviceFitRoom(devData.roomId, devData.point, devData.rotation, devData.serialLength, devData.serialRows);
}

export function dataFromDeviceD(d) {
  const isVertSer = d.id && d.direction === "vertical";
  const length = d.allColsNum || d.devices.length;
  const rows = d.allRowsNum || 1;

  return {
    type: d.id ? 'serial' : 'device',
    rotation: d.id ? d.angle : d.devices[0].angle,
    point: d.id ? { x: d.x, y: d.y } : { x: d.devices[0].x, y: d.devices[0].y },
    roomId: d.id ? d.roomId : d.devices[0].roomId,
    serialLength: isVertSer ? rows : length,
    serialRows: isVertSer ? length : rows,
    original: d
  }
}

export function anyRoomContainsDeviceAllpts(d) {
  var devDat = dataFromDeviceD(d);

  const isCabinet = isDevCabinet(d.devices[0]);

  for (var i = 0; i < uDev.roomsExtendedWithUnassigned.length; i++) {
    var roomId = uDev.roomsExtendedWithUnassigned[i].id;
    if (doesDeviceFitRoom(roomId, devDat.point, devDat.rotation, devDat.serialLength, devDat.serialRows)) {
      if (roomId == uDev.OUTDOORS_ROOM_ID && isCabinet) {
        continue;
      }

      d.roomId = roomId;
      d.devices.forEach(function (dev) {
        dev.roomId = d.roomId;
      });
      return true;
    }
  }

  return false;
}

const CABINET_ITEM_TYPE = { RACK: 1, ELECTRICAL: 2 };

export function updateDev(dev) {
  if (dev.ghost || dev.nopermission) {
    return Promise.resolve();
  }
  if (dev.item_type === CABINET_ITEM_TYPE.RACK || dev.item_type === CABINET_ITEM_TYPE.ELECTRICAL) {
    return updateDevsAfterResize([dev]);
  }
  return new Promise((res, rej) => {
    var sendData = {
      x: dev.x,
      y: dev.y,
      room_id: dev.roomId,
      plan_object_id: dev.deviceId.toString().replace('S_', ''),
      rotate_value: dev.angle
    };

    getAuthHeader(function (header) {
      $.ajax({
        headers: header,
        url: ROOT_URI + '/device',
        type: 'PUT',
        data: sendData,
        success: (resp) => res(resp),
        error: (resp) => rej(resp)
      });
    });
  });
}

export function updateDevsAfterResize(devices) {
  return new Promise((res, rej) => {
    // Prepare the data to be sent to the backend
    // console.log(devices)
    const sendData = devices.map(dev => {
      var plan_object_id = (dev.deviceId.toString().indexOf("C_") == 0) ? dev.deviceId.toString().replace('C_', '') : dev.deviceId.toString().replace('S_', '')
      return {
        x: dev.x,
        y: dev.y,
        room_id: dev.roomId,
        plan_object_id: plan_object_id,
        rotate_value: dev.angle,
        type: (dev.deviceId.toString().indexOf("C_") == 0) ? 'custom' : dev.type
      }
    })

    getAuthHeader(function (header) {
      $.ajax({
        headers: header,
        url: ROOT_URI + '/device/save-new-coordinates',
        type: 'PUT',
        data: JSON.stringify(sendData),
        contentType: 'application/json',
        success: (resp) => res(resp),
        error: (resp) => rej(resp)
      });
    });
  });
}

export function saveCurrDevicePos(d) {
  var dev = d.devices[0];
  dev.origiposition = [d.x, d.y];
  dev.origiAngle = d.id ? d.angle : dev.angle;
  dev.origiRoomId = dev.roomId;
}

export function snapCurrDeviceBack(d) {
  if (PlannerGlobals.mode == 'basic') {
    var dev = d.devices[0];
    dev.x = dev.origiposition[0];
    dev.y = dev.origiposition[1];
    redrawDevices();
  }
}

export function saveCurrAngle(thisElem) {
  var transform = d3.select(thisElem).attr("transform");
  var match = ROTATE_REGEXP.exec(transform);
  if (match) {
    PlannerGlobals.DRAG_DEV_START_ROTATION = match[0];
  } else {
    PlannerGlobals.DRAG_DEV_START_ROTATION = "";
  }
}


let TRANSLATE_REGEXP = /translate\(.*?\)/;
let ROTATE_REGEXP = /rotate\(.*?\)/;
/**
 *
 * @param {*} d
 * @returns {Serial|Device}
 */
export function originalFromD(d) {
  if (d.id) { // serial
    return getSerialById(d.id);
  }
  else if (d.connId) {
    return getSerialConnectionProps(d.connId);
  }
  else { // dev
    return getDeviceById(d.devices[0].deviceId);
  }
}

export function getNodeForD3Data(d) {
  if (d.id) {
    return PlannerGlobals.svg.select(`.serial[data-serialId="${d.id}"]`);
  }
  else if (d.connId) {
    return PlannerGlobals.svg.select(`.serial-connection[data-serConnId="${d.connId}"]`);
  }
  else {
    return PlannerGlobals.svg.select(`.device[data-deviceId="${d.deviceId}"]`);
  }
}

export function d3DataWithSnappedPosOverride(snappedPos, d3Data) {
  if (!snappedPos) {
    return d3Data;
  }
  else {
    const newD3Obj = Object.assign({}, d3Data);
    const posData = snappedPtToPosData(snappedPos);

    for (let key in posData) {
      newD3Obj[key] = posData[key];
    }
    return newD3Obj;
  }
}

export function snappedPtToPosData(snappedPos) {
  if (!snappedPos) { return null; }

  return {
    x: snappedPos.point.x,
    y: snappedPos.point.y,
    angle: snappedPos.rotation,
    roomId: snappedPos.room.id
  }
}

/**
 *
 * @param {D3Dev} d
 * @param {number} shrinkPcnt
 * @returns {Point[]}
 */
export function d3DevRotatedRectPolygon(d, shrinkPcnt = 0) {
  if (!d) { return null; }
  const shrinkVal = PlannerGlobals.DEVICE_SIZE * shrinkPcnt;

  const x = d.x + shrinkVal;
  const y = d.y + shrinkVal;
  const angle = d.angle;

  const cols = getDColsNum(d);
  const rows = getDRowsNum(d);
  const width = cols * PlannerGlobals.DEVICE_SIZE + (cols - 1) * SERIAL_SPACING - shrinkVal * 2;
  const height = rows * PlannerGlobals.DEVICE_SIZE + (rows - 1) * SERIAL_SPACING - shrinkVal * 2;
  const center = {
    x: x + width / 2,
    y: y + height / 2
  };

  let pts = [
    { x: x, y: y },
    { x: x + width, y: y },
    { x: x + width, y: y + height },
    { x: x, y: y + height },
  ];

  const rotPts = pts.map(pt => rotatePointAroundAnotherXY(pt, center, angle));

  return rotPts;
}

export function dNoPermission(d) {
  return (Array.isArray(d.devices) && d.devices.some(function (dev) { return dev.nopermission; }));
}

export function highlightNextProblematic() {
  if (!PlannerGlobals.sizeErrorHelper.errorCorrectMode || PlannerGlobals.sizeErrorHelper.userZoomed) {
    return;
  }
  var xy = getXYP();
  var minDev = null;
  var minVal = Number.MAX_VALUE;
  for (var i in PlannerGlobals.sizeErrorHelper.problemDevices) {
    var dev = PlannerGlobals.sizeErrorHelper.problemDevices[i];
    if (dev.hasProblem) {
      var len = uMath.lineLength({ x1: dev.x, y1: dev.y, x2: xy.x, y2: xy.y });
      if (len < minVal) {
        minVal = len;
        minDev = dev;
      }
    }
  }
  if (minDev) {
    highlightPoint(minDev.x + PlannerGlobals.DEVICE_SIZE / 2, minDev.y + PlannerGlobals.DEVICE_SIZE / 2, 4.5);
  }
}

export function getMergedDevs(deviceId, pnid, roomId) {

  return PlannerGlobals.devices
  .filter(function (dev) {
    let isThisGroup = false;
    for (let i = 0; i < PlannerGlobals.mergedDevice.length; i++){
      // az összemergeltek közül az utolsó
      if (PlannerGlobals.mergedDevice[i].merge_plan_objects_id === deviceId || PlannerGlobals.mergedDevice[i].merged_plan_objects_id === deviceId) {
        isThisGroup = true;
      }
    }
    return isThisGroup && dev.product_name_id == pnid && dev.roomId == roomId
  })
  .map(function (dev) {
    return {
      id: null,
      devices: [dev],
      x: dev.x,
      y: dev.y,
      roomId: dev.roomId,
      angle: dev.angle,
    }
  });
}

export function writeDevParams(d, x, y, angle, roomId) {
  d.x = x;
  d.y = y;
  d.angle = angle;
  d.roomId = roomId;
  if (d.id) {
    var currSer = getSerialById(d.id);
    currSer.angle = d.angle;
  }
  else if (d.connId) {
    d.serials.forEach(ser => {
      var currSer = getSerialById(ser.serialId);
      currSer.angle = d.angle;
      currSer.x = x;
      currSer.y = y;
    })
  }
  for (var i = 0; i < d.devices.length; i++) {
    d.devices[i].x = d.x;
    d.devices[i].y = d.y;
    d.devices[i].angle = d.angle;
    d.devices[i].roomId = d.roomId;
    var currDev = getDeviceById(d.devices[i].deviceId);
    currDev.angle = d.angle;
  }
}

export function updateDevRotationAjax(devId, angle, callback, errorCallback) {
  var props = getDeviceById(devId);
  if (!props) {
    if (typeof errorCallback === "function") {
      errorCallback();
    }
  }

  else {
    getAuthHeader(function (headers) {
      $.ajax({
        headers,
        method: 'PUT',
        url: ROOT_URI + '/device',
        data: {
          x: props.x,
          y: props.y,
          room_id: props.roomId,
          plan_object_id: devId,
          rotate_value: angle
        },
        success: function (resp) {
          if (typeof callback === "function") {
            callback(resp);
          }
        },
        error: function (resp) {
          if (typeof errorCallback === "function") {
            errorCallback(resp);
          }
        }
      })
    });
  }
}

/**
 *
 * @param {D3Device} d
 * @return {JQuery.Promise<any,any,any>}
 */
export function updateD3MergedDevs(d, fromRoomId) {

  if(!d.devices[0].deviceId){
    return;
  }

  var similars = getMergedDevs(!d.devices[0].deviceId, d.devices[0].product_name_id, fromRoomId);
  var proms = [];

  similars.forEach(function (similar) {
    var prom = $.Deferred();
    proms.push(prom);
    writeDevParams(similar, d.x, d.y, d.angle, d.roomId);
    PUTDevData(similar, true, function () { prom.resolve(); });
  });
  redrawDevices();
  var whenAllProm = whenAll(proms);
  whenAllProm.done(function () {
    refreshFloorView();
  });
  return whenAllProm;
}

/**
 *
 * @param {D3Device} d
 * @param {D3Device[]} similars
 * @return {JQuery.Promise<any,any,any>}
 */
export function updateSimilars(d, similars) {
  var proms = [];
  similars.forEach(function (similar) {
    var prom = $.Deferred();
    proms.push(prom);
    writeDevParams(similar, d.x, d.y, d.angle, d.roomId);
    PUTDevData(similar, true, function () { prom.resolve(); });
  });
  redrawDevices();
  var whenAllProm = whenAll(proms);
  whenAllProm.done(function () {
    refreshFloorView();
  });
  return whenAllProm;
}

/**
 *
 * @param {D3Device} d3Data
 */
export function redrawD3DevExtras(d3Data, devElem) {
  d3.select(devElem).attr("transform", function (d, i) {
    return getDevTransform(d);
  });

  d3.select(devElem).selectAll('.quote-symbol, .devices .note-elem').remove();
  d3.select(devElem).selectAll('.quote-number').remove();

  d3Data.devices.forEach(function (dev) {
    var elem = d3.select('[data-deviceId="' + dev.deviceId + '"]');
    elem.each(function (d) {
      if (PlannerGlobals.symbols_on || PlannerGlobals.notes_on) {
        drawDevSymbolForDev(d, this);
      }
      redrawQuantityBadgeForDev(d, this);
    });
  });

  // rotate height text if needed
  if (d3Data.id || d3Data.connId) {
    const normalizedAngle = uMath.normalizeAngle(d3Data.angle);
    const textRotation = normalizedAngle > 91 && normalizedAngle < 269 ? 180 : 0;
    d3.select(devElem).selectAll('.height-txt').each(function () {
      const d3This = d3.select(this);
      const bbox = d3This.node().getBBox();
      const rotateCenter = {
        x: bbox.x + bbox.width / 2,
        y: bbox.y + bbox.height / 2
      }
      d3This.attr('transform', `rotate(${textRotation} ${rotateCenter.x} ${rotateCenter.y})`);
    });
  }
}
export function filterInvalidDevices() {

  var toDel = [];
  PlannerGlobals.devices = PlannerGlobals.devices.filter(function (dev) {
    var room = getRoomById(dev.roomId);
    if (!room) {
      toDel.push(dev);
      return true;
      /* return false; */
    }
    var roomPoly = XYtoNumPoly(room.poly);
    var topLeft = uDev.getTopLeftOfDevice_NoDOM(dev.deviceId);
    var devPts = XYtoNumPoly(uDev.deviceAllPts(topLeft, dev.rotate_value));
    if (uMath.polyDoesntContainAnyPoint(roomPoly, devPts)) {
      // DEBUG
      if (doesDeviceFitRoom(uDev.OUTDOORS_ROOM_ID, topLeft, dev.rotate_value, 1)) {
        dev.roomId = uDev.OUTDOORS_ROOM_ID;
      }
      // DEBUG
      else {
        toDel.push(dev);
        return true;
        /* return false; */
      }
    }
    return true;
  });
  if (toDel.length) {
    console.log('these are invalid devs:', toDel);
  }
}

export const DEV_SIZE_ROOT = 10;
export const DEV_SIZE_MIN = 8;
export const DEV_SIZE_MAX = 65;

export function pureRecalcDevSize() {
  var pxlen = typeof PlannerGlobals.LENGTHOF1PX != 'undefined' && PlannerGlobals.LENGTHOF1PX ? PlannerGlobals.LENGTHOF1PX : 1;
  var modval = 1 / pxlen;

  BASE_DEVICE_SIZE = DEV_SIZE_ROOT * modval;
  if (BASE_DEVICE_SIZE < DEV_SIZE_MIN) {
    BASE_DEVICE_SIZE = DEV_SIZE_MIN
  }
  else if (BASE_DEVICE_SIZE > DEV_SIZE_MAX) {
    BASE_DEVICE_SIZE = DEV_SIZE_MAX;
  }
  PlannerGlobals.sizeErrorHelper.moddingTo = PlannerGlobals.DEVICE_SIZE_MOD;

  PlannerGlobals.DEVICE_SIZE = BASE_DEVICE_SIZE * PlannerGlobals.DEVICE_SIZE_MOD / 100;
  if (PlannerGlobals.DEVICE_SIZE < 2) {
    PlannerGlobals.DEVICE_SIZE = 2;
  }
  else if (PlannerGlobals.DEVICE_SIZE > 100) {
    PlannerGlobals.DEVICE_SIZE = 100;
  }
}

export function changeDrawnDevSizeAfterResize(mod, nocheck, callback) {
  if (!mod) {
    console.warn('received bad devsize, set to 100', mod);
    mod = 100;
  }
  const oldSize = PlannerGlobals.DEVICE_SIZE
  const prevSizeMod = PlannerGlobals.DEVICE_SIZE_MOD
  PlannerGlobals.DEVICE_SIZE_MOD = mod;
  PlannerGlobals.DEVICE_SIZE = BASE_DEVICE_SIZE * PlannerGlobals.DEVICE_SIZE_MOD / 100;
  if (PlannerGlobals.DEVICE_SIZE < 2) {
    PlannerGlobals.DEVICE_SIZE = 2;
  }
  else if (PlannerGlobals.DEVICE_SIZE > 100) {
    PlannerGlobals.DEVICE_SIZE = 100;
  }



  DEBUG_updateNSend( prevSizeMod, PlannerGlobals.DEVICE_SIZE_MOD, PlannerGlobals.DEVICE_SIZE, oldSize)

  if (!nocheck) {
    afterDevSizeMod(callback);
  }
  else {
    if (typeof callback === "function") {
      callback();
    }
  }

}

export function recalcBaseDevSize() {
  unHighlight();
  var pxlen = typeof PlannerGlobals.LENGTHOF1PX != 'undefined' && PlannerGlobals.LENGTHOF1PX ? PlannerGlobals.LENGTHOF1PX : 1;
  var modval = 1 / pxlen;

  BASE_DEVICE_SIZE = DEV_SIZE_ROOT * modval;
  if (BASE_DEVICE_SIZE < DEV_SIZE_MIN) {
    BASE_DEVICE_SIZE = DEV_SIZE_MIN
  }
  else if (BASE_DEVICE_SIZE > DEV_SIZE_MAX) {
    BASE_DEVICE_SIZE = DEV_SIZE_MAX;
  }
  changeDrawnDevSize(PlannerGlobals.DEVICE_SIZE_MOD);
}

export function changeDrawnDevSize(mod, nocheck, callback) {
  if (!mod) {
    console.warn('received bad devsize, set to 100', mod);
    mod = 100;
  }
  PlannerGlobals.DEVICE_SIZE_MOD = mod;
  PlannerGlobals.DEVICE_SIZE = BASE_DEVICE_SIZE * PlannerGlobals.DEVICE_SIZE_MOD / 100;
  if (PlannerGlobals.DEVICE_SIZE < 2) {
    PlannerGlobals.DEVICE_SIZE = 2;
  }
  else if (PlannerGlobals.DEVICE_SIZE > 100) {
    PlannerGlobals.DEVICE_SIZE = 100;
  }
  redrawDevices(true);


  if (!nocheck) {
    afterDevSizeMod(callback);
  }
  else {
    if (typeof callback === "function") {
      callback();
    }
  }

}

export function afterDevSizeMod(callback) {
  checkTooBigDevices(false, callback, true);
  redrawMeasurements();
}

export function resetSizeErrorHelper() {
  PlannerGlobals.sizeErrorHelper = {
    errorCorrectMode: false,
    badFromBeginning: false,
    endCallback: null,
    problemDevices: {},
    normalModdedDevices: {},
    lastGoodRatioPoints: {},
    lastGoodLengthOf1Px: 0,
    lastGoodScaleMod: 0,
    moddingTo: 0,
    alldevs: [],
    devBackup: [],
    userZoomed: false
  }
}

export function getDeviceUniqueId(d) {
  if (!d.id) {
    var dev = d.devices[0];
    return 'dev_' + dev.deviceId;
  }
  else {
    return 'ser_' + d.id;
  }
}

export function refreshDArray(array) {
  var devs = getDevicesD3Style();
  for (var i = 0; i < devs.length; i++) {
    var idx = getDeviceUniqueId(devs[i]);
    if (idx in array) {
      var hadError = array[idx].hasProblem;
      array[idx] = devs[i];
      array[idx].hasProblem = hadError;
    }
  }
}

export function addProblemDevice(d) {
  var t = PlannerGlobals.sizeErrorHelper.problemDevices;
  var idx = getDeviceUniqueId(d);
  /* if (!(idx in t)) { */
  t[idx] = d;
  t[idx].hasProblem = true;
  /* } */
}
export function problemDevsCount() {
  var count = 0;
  for (var i in PlannerGlobals.sizeErrorHelper.problemDevices) {
    if (PlannerGlobals.sizeErrorHelper.problemDevices[i].hasProblem) {
      count++;
    }
  }
  return count;
}
export function removeProblemDevice(d) {
  var t = PlannerGlobals.sizeErrorHelper.problemDevices;
  var idx = getDeviceUniqueId(d);
  if (idx in t) {
    t[idx].hasProblem = false;
  }
}

export function isInProblemDevices(d) {
  var t = PlannerGlobals.sizeErrorHelper.problemDevices;
  var idx = getDeviceUniqueId(d);
  return idx in t;
}

export function addNormalModdedDev(d) {
  var idx = getDeviceUniqueId(d);
  PlannerGlobals.sizeErrorHelper.normalModdedDevices[idx] = d;
}

export function areProblemsFixed() {
  var t = PlannerGlobals.sizeErrorHelper.problemDevices;
  for (var i in t) {
    if (t[i].hasProblem) {
      return false;
    }
  }
  return true;
}

export function sendAllProblemDevs() {
  var t = PlannerGlobals.sizeErrorHelper.problemDevices;
  for (var i in t) {
    PUTDevData(t[i]);
  }
  t = PlannerGlobals.sizeErrorHelper.normalModdedDevices;
  for (var i in t) {
    PUTDevData(t[i]);
  }
}

export function sendNewSize(callback) {
  if (PlannerGlobals.DEVICE_SIZE_MOD == PlannerGlobals.DEVICE_SIZE_MOD_SERVER) {
    if (typeof callback === "function") {
      callback(true);
    }
    return;
  }
  getAuthHeader(function (header) {
    $.ajax({
      headers: header,
      url: ROOT_URI + '/floor/update-icon-size',
      method: 'post',
      data: {
        floor_id: PlannerGlobals.plannerFloorId,
        icon_size: PlannerGlobals.DEVICE_SIZE_MOD
      },
      success: function () {
        PlannerGlobals.DEVICE_SIZE_MOD_SERVER = PlannerGlobals.DEVICE_SIZE_MOD;
        PlannerGlobals.lastGoodScaleMod = PlannerGlobals.DEVICE_SIZE_MOD;
        if (typeof callback === "function") {
          callback(true);
        }
      },
      error: function (resp) {
        genericXHRErrorHandler(resp);
        if (typeof callback === "function") {
          callback(false);
        }
      }
    });
  });
}

export function enderrorCorrectMode() {
  const wssd = PlannerGlobals.wallSegmentation.getSaveData();
  PlannerGlobals.sizeErrorHelper.errorCorrectMode = false;
  sendAllProblemDevs();
  sendNewSize();
  saveProportionRelatedProps();

  var mergedMoveds = $.extend({}, PlannerGlobals.sizeErrorHelper.normalModdedDevices, PlannerGlobals.sizeErrorHelper.problemDevices);
  if (!PlannerGlobals.sizeErrorHelper.badFromBeginning) {
    var action = new ModifyScaleErrorAction(PlannerGlobals.sizeErrorHelper.lastGoodScaleMod, PlannerGlobals.DEVICE_SIZE_MOD,
        PlannerGlobals.sizeErrorHelper.lastGoodRatioPoints, PlannerGlobals.sizeErrorHelper.lastGoodLengthOf1Px,
        PlannerGlobals.lastRatioPoints, PlannerGlobals.LENGTHOF1PX,
        PlannerGlobals.sizeErrorHelper.devBackup, mergedMoveds, wssd);
    PlannerGlobals.plannerHistoryManager.addHistoryEntry(action);
    PlannerGlobals.wallSegmentation.recalcPreserveSave(wssd);
  }

  resetSizeErrorHelper();
  $('#show-next-bad-btn').addClass('hidden');
  $("#reset-center-btn").click();
  PlannerGlobals.plannerHistoryManager.handleButtonClasses();
  showActualSizeBtn();
  toastRemoveAll();
  if (!PlannerGlobals.lastCalculatedOuterWall) {
    instantCalcOuter();
  }
  toastSuccess(ts('p_err_resolved', "Errors resolved. Saving new size!"));
}

export function undoErrorCorrectMode() {
  PlannerGlobals.sizeErrorHelper.errorCorrectMode = false;
  if (!PlannerGlobals.lastGoodScaleMod) {
    console.warn('received bad devsize, set to 100', PlannerGlobals.lastGoodScaleMod);
    PlannerGlobals.lastGoodScaleMod = 100;
  }
  PlannerGlobals.DEVICE_SIZE_MOD = PlannerGlobals.lastGoodScaleMod;
  restoreDevPositionBackup();
  wallSelectToLastGood();
  redrawDevices();
  toastRemoveAll();
  resetSizeErrorHelper();
  $('#show-next-bad-btn').addClass('hidden');
  PlannerGlobals.plannerHistoryManager.handleButtonClasses();
  showActualSizeBtn();
}

export function cancelerrorCorrectMode() {
  undoErrorCorrectMode();
  toastInfo(ts('p_snapped_back', "Unresolved changes detected, devices returned to their original positions!"));
  $("#reset-center-btn").click();
}

export function backupDevPositions() {
  PlannerGlobals.sizeErrorHelper.devBackup = [];
  var t = PlannerGlobals.sizeErrorHelper.devBackup;
  var toBackup = ['deviceId', 'x', 'y', 'angle', 'roomId', 'rotate_value'];
  for (var i in PlannerGlobals.devices) {
    var device = PlannerGlobals.devices[i];
    var backup = {};
    for (var j in toBackup) {
      var prop = toBackup[j];
      backup[prop] = device[prop];
    }
    t.push(backup);
  }
}

export function restoreDevPositionBackup() {
  var t = PlannerGlobals.sizeErrorHelper.devBackup;
  for (var i in t) {
    var backup = t[i];
    var targetDev = getDeviceById(backup.deviceId);
    if (targetDev) {
      for (var j in backup) {
        targetDev[j] = backup[j];
      }
    }
  }
}

export function checkTooBigDevices(silent, callback, autoFit = true) {
  var wasError = false;
  if (!PlannerGlobals.sizeErrorHelper.errorCorrectMode) {
    PlannerGlobals.sizeErrorHelper.userZoomed = false;
    PlannerGlobals.sizeErrorHelper.problemDevices = {};
    PlannerGlobals.sizeErrorHelper.normalModdedDevices = {};
    backupDevPositions();
  }
  PlannerGlobals.sizeErrorHelper.alldevs = getDevicesD3Style();
  for (var i = 0; i < PlannerGlobals.sizeErrorHelper.alldevs.length; i++) {
    var doesFit = isDeviceInIntendedRoom(PlannerGlobals.sizeErrorHelper.alldevs[i]);

    if (!doesFit && autoFit) { // try to autofit the device by snapping to a wall

      const point = {
        x: PlannerGlobals.sizeErrorHelper.alldevs[i].x,
        y: PlannerGlobals.sizeErrorHelper.alldevs[i].y,
        wallId: isD3DevSnapped(PlannerGlobals.sizeErrorHelper.alldevs[i], true) // returns wallId when already snaps
      }
      const addCenter = PlannerGlobals.sizeErrorHelper.alldevs[i].devices.length == 1; // false for serials
      var snappedPos = snapDeviceToWall(point, PlannerGlobals.DEVICE_SIZE * 1.5, PlannerGlobals.sizeErrorHelper.alldevs[i].devices.length, addCenter);

      if (!snappedPos) {
        console.log('Failed to autoFit: snapDeviceToWall without result for device', PlannerGlobals.sizeErrorHelper.alldevs[i], PlannerGlobals.DEVICE_SIZE);
        break;
      }
      var moveBy = {
        x: snappedPos.point.x - PlannerGlobals.sizeErrorHelper.alldevs[i].x,
        y: snappedPos.point.y - PlannerGlobals.sizeErrorHelper.alldevs[i].y
      }

      PlannerGlobals.sizeErrorHelper.alldevs[i].x += moveBy.x;
      PlannerGlobals.sizeErrorHelper.alldevs[i].y += moveBy.y;
      PlannerGlobals.sizeErrorHelper.alldevs[i].roomId = snappedPos.room.id;

      for(var j = 0; j < PlannerGlobals.sizeErrorHelper.alldevs[i].devices.length; j++) {
        PlannerGlobals.sizeErrorHelper.alldevs[i].devices[j].x += moveBy.x;
        PlannerGlobals.sizeErrorHelper.alldevs[i].devices[j].y += moveBy.y;
        PlannerGlobals.sizeErrorHelper.alldevs[i].devices[j].roomId = snappedPos.room.id;
        updateDev(PlannerGlobals.sizeErrorHelper.alldevs[i].devices[j]);
        redrawDevice(PlannerGlobals.sizeErrorHelper.alldevs[i].devices[j].deviceId);
      }

      // check again
      doesFit = isDeviceInIntendedRoom(PlannerGlobals.sizeErrorHelper.alldevs[i]);
    }
    if (!doesFit) {
      addErrorMarker(PlannerGlobals.sizeErrorHelper.alldevs[i]);
      addProblemDevice(PlannerGlobals.sizeErrorHelper.alldevs[i]);
      wasError = true;
    } else {
      PlannerGlobals.sizeErrorHelper.alldevs[i].hasProblem = false;
    }
  }
  if (wasError) {
    PlannerGlobals.sizeErrorHelper.errorCorrectMode = true;
    $('#planner-undo-btn').removeClass('planner-button-disabled');
    if (!silent && !PlannerGlobals.isInQuote) {
      toastRemoveAll();
      toastError(ts('p_adjust_red_please', "You need to adjust the devices marked with red to save the new size."));
      highlightNextProblematic();
    }
  } else {
    sendNewSize(callback);
    resetSizeErrorHelper();
  }
}


export function checkDeviceSizePermission(callback) {
  if (typeof callback === "function") {
    getAuthHeader(function (header) {
      $.ajax({
        headers: header,
        url: ROOT_URI + '/floor/update-icon-size',
        method: 'post',
        data: {
          floor_id: PlannerGlobals.plannerFloorId,
          icon_size: PlannerGlobals.DEVICE_SIZE_MOD_SERVER
        },
        success: function () {
          callback(true);
        },
        error: function (resp) {
          genericXHRErrorHandler(resp);
          callback(false);
        }
      });
    });
  }
}

export function toggleDeviceSize() {
  if (PlannerGlobals.mode.indexOf("wallSelect") == 0) {
    return;
  }
  else if (typeof PlannerGlobals.plannerHistoryManager !== "undefined" && PlannerGlobals.plannerHistoryManager.busy) {
    return ts("p_history_busy", "Please wait, another operation is in progress.");
  }

  if (PlannerGlobals.mode == 'wificalc' || isMotionSensorMode()) {
    setMode.basic();
  }

  var prevSize = PlannerGlobals.DEVICE_SIZE_MOD;
  if (!prevSize) {
    console.warn('received bad devsize, set to 100', prevSize);
    prevSize = 100;
  }
  var nextSize = PlannerGlobals.DEVICE_SIZE_MODS[PlannerGlobals.DEVICE_SIZE_MOD].next;
  PlannerGlobals.DEVICE_SIZE_MOD = nextSize;
  showActualSizeBtn();
  if (PlannerGlobals.setSizeTimeout) {
    clearTimeout(PlannerGlobals.setSizeTimeout);
  }
  PlannerGlobals.setSizeTimeout = setTimeout(function () {
    checkDeviceSizePermission(function (res) {
      if (res) {
        hideRotateAndDeviceTools();

        if (PlannerGlobals.sizeErrorHelper.errorCorrectMode && !areProblemsFixed()) {
          cancelerrorCorrectMode();
        }

        PlannerGlobals.lastGoodLengthOf1Px = PlannerGlobals.LENGTHOF1PX;
        PlannerGlobals.lastGoodRatioPoints = $.extend(true, {}, PlannerGlobals.serverConfirmedRatioPoints);

        PlannerGlobals.sizeErrorHelper.lastGoodScaleMod = PlannerGlobals.lastGoodScaleMod;
        PlannerGlobals.sizeErrorHelper.lastGoodRatioPoints = $.extend(true, {}, PlannerGlobals.serverConfirmedRatioPoints);
        PlannerGlobals.sizeErrorHelper.lastGoodLengthOf1Px = PlannerGlobals.lastGoodLengthOf1Px;

        PlannerGlobals.sizeErrorHelper.moddingTo = nextSize;
        PlannerGlobals.DEVICE_SIZE_MOD = nextSize;

        // changeDrawnDevSize(nextSize);
        changeDrawnDevSizeAfterResize(nextSize)

        if (!PlannerGlobals.sizeErrorHelper.errorCorrectMode) {
          var action = new ModifyDevSizeNoErrorAction(PlannerGlobals.lastGoodScaleMod, nextSize);
          PlannerGlobals.plannerHistoryManager.addHistoryEntry(action);
        }

        showActualSizeBtn();
      }
      else {
        PlannerGlobals.DEVICE_SIZE_MOD = PlannerGlobals.DEVICE_SIZE_MOD_SERVER;
        showActualSizeBtn();
      }
    });
  }, 350);
}

export function setDeviceSize(modsize, callback) {
  if (PlannerGlobals.sizeErrorHelper.errorCorrectMode && !areProblemsFixed()) {
    cancelerrorCorrectMode();
  }
  var nextSize = modsize || 100;
  $('[id^="planner-devsize"]').hide();
  $('#planner-devsize-' + PlannerGlobals.DEVICE_SIZE_MODS[modsize].btn).show();
  changeDrawnDevSize(nextSize, false, callback);
}

/**
 *
 * @param {D3Device} d
 * @param {number} angle
 */
export function rotateD3Dev(d, angle, callback, errorCallback) {
  d.angle = angle;
  d.devices.forEach(function (dev) {
    dev.angle = angle;
  });
  PUTDevData(d, undefined, callback, errorCallback);
}

/**
 * termék poligon (4 sarkának a kordinátája)
 *
 * @param d
 * @param shrinkPcnt
 * @returns {{x: number, y: number}[]}
 */
export function getDeviceCoordinates(d, shrinkPcnt = 0) {

  const shrinkVal = PlannerGlobals.DEVICE_SIZE * shrinkPcnt;

  const x = d.x + shrinkVal;
  const y = d.y + shrinkVal;
  const angle = d.angle;

  const cols = getDColsNum(d);
  const rows = getDRowsNum(d);
  const width = cols * PlannerGlobals.DEVICE_SIZE + (cols - 1) * SERIAL_SPACING - shrinkVal * 2;
  const height = rows * PlannerGlobals.DEVICE_SIZE + (rows - 1) * SERIAL_SPACING - shrinkVal * 2;
  const center = {
    x: x + width / 2,
    y: y + height / 2
  };

  let pts = [
    { x: x, y: y },
    { x: x + width, y: y },
    { x: x + width, y: y + height },
    { x: x, y: y + height },
  ];

  return pts.map(pt => rotatePointAroundAnotherXY(pt, center, angle));
}


/**
 *
 * @param {boolean} noInstantRefresh
 * @param {function} callback
 */
export function PUTDevData(d, noInstantRefresh = false, callback = null, errorCallback = null) {
  if (PlannerGlobals.sizeErrorHelper.errorCorrectMode) {
    return;
  }

  var promises = [];
  var devArr = d.devices;
  if (d.id) {
    devArr = getSerialById(d.id).deviceIds.map(getDeviceById);
  }
  else if (d.connId) {
    devArr = d.serials.reduce((p, c) => p.concat(c.deviceIds), []).map(getDeviceById);
  }
  for (var i = 0; i < devArr.length; i++) {
    devArr[i].roomId = d.roomId;
    getAuthHeader(function (header) {
      var isCabinet = 'type' in devArr[0] && devArr[0].type.toString().indexOf("cabinet") != -1;
      var isCustom = devArr[0].deviceId.toString().indexOf("C_") == 0;
      var sendData = {
        x: d.x,
        y: d.y,
        room_id: d.roomId,
        plan_object_id: devArr[i].deviceId,
        rotate_value: d.id ? d.angle : devArr[0].angle,
      }

      // ha rádobjuk egy mási keszközre
      const merge = getMergedDevice(devArr[i]);
      if (merge !== null) {
        sendData.merged_device_id = merge.deviceId;
      }

      var sendUrl = ROOT_URI + '/device';

      if (isCabinet) {
        sendUrl = ROOT_URI + '/floor/additional-item';
        delete sendData.plan_object_id;
        sendData.additional_item_id = devArr[0].deviceId.toString().replace('S_', '');
        sendData.item_type = devArr[0].item_type;
      }

      if (isCustom) {
        sendUrl = ROOT_URI + "/user-custom-items/room-user-custom-item";
        delete sendData.plan_object_id;
        sendData.room_user_custom_item_id = devArr[0].deviceId.toString().replace("C_", "");
        sendData.user_custom_item_id = devArr[0].user_custom_item_id;
        sendData.item_type = 'custom'
      }

      // TODO: REMOVE THIS AFTER UNASSIGNED AJAX
      /* if (sendData.room_id == uDev.UNASSIGNED_ROOM_ID) {
                console.debug('DEBUG: Replaced unassigned room id with outdoor room id');
                sendData.room_id = uDev.OUTDOORS_ROOM_ID;
            } */

      promises.push($.ajax({
        headers: header,
        url: sendUrl,
        type: 'PUT',
        data: sendData,
        success: function (response) {
          var ser = getSerialById(d.id);
          if (ser) {
            ser.angle = d.id ? d.angle : devArr[0].angle;
          }

          if (response.merged_device) {
            PlannerGlobals.mergedDevice = response.merged_device
          }
          redrawDevices()
        },
        error: function (response) {
          snapCurrDeviceBack(d);
          if (d.id) {
            d.angle = rotateMeDevOrigiAngle || 0;
          } else {
            devArr[0].angle = rotateMeDevOrigiAngle || 0;
          }
          redrawDevices();
          if (response.responseJSON && response.responseJSON.message) {
            toastError(response.responseJSON.message);
          }
        }
      }));
    });
  }

  if (!noInstantRefresh) {
    redrawGroups();
  }

  $.when.apply($, promises)
  .done(function () {
    if (!noInstantRefresh) {
      refreshFloorView();
    }
    if (typeof callback == "function") {
      callback();
    }
  })
  .fail(function () {
    if (typeof errorCallback === "function") {
      errorCallback();
    }
  });
}

export function getXYCorrig() {
  var widthCorr = PlannerGlobals.DEVICE_SIZE / 2;
  var x = (PlannerGlobals.XY[0] - PlannerGlobals.translatevar[0]) / PlannerGlobals.scalevar - widthCorr;
  var y = (PlannerGlobals.XY[1] - PlannerGlobals.translatevar[1]) / PlannerGlobals.scalevar - widthCorr;
  return [x, y];
}

/**
 * @returns {number[]}
 */
export function getXY() {
  var x = (PlannerGlobals.XY[0] - PlannerGlobals.translatevar[0]) / PlannerGlobals.scalevar;
  var y = (PlannerGlobals.XY[1] - PlannerGlobals.translatevar[1]) / PlannerGlobals.scalevar;
  return [x, y];
}

/**
 * @returns {Point}
 */
export function getXYP() {
  var xy = getXY();
  return { x: xy[0], y: xy[1] };
}

// d3-drag suppresses the SVG mousemove during a gesture, so refresh XY from the drag event
export function updateDragXY(event) {
  if (event && event.sourceEvent && PlannerGlobals.svg) {
    PlannerGlobals.XY = d3.pointer(event.sourceEvent, PlannerGlobals.svg.node());
  }
}

export function closePolygon(points) {
  // check if the currently made room contains another room
  if (roomContainsAnother(points)) {
    toastInfo(ts('contain_err', 'containErr'));
    return;
  }

  // if room is fine, add it
  addRoom(points);
  points.splice(0);

  // the newly made room is gonna have id -1, select it for naming and sending to server
  setMode.prepareSelect();
  selectRoom(-1);
}

export function closePolygonOuter(points) {
  const wssd = PlannerGlobals.wallSegmentation.getSaveDataV2();
  saveOuterWalls(points, function () {
    var action = new CreateOuterWallsAction(PlannerGlobals.outerBorder, wssd);
    PlannerGlobals.plannerHistoryManager.addHistoryEntry(action);
    PlannerGlobals.wallSegmentation.recalcPreserveSave(wssd);
  });
  points.splice(0);
  setMode.basic();
}

export function redrawDrawcircles() {
  PlannerGlobals.svg.selectAll('.drawCircle').remove();

  if (PlannerGlobals.drawRoomPoints.length > 0) {
    PlannerGlobals.g.append('circle')
      .attr('class', 'drawCircle')
      .attr('cx', PlannerGlobals.drawRoomPoints[0][0])
      .attr('cy', PlannerGlobals.drawRoomPoints[0][1])
      .attr('r', PlannerGlobals.DRAW_CIRCLE_R / PlannerGlobals.scalevar)
      .attr('fill', '#ddd')
      .attr('stroke', '#000')
      .attr('is-handle', 'true')
      .attr('stroke-width', PlannerGlobals.DRAW_CIRCLE_STROKE_WIDTH / PlannerGlobals.scalevar)
      .style('cursor', 'pointer');
  }

  for (var i = 1; i < PlannerGlobals.drawRoomPoints.length; i++) {
    PlannerGlobals.g.append('circle')
      .attr('class', 'drawCircle')
      .attr('cx', PlannerGlobals.drawRoomPoints[i][0])
      .attr('cy', PlannerGlobals.drawRoomPoints[i][1])
      .attr('r', PlannerGlobals.DRAW_CIRCLE_R / PlannerGlobals.scalevar)
      .attr('fill', '#fff')
      .attr('stroke', '#000')
      .attr('stroke-width', PlannerGlobals.DRAW_CIRCLE_STROKE_WIDTH / PlannerGlobals.scalevar)
      .style('cursor', 'default');
  }
}
/**
 * Returns only those devs that are intersected by the room since we can use Unassigned room for left outs now
 * @returns {Device[]}
 */
export function leftOutDevicesV2() {
  if (!PlannerGlobals.modifiedPoly || !PlannerGlobals.modifiedRoom) {
    return [];
  }

  var lod = [];

  const datas = getDevicesD3Style().map(dev => dataFromDeviceD(dev));
  datas.forEach(devData => {
    const devPts = getDeviceRealPoints(devData.point, devData.rotation, devData.serialLength, devData.serialRows);
    if (devAndPolyIntersects(devPts, XYto2DArr(PlannerGlobals.modifiedPoly))) {
      lod = lod.concat(uDevDOM.devicesOfD3D(devData.original));
    }
  });

  return lod;
}

const PLANNER_BOTTOM_GAP_PX = 10;

function getScrollParent(el) {
  for (let node = el.parentElement; node; node = node.parentElement) {
    const overflowY = getComputedStyle(node).overflowY;
    if (overflowY === 'auto' || overflowY === 'scroll') {
      return node;
    }
  }
  return null;
}

export function plannerCanvasHeight() {
  const container = document.getElementById('svgAndChat');
  if (!container) {
    return window.innerHeight;
  }
  const top = container.getBoundingClientRect().top;
  const scrollParent = getScrollParent(container);
  let bottom = window.innerHeight;
  if (scrollParent) {
    const rect = scrollParent.getBoundingClientRect();
    const paddingBottom = parseFloat(getComputedStyle(scrollParent).paddingBottom) || 0;
    bottom = rect.bottom - paddingBottom;
  }
  return bottom - top - PLANNER_BOTTOM_GAP_PX;
}

export function adjustCenter() {
  d3.select('#plannerSVG').attr('height', plannerCanvasHeight());
}

export function isPointOnPreviousSegments(points, currXY) {
  if (points.length < 2) {
    return false;
  }
  else {
    var polyLine = uMath.polyLineToSegments(NumToXYPoly(points));
    for (var segment of polyLine) {
      if (isPointOnSegment(P_numtoxy(currXY), segment)) {
        return true;
      }
    }
  }
  return false;
}

export function isPointAvailable(point) {
  if (point[0] < 0 || point[1] < 0 || point[0] > 900 || point[1] > 900) {
    return false;
  }
  //is point available
  var ava = true;
  //go through each room
  PlannerGlobals.rooms.forEach(function (room) {
    //get their format in [[x,y],...]
    var roomPoly = XYtoNumPoly(room.poly);
    //try to find a room that contains the ending point
    if (d3.polygonContains(roomPoly, point)) {
      ava = false;
      return false;
    }
  });
  return ava;
}

export function isPointSimilarToLast(points, lastPoint) {
  if (!points.length) {
    return false;
  }
  return uMath.pointDistance(P_numtoxy(points[points.length - 1]), P_numtoxy(lastPoint)) < 0.2;
}

let roomLines = [];

export function AnyLineIntersectsARoom(points, XY) {
  roomLines = [];
  //if there are no other points yet, we can be sure there is no intersection
  if (points.length < 1) {
    return false;
  } else {
    //we always only check the current room's last line, since we checked the previous ones already with this function
    var lastLine = {
      x1: points[points.length - 1][0],
      y1: points[points.length - 1][1],
      x2: XY[0],
      y2: XY[1]
    };
    //going through all rooms
    for (var i = 0; i < PlannerGlobals.rooms.length; i++) {
      //converting the polygons to line_line_intersect's format {x1, x2, y1, y2}
      for (var j = 1; j < PlannerGlobals.rooms[i].poly.length; j++) {
        roomLines.push({
          x1: PlannerGlobals.rooms[i].poly[j - 1].x,
          y1: PlannerGlobals.rooms[i].poly[j - 1].y,
          x2: PlannerGlobals.rooms[i].poly[j].x,
          y2: PlannerGlobals.rooms[i].poly[j].y
        });
      }
      //we have to add the line between the first and last point too
      roomLines.push({
        x1: PlannerGlobals.rooms[i].poly[0].x,
        y1: PlannerGlobals.rooms[i].poly[0].y,
        x2: PlannerGlobals.rooms[i].poly[PlannerGlobals.rooms[i].poly.length - 1].x,
        y2: PlannerGlobals.rooms[i].poly[PlannerGlobals.rooms[i].poly.length - 1].y
      })
    }
    if (uDev.outerBorderExists() && (PlannerGlobals.mode == 'drawing' || PlannerGlobals.mode == 'selectRoom')) {
      roomLines = roomLines.concat(uMath.segmentsFromPointArray(PlannerGlobals.outerBorder));
    }
    //check if the new room's last line intersects any of the rooms' lines
    for (var i = 0; i < roomLines.length; i++) {
      var result = line_line_intersect(roomLines[i], lastLine);
      if (result != 'nir') {
        //immediately return true if an intersection is detected
        return true;
      }
    }
  }
  return false;
}

export function AnyLineIntersectsSelf(points, XY) {
  //adding together the current points, and the point to be placed
  var allPoints = points.concat([XY]);
  var lines = [];
  var lastLine = {};
  //if there are only 2 points, no intersection can occur
  if (allPoints.length < 3) {
    return false;
  } else {
    //the last line, that we have to check for intersections (we don't have to check the others, since they were already checked by this function)
    lastLine = {
      x1: points[points.length - 1][0],
      y1: points[points.length - 1][1],
      x2: XY[0],
      y2: XY[1]
    };
    //convert the lines to line_line_intersect's format {x1, x2, y1, y2}
    for (var i = 1; i < points.length; i++) {
      lines.push({
        x1: points[i - 1][0],
        y1: points[i - 1][1],
        x2: points[i][0],
        y2: points[i][1]
      })
    }
    for (var i = 0; i < lines.length - 1; i++) {
      var result = line_line_intersect(lines[i], lastLine);
      if (result != 'nir') {
        return true;
      }
    }
  }
  return false;
}

export function roomContainsAnother(points) {
  /**
   * a polygon contains another IF none of their lines intersect, AND any of the inner's polygon's points are inside the outer polygon
   * at the point this function is called, we can be sure that none of the lines intersect overall, since we checked that earlier.
   * now we only need to check if any of the rooms' first points are inside the to-be-made room
   */
  for (var i = 0; i < PlannerGlobals.rooms.length; i++) {
    var roomFirstPointXY = PlannerGlobals.rooms[i].poly[0];
    var roomFirstPointNorm = [roomFirstPointXY.x, roomFirstPointXY.y];
    if (d3.polygonContains(points, roomFirstPointNorm)) {
      return true;
    }
  }
  return false;
}

export function Line(x1, y1, x2, y2) {
  this.x1 = x1;
  this.y1 = y1;
  this.x2 = x2;
  this.y2 = y2;
}

/**
 * Converts a room to its lines' array
 * @param {Room} room
 * @returns {Line[]}
 */
export function getRoomLines(room) {
  var lines = [];
  for (var i = 1; i < room.poly.length; i++) {
    //current point
    var cpt = room.poly[i];
    //prev point
    var ppt = room.poly[i - 1];
    lines.push(new Line(cpt.x, cpt.y, ppt.x, ppt.y));
  }
  var fpt = room.poly[0];
  var lpt = room.poly[room.poly.length - 1];
  lines.push(new Line(lpt.x, lpt.y, fpt.x, fpt.y));
  return lines;
}

export function AnyLineIntersectsSelfMod() {
  var roomLines = getRoomLines(PlannerGlobals.modifiedRoom);
  for (var i = 0; i < roomLines.length; i++) {
    for (var j = 0; j < roomLines.length; j++) {
      if (j == i || j == (i + 1) % roomLines.length || j == (i + roomLines.length - 1) % roomLines.length) {
        continue;
      } else {
        var result = line_line_intersect(roomLines[i], roomLines[j]);
        if (result != 'nir') {
          return true;
        }
      }
    }
  }
  return false;
}

export function AnyLineIntersectsARoomMod() {
  var selfRoomLines = getRoomLines(PlannerGlobals.modifiedRoom);

  var roomLines = [];
  for (var i = 0; i < PlannerGlobals.rooms.length; i++) {
    roomLines = roomLines.concat(getRoomLines(PlannerGlobals.rooms[i]));
  }
  if (uDev.outerBorderExists() && (PlannerGlobals.mode == 'drawing' || PlannerGlobals.mode == 'selectRoom')) {
    roomLines = roomLines.concat(uMath.segmentsFromPointArray(PlannerGlobals.outerBorder).filter(function (line) { line.borderLine = true; return true; }));
  }
  for (var i = 0; i < selfRoomLines.length; i++) {
    for (var j = 0; j < roomLines.length; j++) {
      var result = line_line_intersect(selfRoomLines[i], roomLines[j]);
      if (result != 'nir') {
        return { result: true, wasBorder: !!roomLines[j].borderLine };
      }
    }
  }

  return false;
}

export function isNumArr(variable) {
  return variable && $.isNumeric(variable[0]) && $.isNumeric(variable[1]);
}

export function hasUserMovedMouse(dist = 1) {
  var currPageXY = { x: PAGEXY.x, y: PAGEXY.y };
  if (PlannerGlobals.mouseDownPageXY && uMath.pointDistance(PlannerGlobals.mouseDownPageXY, currPageXY) > dist) {
    return true;
  }
  return false;
}

export function hasUserDraggedPlanner(dist = 5) {
  var t = d3.zoomTransform(PlannerGlobals.svg.node());
  var trans = [t.x, t.y];
  if (isNumArr(trans) && isNumArr(PlannerGlobals.mouseDownTranslate) &&
      uMath.pointDistance(P_numtoxy(trans), P_numtoxy(PlannerGlobals.mouseDownTranslate)) > dist * PlannerGlobals.scalevar) {
    return true;
  }
  return false;
}

//putting down a circle while drawing
export function putDrawCircle(e) {
  if (ControllerGlobals.currentlyDraggedDevice || PlannerGlobals.isDragging || !PlannerGlobals.isDrawing || !(!e || e.which == 1 || e.type == 'touchend')) return;
  if (hasUserDraggedPlanner(5)) {
    return;
  }
  if (e && e.type == 'touchend') {
    var touch = e.changedTouches[0];
    var offset = $('#plannerSVG').offset();
    var svgXY = [touch.pageX - offset.left, touch.pageY - offset.top];
    PlannerGlobals.XY = svgXY;
  }
  var currXY = getXY();
  if (!MODKEYS_STATE.shift && PlannerGlobals.drawRoomStartPoint) {
    currXY = P_xytonum(uMath.getSnappedEnd(P_numtoxy(PlannerGlobals.drawRoomStartPoint), P_numtoxy(currXY)));
  }

  if (!isPointAvailable(currXY)) {
    if (PlannerGlobals.mode == 'drawOuterW') {
      toastInfo(ts('p_ow_point_in_room_err', "You cannot place a wall there."));
    }
    else {
      toastInfo(ts('point_in_room_err', 'pointInRoomErr'));
    }
    return;
  }

  if (isPointSimilarToLast(PlannerGlobals.drawRoomPoints, currXY)) {
    return;
  }

  if (AnyLineIntersectsARoom(PlannerGlobals.drawRoomPoints, currXY)) {
    if (PlannerGlobals.mode == 'drawOuterW') {
      toastInfo(ts('p_ow_intersect_o_err', "Walls can't intersect rooms."));
    }
    else {
      toastInfo(ts('intersect_o_err', 'intersectOErr'));
    }
    return;
  }

  if (PlannerGlobals.drawRoomPoints.length > 0) {
    if (uDevDOM.segmentIntersectsAnyDev(uMath.segmentFromPoints(P_numtoxy(PlannerGlobals.drawRoomPoints[PlannerGlobals.drawRoomPoints.length - 1]), P_numtoxy(currXY)))) {
      toastInfoSingle(ts('p_ow_intersect_d_err', "Walls can't intersect devices"), false, 'left-out-warning');
      return;
    }
  }

  if (d3.select('g.drawPoly').empty()) {
    PlannerGlobals.g = PlannerGlobals.container.append('g').attr('class', 'drawPoly');
  }

  if (e && e.target.hasAttribute('is-handle') ||
      PlannerGlobals.drawRoomPoints[0] && uMath.pointDistance(P_numtoxy(currXY), P_numtoxy(PlannerGlobals.drawRoomPoints[0])) < 2) {
    if (PlannerGlobals.drawRoomPoints.length > 2) {

      var pointsWOFirst = PlannerGlobals.drawRoomPoints.slice(1, PlannerGlobals.drawRoomPoints.length);

      if (AnyLineIntersectsSelf(pointsWOFirst, currXY)) {
        if (PlannerGlobals.mode == 'drawOuterW') {
          toastInfoSingle(ts('p_ow_intersect_s_err', "Walls can't intersect themselves.", false, 'left-out-warning'));
        }
        else {
          toastInfo(ts('intersect_s_err', 'intersectSErr'));
        }
        return;
      }

      if (PlannerGlobals.mode == 'drawing') {
        closePolygon(PlannerGlobals.drawRoomPoints);
      }
      else if (PlannerGlobals.mode == 'drawOuterW') {
        closePolygonOuter(PlannerGlobals.drawRoomPoints);
      }
      return;
    }
    else {
      return;
    }
  }

  if (isPointOnPreviousSegments(PlannerGlobals.drawRoomPoints, currXY)) {
    return;
  }

  if (AnyLineIntersectsSelf(PlannerGlobals.drawRoomPoints, currXY)) {
    if (PlannerGlobals.mode == 'drawOuterW') {
      toastInfo(ts('p_ow_intersect_s_err', "Walls can't intersect themselves."));
    }
    else {
      toastInfo(ts('intersect_s_err', 'intersectSErr'));
    }
    return;
  }

  PlannerGlobals.drawRoomPoints.push(currXY);
  PlannerGlobals.drawRoomStartPoint = [+currXY[0], +currXY[1]];
  PlannerGlobals.g.select('polyline').remove();

  var polyline = PlannerGlobals.g.append('polyline')
  .attr('points', PlannerGlobals.drawRoomPoints)
  .style('fill', 'none')
  .attr('stroke', PlannerGlobals.mode == 'drawOuterW' ? 'darkorange' : 'red')
  .attr('stroke-width', 1);

  redrawDrawcircles();
}

export function saveOpacity(opacity, callback, errorCallback) {
  getAuthHeader(function (header) {
    $.ajax({
      headers: header,
      url: ROOT_URI + '/floor/update-floor-opacity',
      type: 'POST',
      data: {
        floor_opacity: opacity,
        floor_id: PlannerGlobals.plannerFloorId
      },
      success: function () {
        if (typeof callback === "function") {
          callback();
        }
      },
      error: function (response) {
        genericXHRErrorHandler(response);
        if (typeof errorCallback === "function") {
          errorCallback();
        }
      }
    });
  });
}

export function savePlanNameState(state) {
  getAuthHeader(function (header) {
    $.ajax({
      headers: header,
      url: ROOT_URI + '/floor/update-room-names-visibility',
      dataType: 'json',
      method: 'post',
      data: {
        visible: state ? 1 : 0,
        floor_id: PlannerGlobals.plannerFloorId
      },
      error: function (resp) { genericXHRErrorHandler(resp); }
    });
  });
}

export function savePlanGridImageVisibility() {
  getAuthHeader(function (header) {
    $.ajax({
      headers: header,
      url: ROOT_URI + '/floor/update-room-grid-visibility',
      dataType: 'json',
      method: 'post',
      data: {
        visible: PlannerGlobals.planGridShown ? 1 : 0,
        floor_id: PlannerGlobals.plannerFloorId
      },
      error: function (resp) { genericXHRErrorHandler(resp); }
    });
  });
}

export function setPlanNamesShown(state) {
  PlannerGlobals.planNamesShown = !!state;
  $("#toggle-plannames-btn").children().first().css("opacity", PlannerGlobals.planNamesShown ? 1 : 0.4);
  toolbarSwitchSet("roomname-display", PlannerGlobals.planNamesShown ? "on" : "off");
}

export function togglePlanNames() {
  setPlanNamesShown(!PlannerGlobals.planNamesShown);
  savePlanNameState(PlannerGlobals.planNamesShown);
  redrawRooms();
  redrawGroups();
}

export function toggleSymbols() {
  PlannerGlobals.symbols_on = !PlannerGlobals.symbols_on;
  if (PlannerGlobals.symbols_on) {
    if (PlannerGlobals.notes_on) {
      PlannerGlobals.notes_on = false;
      toolbarSwitchSet("note-display", "off");
      redrawNotes();
    }
  }
  else {
    PlannerGlobals.notes_on = true;
    toolbarSwitchSet("note-display", "on");
    redrawNotes();
  }
  toolbarSwitchSet("symbolname-display", PlannerGlobals.symbols_on ? "on" : "off");
  redrawDevices();
}

export function toggleGrid(){

  $('#gridImage').toggle()

  PlannerGlobals.planGridShown = !!$('#gridImage').is(":visible");

  toolbarSwitchSet("show-grid", PlannerGlobals.planGridShown ? 'on' : 'off');
  savePlanGridImageVisibility();
}

export function toggleOpacity() {
  if (PlannerGlobals.mode == "showBuildingMats") {
    setMode.basic();
  }

  var nextOpacityIdx = (PlannerGlobals.plannerOpacityIdx + 1) % PlannerGlobals.plannerOpacities.length;
  var nextPlannerOpacity = PlannerGlobals.plannerOpacities[nextOpacityIdx];

  if (nextPlannerOpacity === 100) {
    PlannerGlobals.plannerEditableWallViewEnable = true;
    toggleEditableWallViewMode(true);
  } else {
    PlannerGlobals.plannerEditableWallViewEnable = false;
    toggleEditableWallViewMode(false)
  }

  saveOpacity(nextPlannerOpacity, function () {
    PlannerGlobals.plannerOpacityIdx = nextOpacityIdx;
    PlannerGlobals.plannerOpacity = nextPlannerOpacity;
    $('#opacity-display').html(PlannerGlobals.plannerOpacity);
    redrawRooms();
    redrawGroups();
  });
}

export function toggleEditableWallViewMode(enableMode) {

  modeChanged('showBuildingMats');

  setMode.basic();
  CleanupAll();

  if (enableMode === false) {
    return;
  }

  if (!PlannerGlobals.rooms.length) {
    return toastErrorSingle(ts("p_ceilmat_norooms_err", "There are no rooms yet"), false, 'no-rooms-yet');
  }

  PlannerGlobals.container.insert("polygon", ".rooms")
  .attr("points", "0,0 0,900 900,900 900,0")
  .attr("fill-opacity", "1")
  .attr("id", "editableWallViewModeBackground")
  .attr("fill", "white")
  .attr("pointer-events", "none");

  const allPolies = PlannerGlobals.wallSegmentation.calculatedPolygons
  .filter(poly => poly.pts.length >= 3);

  if (!allPolies.length) {
    return toastErrorSingle(ts("p_ceilmat_nomats_err", "Please set the materials of the floor <b>(Hotkey: 6)</b>"), false, 'set-mats-pls');
  }

  const polyCont = PlannerGlobals.container.insert('g', '#gridImage').attr('id', 'build-mat-poly-cont');

  allPolies.forEach(poly => {

    let fillColor = poly.material.fillColor;
    // ha plafon akkor fixen fehére rakjuk ebben a nézetben
    if (poly.id.substring(0, 8) === "ceiling_") {
      fillColor = "white";
    }

    let strokeColor = 'black'

    // fall esetén nem rakunk keretett ez azért kell hogy egységes legyen a fall
    if (poly.id.substring(0, 9) === "polywall_") {
      strokeColor = fillColor;
    }

    polyCont.append('polygon')
      .attr('class', 'build-mat-poly')
      .attr('points', poly.pts.map(pt => pt[0] + "," + pt[1]).join(' '))
      .style('fill', fillColor)
      .style('fill-opacity', 1)
      .style('stroke', strokeColor)
      .style('stroke-width', 0.5)
      .style('pointer-events', 'none');
  });
}

export function zenModeOn() {
  PlannerGlobals.PLANNER_ZEN_MODE = true;
  _plannerCallbacks.onFullscreenChange?.(true);
  $('#zen-mode-on-btn').hide();
  $('#zen-mode-off-btn').show();
  $('#svgAndChat').addClass('zen-mode');
}

export function zenModeOff() {
  PlannerGlobals.PLANNER_ZEN_MODE = false;
  _plannerCallbacks.onFullscreenChange?.(false);
  $('#zen-mode-on-btn').show();
  $('#zen-mode-off-btn').hide();
  $('#svgAndChat').removeClass('zen-mode');
}

export function toggleZenMode() {
  if (PlannerGlobals.PLANNER_ZEN_MODE) {
    zenModeOff();
  }
  else {
    zenModeOn();
  }
}


export function permissionCheck(thisVar) {
  if ($(thisVar).hasClass('planner-button-disabled')) {
    toastRemoveAll();
    toastInfo(ts('p_tool_permission', "Available for Project Admins/Owners only."));
    return false;
  }
  return true;
}

export function removeGhostDevice() {
  PlannerGlobals.GHOST_DEV_PARAMS = null;
  removeLengthLines();
  d3.select('#ghostdev').remove();
}


/**
 * Draws a ghost device to show the user where the device will end up at the end of drag
 * @param {Point} p Closest point on wall
 * @param {Numeber} deg Degree of rotation
 */
export function redrawGhostDevice(p, deg, room, length = 1, d, serialRows = 1) {
  removeGhostDevice();
  var x = p.x;
  var y = p.y;
  var width = length * PlannerGlobals.DEVICE_SIZE + (length - 1) * SERIAL_SPACING;
  var height = PlannerGlobals.DEVICE_SIZE * serialRows + SERIAL_SPACING * (serialRows - 1);
  var rotX = x + width / 2;
  var rotY = y + height / 2;
  var rot = deg;
  let entityType = "none";
  let entityId = "none";
  if (d) {
    if (d.id) {
      entityType = "serial";
      entityId = d.id;
    }
    else if (d.connId) {
      entityType = "serialconn";
      entityId = d.connId;
    }
    else {
      entityType = "device";
      entityId = d.devices[0].deviceId;
    }
  }
  PlannerGlobals.GHOST_DEV_PARAMS = {
    x: +x,
    y: +y,
    rot: +rot,
    roomId: +room.id,
    entityType,
    entityId,
    cx: +rotX,
    cy: +rotY,
  };
  PlannerGlobals.container.append('rect')
    .attr('class', 'ghostdev')
    .attr('id', 'ghostdev')
    .attr('x', x)
    .attr('y', y)
    .attr('width', width)
    .attr('height', height)
    .attr('transform', 'rotate(' + rot + ' ' + rotX + ' ' + rotY + ')')
    .attr('data-rot', rot)
    .attr('data-roomId', room.id)
    .attr('data-entType', PlannerGlobals.GHOST_DEV_PARAMS.entityType)
    .attr('data-entId', PlannerGlobals.GHOST_DEV_PARAMS.entityId)
    .attr('stroke', 'transparent')
    .attr('fill', 'transparent')
    .attr('data-centerX', rotX)
    .attr('data-centerY', rotY)
    .attr('stroke-width', 0.2)
    .attr('rx', '0.2px')
    .attr('ry', '0.2px')
    .attr('style', 'pointer-events: none;');
}

export function twoClosestWallsWithPoints(point, room, d) {
  var walls = wallsOfRoom(room);
  var others = getMeasurementsOfD(d);
  if (others.length >= 2) {
    return [];
  }
  var otherWalls = getMeasurementsOfD(d, "wall");

  // get closest points and their distances on all walls
  walls.forEach(function (wall) {
    var closest = wallClosestPointToPoint(point, wall);
    var dist = uMath.pointDistance(point, closest);
    wall.closestPt = closest;
    wall.distToPt = dist;
  });
  walls = walls.filter(function (wall) {
    // filter too close walls
    if (wall.distToPt < PlannerGlobals.DEVICE_SIZE * 0.75) {
      return false;
    }
    // filter already connected walls
    if (otherWalls.findIndex(function (otherWall) { return otherWall.id == wall.id }) != -1) {
      return false;
    }
    // filter out walls that are not perpendicular to current point
    var v1 = uMath.vectorFromSegment(wall);
    var v2 = uMath.vectorFromSegment(uMath.segmentFromPoints(wall.closestPt, point))
    var dotProduct = uMath.dotProduct(v1, v2);
    return Math.abs(dotProduct) < 1;
  });

  // get closest walls
  walls.sort(function (a, b) {
    var lenA = a.distToPt;
    var lenB = b.distToPt;
    return (lenA > lenB) ? 1 : -1;
  });


  // two closest walls with the closest points to "point" variable
  return walls.slice(0, 2 - others.length);
}

export function removeLengthLines() {
  if (!PlannerGlobals.svg) return;
  PlannerGlobals.svg.selectAll('.lengthLine, .lengthLineText, .lengthLineRect, .lengthLineExtra').remove();
}

/**
 *
 * @param {Point} svgpt
 * @returns {Point}
 */
export function convertSVGPointToPagePoint(svgpt) {
  var containerNode = PlannerGlobals.container.node();
  var svg = containerNode.ownerSVGElement || containerNode;
  var point = svg.createSVGPoint();
  point.x = svgpt.x;
  point.y = svgpt.y;
  var pt2 = point.matrixTransform(containerNode.getScreenCTM());
  return pt2;
}
/**
 *
 * @param {Point} svgpt
 * @param {number} padding
 * @param {Rect} rect
 */
export function isPointVisibleInSVGRect(svgpt, padding = 0, rect) {
  if (!svgpt || !rect) {
    return false;
  }
  var textWinPos = convertSVGPointToPagePoint(svgpt);
  var paddedRect = { x: rect.x + padding, y: rect.y + padding, width: rect.width - padding * 2, height: rect.height - padding * 2 };
  return uMath.rectContainsPoint(paddedRect, textWinPos);
}

/**
 *
 * @param {JQuery<HTMLElement>} jqueryNode
 * @returns {Rect}
 */
export function rectFromNode(jqueryNode) {
  if (jqueryNode.length == 0) {
    return false;
  }
  var offset = jqueryNode.offset();
  var width = jqueryNode.width();
  var height = jqueryNode.height();
  return { x: offset.left, y: offset.top, width, height };
}

/**
 *
 * @param {Point} pointOnSVG
 * @param {number} padding
 * @returns {boolean}
 */
export function isPointVisibleInSVG(pointOnSVG, padding = 0) {
  if (!pointOnSVG) {
    return false;
  }
  var rect = rectFromNode($('#plannerSVG'));
  return isPointVisibleInSVGRect(pointOnSVG, padding, rect);
}

export function addHaventExited(e) {
  if (!e || e && typeof e.isTrigger === "undefined") { // no event supplied or event was real click event
    $('#planner-buttons-left-main').addClass('havent-exited');
    $('#planner-buttons-left-main').mouseleave(haventExitedHandleOnce);
  }
  if (e && typeof e.isTrigger !== "undefined") { // if event is triggered by .click()
    if ($('#planner-buttons-left-main').is(':hover')) {
      $('#planner-buttons-left-main').addClass('havent-exited');
      $('#planner-buttons-left-main').mouseleave(haventExitedHandleOnce);
    }
  }
}

export function haventExitedHandleOnce() {
  $('#planner-buttons-left-main').removeClass('havent-exited');
  $('#planner-buttons-left-main').off('mouseleave', haventExitedHandleOnce);
}

/**
 *
 * @param {Point} p1
 * @param {Point} p2
 */
export function drawLengthLine(p1, p2, cont = PlannerGlobals.container, cls = "lengthLine", source, noLength, stroke = "black", dasharray = "") {
  if (!isPointValid(p1) || !isPointValid(p2)) {
    return;
  }
  var deg = vectorRotationDegree(p1, p2);
  var reverseAnchor = false;
  if (deg >= 85 && deg < 265) {
    deg += 180;
    reverseAnchor = true;
  }

  // Default params
  // Text is at the centre, it has a smaller size
  var textPos = {
    x: (p1.x + p2.x) / 2 + uMath.sinD(deg) * 0.5 - uMath.cosD(deg) * 0.5,
    y: (p1.y + p2.y) / 2 - uMath.cosD(deg) * 0.5 - uMath.sinD(deg) * 0.5
  };
  var textAnchor = "middle";
  var textSize = 3.5;

  // If drawing right now
  if (source == "justDrawing") {
    // text size is bigger
    textSize = 4.5;
    // if text is outside in svg (or 20px close to it)
    // move it to the end of the line
    if (!isPointVisibleInSVG(textPos, 20)) {
      textPos = {
        x: p2.x + uMath.sinD(deg) - uMath.cosD(deg) * 0.5,
        y: p2.y - uMath.cosD(deg) - uMath.sinD(deg) * 0.5
      };
      // if it was reversed, text anchor has to be changed too
      if (reverseAnchor) {
        textAnchor = "start"
      }
      else {
        textAnchor = "end";
      }
    }
  }

  var rawLen = source && source.siblingConnLen ? source.siblingConnLen : uMath.pointDistance(p1, p2);
  var lengthCM = PlannerGlobals.LENGTHOF1PX ? roundTo(rawLen * PlannerGlobals.LENGTHOF1PX, 5) : 0;
  var lengthInch = PlannerGlobals.LENGTHOF1PX ? roundTo(cmToInch(rawLen * PlannerGlobals.LENGTHOF1PX), 2) : 0;
  var writtenLength = isPlannerMetric() ? lengthCM : lengthInch;
  var writtenUnit = isPlannerMetric() ? "cm" : '"';

  cont.insert("line", '#motionsensors')
    .attr('id', function (d) { if (source) { return "line_measure_" + source.id } else { return "" } })
    .attr('data-measurementId', function (d) { if (source) { return source.id } else { return "" } })
    .attr('class', cls)
    .attr('x1', p1.x)
    .attr('y1', p1.y)
    .attr('x2', p2.x)
    .attr('y2', p2.y)
    .attr('stroke', stroke)
    .attr('stroke-width', "0.2px")
    .attr('stroke-dasharray', dasharray)
    .attr('style', "pointer-events: none;");

  var elemIsGhost = source && measureHelper.connIsGhost(source);

  if (!noLength) {
    var placedText = cont.insert("text", '#motionsensors')
      .attr('id', function (d) { if (source) { return "text_measure_" + source.id } else { return "" } })
      .attr('data-measurementId', function (d) { if (source) { return source.id } else { return "" } })
      .attr('class', cls + "Text")
      .attr('x', textPos.x)
      .attr('y', textPos.y)
      .attr('text-anchor', textAnchor)
      .attr('fill', "black")
      .attr('fill-opacity', function (d) { if (source) { return elemIsGhost || source.justDeleted || source.justAdded ? 0.6 : 1; } else { return 1; } })
      .attr('style', "font-size: " + textSize + "px; pointer-events: none;")
      .attr('transform', "rotate(" + deg + " " + textPos.x + " " + textPos.y + ")")
      .text(function () { return writtenLength <= 2 ? "" : writtenLength + writtenUnit; });
    var bbox = uMath.getBBoxIfExists(placedText);
    if (bbox) {
      var bboxPad = bbox.height * 0.15;
      cont.insert('rect', '.' + cls)
        .attr('id', function (d) { if (source) { return "rect_measure_" + source.id } else { return "" } })
        .attr('data-measurementId', function (d) { if (source) { return source.id } else { return "" } })
        .attr('class', cls + "Rect")
        .attr('x', bbox.x)
        .attr('y', bbox.y + bboxPad)
        .attr('width', bbox.width)
        .attr('height', bbox.height - bboxPad * 2)
        .attr('fill', 'white')
        .attr('fill-opacity', 0.65)
        .attr('rx', textSize / 3)
        .attr('ry', textSize / 3)
        .attr('style', "pointer-events: " + (!source || elemIsGhost || source.justDeleted || source.justAdded ? "none" : "all") + ";")
        .attr('transform', "rotate(" + deg + " " + textPos.x + " " + textPos.y + ")")
        .on('mouseover', function () { showMeasureDelTool(this); });
    }
  }
}


export function mouseUpHandler(e) {
  // TODO moveplannercode-dragnewcustomitem
  // if (PlannerGlobals.mode == "measureMe") {
  //   measureHelper.endMeasure(e);
  // }
  // function shiftHandler(e) {
  //   unregisterDNDIcon();
  //   removeGhostDevice();
  //   // unregister self when shift released
  //   $(document).off('keyup', shiftHandler);
  // }
  // if (!e.shiftKey) {
  //   unregisterDNDIcon();
  // } else {
  //   if (typeof ControllerGlobals.currentlyDraggedDevice === 'object' && ControllerGlobals.currentlyDraggedDevice &&
  //       (ControllerGlobals.currentlyDraggedDevice.type === 'device' || ControllerGlobals.currentlyDraggedDevice.type === "custom_device")) {
  //     // register event for releasing shift
  //     $(document).on('keyup', shiftHandler);
  //   }
  //   else {
  //     unregisterDNDIcon();
  //   }
  // }
  // removeGhostDevice();
}

export function abolishInvalidGroups() {
  var didRemove = false;
  var groupsSnapshot = JSON.parse(JSON.stringify(PlannerGlobals.groups));

  PlannerGlobals.groups.forEach(group => {
    if (group.deviceIds.length === 1) {
      removeDeviceFromGroup(group.deviceIds[0]);
      didRemove = true;
    }
  });

  if (didRemove) {
    console.log(`Removed groups with length 1. Original groups were:`, groupsSnapshot);
  }
}

export function devicesChanged() {
  /* if (LIVE_DEBUG_PATHFINDER && !isInQuote) {
        downloadSVGOfCurrent();
    } */
}

export function setMouseDownXY() {
  var t = d3.zoomTransform(PlannerGlobals.svg.node());
  PlannerGlobals.mouseDownTranslate = [t.x, t.y];
  PlannerGlobals.mouseDownPageXY = { x: PAGEXY.x, y: PAGEXY.y };
}

export function wasClickValidForMustClick(e) {
  let which = -1;
  if (e) {
    which = e.which;
  }

  const mustClickCircle = $('circle.must-click-target');

  if (mustClickCircle.length && which !== 2) {
    const cx = mustClickCircle.attr('cx');
    const cy = mustClickCircle.attr('cy');
    const radius = mustClickCircle.attr('r');

    var clickedPt = getXYP();

    if (uMath.pointDistance({ x: cx, y: cy }, clickedPt) >= radius || which !== 1) {
      const mustClickText = $('text.must-click').attr('data-tooltiptext');
      if (mustClickText) {
        toastInfoSingle(mustClickText, false, 'must-click-info');
      }
      return { clickValid: false, needNextCircle: false };
    }
    else {
      PlannerGlobals.XY = [+cx * PlannerGlobals.scalevar + PlannerGlobals.translatevar[0], +cy * PlannerGlobals.scalevar + PlannerGlobals.translatevar[1]];
      return { clickValid: true, needNextCircle: true };
    }
  }
  else {
    return { clickValid: true, needNextCircle: false };
  }
}

export function plannerSVGMouseDownHandler(e) {
  setMouseDownXY();

  const clickAreaState = wasClickValidForMustClick(e);
  if (!clickAreaState.clickValid) { return; }

  if (e.which == 1 && !PlannerGlobals.entitySelectStartPos) {
    entitySelectUpdate();
    entitySelectClick();
  }
  if (e.which == 1 || e.which == 3) {
    wallSelectUpdate();
    wallSelectStart(e);
  }
  if (e.which == 1 && PlannerGlobals.mode == "measurePrepare") {
    var xy = getXYP();
    measureHelper.startMeasureManual(xy);
  }
  if (e.which == 3 && PlannerGlobals.mode == "groupMe") {
    setMode.basic();
  }
}

export function plannerHoverMouseOver(e) {
  var cls = (typeof e.target.className === "object" && 'baseVal' in e.target.className) ? e.target.className.baseVal : e.target.className;
  if (cls.indexOf("device") !== -1) {
    PlannerGlobals.lastDevIdMouseOver = e.target.id;
  }
  else if (cls.indexOf("note-elem") !== -1) {
    var noteId = e.target.getAttribute('data-noteId');
    if (cls.indexOf("dev-note-rect") !== -1) {
      PlannerGlobals.lastDevIdMouseOver = noteId;
    }
    else {
      PlannerGlobals.lastNoteIdMouseOver = noteId;
    }
  }
}

export function plannerHoverMouseOut(e) {
  var cls = (typeof e.target.className === "object" && 'baseVal' in e.target.className) ? e.target.className.baseVal : e.target.className;
  if (cls.indexOf("device") !== -1) {
    PlannerGlobals.lastDevIdMouseOver = null;
  }
  else if (cls.indexOf("note-elem") !== -1) {
    if (cls.indexOf("dev-note-rect") !== -1) {
      PlannerGlobals.lastDevIdMouseOver = null;
    }
    else {
      PlannerGlobals.lastNoteIdMouseOver = null;
    }
  }
}

/**
 *
 * @param {boolean} realAlone
 * @param {Serial | null} realTargetSerial
 * @param {Serial | null} realConnectTo
 * @returns
 */
export function addPlaceDeviceAction(realAlone = false, realTargetSerial = null, realConnectTo = null) {
  return function (newDev, resp, ser, newAddonDev) {
    const prom = ser && realConnectTo ? connectSerials(ser.id, realConnectTo.id) : Promise.resolve();
    return prom.then(() => {
      if (newDev) {
        try {
          var action = new CreateSingleDeviceAction(newDev, realAlone, realTargetSerial, newAddonDev, realConnectTo);
          PlannerGlobals.plannerHistoryManager.addHistoryEntry(action);
        }
        catch (err) {
          console.debug(err);
        }
      }
    });
  }
}

export function isBlockingModalOpen() {
  return $('.modal').hasClass('in') || !!$('.MuiDialog-root').length;
}

export function eventShouldntTriggerHotkey(e) {
  var $tar = $(e.target);

  if (!('key' in e)) {
    return;
  }

  var pressedIsEnterOrEsc = e.key === "Enter" || e.key === "Escape";
  const pressedIsEsc = e.key === "Escape";

  const pulsingHotkey = $('.uplan-pulse').find('.planner-hotkey').text();
  if ($('.tour.popover').not('.hidden').length && e.key != pulsingHotkey) {
    return e.key != pulsingHotkey;
  }

  return e.ctrlKey || e.altKey || e.shiftKey || e.metaKey ||
      $tar.is('input') && !pressedIsEnterOrEsc || $tar.is('textarea') ||
      PlannerGlobals.isInQuote || PlannerGlobals.isDragging || ControllerGlobals.currentlyDraggedDevice ||
      isBlockingModalOpen() || !!$('.showSweetAlert, .jstree-rename-input').length ||
      $('.must-click').length || (pressedIsEsc && $('.must-click-pulse').length);
}

/**
 *
 * @param {{selector: string,
 *  placement: string,
 *  imagelink: string?,
 *  learnlink: string?,
 *  title: string?,
 *  hotkey: string?,
 *  body: string?,
 *  learntext: string?,
 *  manualOnly: boolean?,
 *  viewport: string?,
 *  container: string?,
 *  styles: Object.<string,string>?,
 *  top: string?
 *  }} descriptor
 */
export function createRichTooltip(descriptor) {
  var DEFAULT_HIDE_DELAY = 400;
  var DEFAULT_SHOW_DELAY_NOT_SHOWN = 750;
  var DEFAULT_SHOW_DELAY_SHOWN = 100;

  var origiTitle = $(descriptor.selector).attr('title') || $(descriptor.selector).attr('data-original-title');
  $(descriptor.selector)
  .removeAttr('title')
  .removeAttr('data-original-title')
  .removeAttr('data-toggle')
  .removeAttr('data-placement')
  .tooltip('destroy');

  let tooltipHideTimeout = null;
  let tooltipShowTimeout = null;

  if (descriptor.selector.indexOf('#') !== 0) {
    return console.log("Rich Tooltips only support IDs as selectors right now. Please supply a selector starting with '#'");
  }

  var shortSelector = descriptor.selector.replace('#', '');

  var tooltipBody = $('<div></div>').css('display', 'flex').css('flex-direction', 'column').css('font-size', '15px');

  if (typeof descriptor.imagelink === "string" && descriptor.imagelink.trim().length > 0) {
    var imageSrc = descriptor.imagelink.startsWith("http") ? descriptor.imagelink : getFrontendURL() + descriptor.imagelink;
    tooltipBody.append(`<img src="${imageSrc}" />`);
  }

  var paddedElem = $('<div></div>').css('padding', '10px 20px');
  tooltipBody.append(paddedElem);

  var tTitle = (descriptor.title || origiTitle || "") + (descriptor.hotkey ? ` (${descriptor.hotkey})` : "");

  if (typeof tTitle === "string" && tTitle.trim().length > 0) {
    paddedElem.append(`<div style="text-align: left;font-weight:600;">${tTitle.trim()}</div>`)
  }

  if (typeof descriptor.body === "string" && descriptor.body.trim().length > 0) {
    paddedElem.append(`<div style="text-align: left;margin: 10px 0;">${descriptor.body}</div>`)
  }

  if (typeof descriptor.learnlink === "string" && descriptor.learnlink.trim().length > 0 &&
      typeof descriptor.learntext === "string" && descriptor.learntext.trim().length > 0) {
    paddedElem.append(`<div style="text-align: right;font-weight:600;"><a class="learnhow-link" href="${descriptor.learnlink}" target="_blank">${descriptor.learntext}</a></div>`)
  }

  if (paddedElem.text().length === 0) {
    paddedElem.remove();
  }

  var tooltipObj = {
    trigger: 'manual',
    html: true,
    container: 'body',
    placement: descriptor.placement,
    template: `<div class="tooltip tooltip-rich ${shortSelector}" role="tooltip" ><div class="tooltip-arrow"></div><div class="tooltip-inner" ></div></div>`,
    title: tooltipBody[0].outerHTML
  };

  ['viewport', 'container'].forEach(function (key) {
    if (key in descriptor) {
      tooltipObj[key] = descriptor[key];
    }
  });

  $(descriptor.selector)
  .off('inserted.bs.tooltip.g1')
  .on('inserted.bs.tooltip.g1', function () {
    if (typeof descriptor.styles === "object") {
      for (let key in descriptor.styles) {
        $(`.tooltip.${shortSelector}`).css(key, descriptor.styles[key]);
      }
    }
    if (descriptor.top) {
      setTimeout(function () { $(`.tooltip.${shortSelector}`).css("top", descriptor.top); }, 0);
    }
  })
  .tooltip(tooltipObj);

  if (!descriptor.manualOnly) {
    $(descriptor.selector)
    .on("mouseenter", function (e) {
      tooltipHideTimeout && clearTimeout(tooltipHideTimeout);
      tooltipShowTimeout && clearTimeout(tooltipShowTimeout);

      if (e.originalEvent.buttons || $(`.tooltip.${shortSelector}`).is(":visible")) { return; }

      var _this = this;
      var isOneVisible = $('.tooltip-rich').is(':visible');

      tooltipShowTimeout = setTimeout(function () {
        if (descriptor.selector !== "#wizard-btn-dropdown") {
          // if (!(newTour.isOngoing() && newTour.currStepId === "wizard")) {
          closeWizListDelay(0);
          // }
        }

        $(".tooltip").not(`.${shortSelector}`).not('.tooltip-clickhere').remove(); // remove other tooltips
        $(_this).tooltip("show"); // show this tooltip
        $(`.tooltip.${shortSelector}`) // make this tooltip close after tooltip mouseleave
        .off('mouseenter.g1')
        .on('mouseenter.g1', function () {
          if (descriptor.selector === "#wizard-btn-dropdown") {
            wizardListTimeout && clearTimeout(wizardListTimeout);
          }
        })
        .off("mouseleave.g1")
        .on("mouseleave.g1", function () {
          tooltipHideTimeout && clearTimeout(tooltipHideTimeout);
          wizardListTimeout && clearTimeout(wizardListTimeout);

          tooltipHideTimeout = setTimeout(function () {
            if (!$(`.tooltip.${shortSelector}:hover`).length) {
              $(`.tooltip.${shortSelector}`).remove();
            }
          }, DEFAULT_HIDE_DELAY);

        })
        .on("click", function () { // make tooltip close on elem click
          tooltipHideTimeout && clearTimeout(tooltipHideTimeout);
          $(".tooltip").not('.tooltip-clickhere').remove();
        });
      }, (isOneVisible) ? DEFAULT_SHOW_DELAY_SHOWN : DEFAULT_SHOW_DELAY_NOT_SHOWN);

    })
    .on("mouseleave", function () { // make tooltip close on elem mouseleave
      tooltipHideTimeout && clearTimeout(tooltipHideTimeout);
      tooltipShowTimeout && clearTimeout(tooltipShowTimeout);

      tooltipHideTimeout = setTimeout(function () {
        if (!$(`.tooltip.${shortSelector}:hover`).length) {
          $(`.tooltip.${shortSelector}`).remove();
        }
      }, DEFAULT_HIDE_DELAY);
    })
    .on("click", function (e) { // make tooltip close on elem click
      tooltipHideTimeout && clearTimeout(tooltipHideTimeout);
      tooltipShowTimeout && clearTimeout(tooltipShowTimeout);

      if ($(e.target).closest('#wizard-btn-dropdown').length === 0) {
        $(".tooltip").remove();
      }
    });
  }

}

export function initPlannerTooltips() {
  $('.planner-icon-btn').tooltip({
    trigger: 'hover',
    container: 'body'
  });

  $('.planner-tooltipped-input').tooltip({
    trigger: 'hover focus',
    container: 'body'
  });

  [
    {
      selector: "#toggle-wallselect-btn",
      placement: "bottom",
      imagelink: "/images/tutorial/draw_scale.gif",
      learnlink: "https://youtu.be/p_LR4dVuUNA",
      hotkey: "9",
      body: ts("p_tt_1_body", "You can set the floor's scale with this tool"),
      learntext: ts('p_tt_learnhow', "Learn how")
    },
    {
      selector: "#toggle-drawouter-btn",
      placement: "bottom",
      imagelink: "/images/tutorial/2_tool.gif",
      learnlink: "https://youtu.be/p_LR4dVuUNA",
      hotkey: "1",
      body: ts("p_tt_2_body", "You can draw the outer walls of the building with this tool"),
      learntext: ts('p_tt_learnhow', "Learn how")
    },
    {
      selector: "#toggle-drawing-btn",
      placement: "bottom",
      imagelink: "/images/tutorial/3_tool_v6.gif",
      learnlink: "https://youtu.be/p_LR4dVuUNA",
      hotkey: "2",
      body: ts("p_tt_3_body", "You can draw the walls of the rooms with this tool"),
      learntext: ts('p_tt_learnhow', "Learn how")
    },
    {
      selector: "#toggle-doorselect-btn",
      placement: "bottom",
      imagelink: "/images/tutorial/4_tool.gif",
      hotkey: "3",
      body: ts("p_tt_4_body", "You can draw the doors with this tool"),
    },
    {
      selector: "#toggle-windowselect-btn",
      placement: "bottom",
      imagelink: "/images/tutorial/5_tool.gif",
      hotkey: "4",
      body: ts("p_tt_5_body", "You can draw the windows with this tool"),
    },
    {
      selector: "#measure-distance-btn",
      placement: "bottom",
      imagelink: "/images/tutorial/6_tool.gif",
      hotkey: "5",
      body: ts("p_tt_6_body", "You can measure distances between elements with this tool"),
    },
    {
      selector: "#wizard-btn-dropdown",
      top: '45px',
      placement: "left",
      imagelink: "/images/tutorial/7_tool.gif",
      learnlink: "https://www.youtube.com/watch?v=MK9pdI2UsCA",
      body: ts("p_tt_7_body", "The uPlan Wizard automatically generates the required devices on your plan."),
      learntext: ts('p_tt_learnhow', "Learn how"),
      styles: { width: 250 }
    },
    {
      selector: '#set-wall-types-btn',
      placement: 'bottom',
      imagelink: '/images/tutorial/wallmat_tool.gif',
      hotkey: "6",
      body: ts("p_tt_8_body", "You can set the materials of the building with this tool")
    }
  ].forEach(function (tooltipDescriptor) {
    createRichTooltip(tooltipDescriptor);
  });
}

export function openWizList() {
  if (wizardListTimeout) {
    clearTimeout(wizardListTimeout);
  }
  $('#wizard-dropdown-list').css('pointer-events', '');
  $('#wizard-btn-dropdown').addClass('list-in');
}

export function closeWizListDelay(delay) {
  if (wizardListTimeout) {
    clearTimeout(wizardListTimeout);
  }
  wizardListTimeout = setTimeout(function () {
    $('#wizard-btn-dropdown').removeClass('list-in');
    $('#wizard-dropdown-list').css('pointer-events', 'none');
    $('.wiz-drop-subs-container').addClass('hidden');
    $('#lox-drop-arrow, #conv-drop-arrow').removeClass('rotate180');
  }, delay);
}

//DEPRECATED - making a new group
export function groupingSave() {
  if (newGroupConnections.length > 1) {
    PlannerGlobals.groups.push({
      id: newGroupId++,
      deviceIds: newGroupConnections
    });
  }
  redrawGroups();
  groupingCleanup();
  setMode.prepareGrouping();
}

export function chatCleanup() {
  if (PlannerGlobals.mode == 'commenting') {

    chatMomentSVGTranslate = null;
    chatRelDevice = null;
    /* $('#chatbox').animate({bottom: -CHATBOX_HEIGHT}, 500, function() {
          chatbox.html('')
        }) */
    $('#svgAndChat').find('.important-msg-container').remove();
    //importantElems.splice(0);
    $('.device').css('cursor', '');
    //closeChatbox();
  }
}

export function deleteCleanup() {
  hideTools();
}

export function drawCleanup() {
  if (PlannerGlobals.svg) {
    PlannerGlobals.svg.style('cursor', '');
  }

  d3.select('.drawPoly').remove();
  $('#modify-bg-btn').css("display", "");
  /* $('#planner-sizers').removeClass('hidden'); */
  PlannerGlobals.isDrawing = false;
  PlannerGlobals.drawRoomStartPoint = null;
  PlannerGlobals.drawRoomPoints.splice(0);
}

export function groupingCleanup() {
  unHighlight('grp');
  newGroupConnections = [];
  d3.select('.newgrouplines').remove();
  $('planner-grouping-item').addClass('hidden');
}

export function groupMeCleanup() {
  PlannerGlobals.groupMeSourceId = undefined;
  PlannerGlobals.groupMeXY = undefined;
  PlannerGlobals.svg.selectAll('.new-groupme-line').remove();
}

export function rotateMeCleanup() {
  if (PlannerGlobals.mode === 'rotateMe') {
    $('#rotate-tool').remove();
    $('.rotate-helper').remove();
  }
}

export function showImportantsCleanup() {
  hideDevSymbols();
  $('#toggle-importants-btn').removeClass('pressed');
}

export function wallSelectCleanup() {
  if (PlannerGlobals.mode == 'wallSelect' || PlannerGlobals.mode == 'wallSelected') {
    PlannerGlobals.svg.style('cursor', '');
    PlannerGlobals.svg.selectAll('.wallSelectLine').remove();
    d3.select('.wallSelectModifyCircles').remove();
    $('#toggle-wallselect-btn').removeClass('pressed');
    $('#modify-bg-btn').css("display", "");
    PlannerGlobals.wallInput.attr('class', 'wallInputHidden');
    if (!PlannerGlobals.isInQuote) {
      $('#svgAndChat').attr('tabindex', 0).focus();
    }
  }
}

export function wallSelectModifyCleanup() {
  if (PlannerGlobals.mode == 'wallSelectModify' || PlannerGlobals.mode == 'wallSelected') {
    PlannerGlobals.svg.selectAll('.wallSelectLine').remove();
    d3.select('.wallSelectModifyCircles').remove();
    $('#toggle-wallselect-btn').removeClass('pressed');
    $('#modify-bg-btn').css("display", "");
    PlannerGlobals.wallInput.attr('class', 'wallInputHidden');
    if (!PlannerGlobals.isInQuote) {
      $('#svgAndChat').attr('tabindex', 0).focus();
    }
  }
}

export function entitySelectCleanup() {
  if (PlannerGlobals.mode == 'entitySelect') {
    PlannerGlobals.entitySelectStartPos = null;
    PlannerGlobals.entitySelectEndPos = null;
    PlannerGlobals.svg.style("cursor", '');
    //svg.selectAll('.entitySelectRect').remove();
    PlannerGlobals.svg.selectAll('.entitySelectPt').remove();
  }
}

export function editPictureCleanup() {
  if (PlannerGlobals.mode == 'editPicture') {
    PlannerGlobals.svg.selectAll('.edit-elem').remove();
    $('#containerSVG').removeClass('edit-picture');
    $(".planner-buttons-cont").removeClass('hidden');
    $('#planner-buttons-crop').addClass('hidden');
    PlannerGlobals.svg.attr('viewBox', getViewBox());
  }
}

export function CleanupAll(noRemoveToast) {
  $('.planner-modify-item, .planner-grouping-item').addClass('hidden');
  $('.planner-floor-manip').removeClass('hidden');
  $('.wizard-hidden-btn').addClass('hidden');
  $('.pressed').removeClass('pressed');
  $('.disable-exception').removeClass('disable-exception');
  enablePlannerButtons();
  dontRequireLeavingToolbarOnce();
  resetMeasureProps();
  if (!PlannerGlobals.isInQuote && !noRemoveToast) {
    toastRemoveAll();
  }
  // if (newTour.isOngoing()) {
  //     newTour.cleanUpMustClick();
  // }
  cleanupMethods.forEach(function (method) {
    try {
      method();
    }
    catch (err) {
      var name = "";
      if ('name' in method && typeof method.name === "string") {
        name = method.name;
      }
      console.debug('caught error in cleanup method ' + name, err)
    }
  });
}

export const cleanupMethods = [
  modifyUndo,
  drawCleanup,
  chatCleanup,
  deleteCleanup,
  groupingCleanup,
  groupMeCleanup,
  rotateMeCleanup,
  showImportantsCleanup,
  wallSelectCleanup,
  wallSelectModifyCleanup,
  entitySelectCleanup,
  measurePrepareCleanup,
  outerWallModCleanup,
  editPictureCleanup,
  lightingCleanup,
  buildingMatCleanup
];

export function buildingMatCleanup() {
  if (PlannerGlobals.mode === "showBuildingMats") {
    modeChanged('showBuildingMatsCleanup');


    d3.selectAll('#devicesMain, #grouppaths, #measurements, #notes, .doorOrWindowContainer').style('opacity', '');
    d3.select('#build-mat-poly-cont').remove();
    d3.select('#editableWallViewModeBackground').remove();
    redrawRooms();
    toolbarSwitchSet("building-mat-display", "off");

    modeChanged('showBuildingMats');

  }
}

export function lightingCleanup() {
  if (PlannerGlobals.LIGHTING_CALC) {
    PlannerGlobals.LIGHTING_CALC.stopLightCalcMode();
  }
}

export function modifyWallsOfRoom(room) {
  var walls = [];

  for (var currPt = 0; currPt < PlannerGlobals.modifiedPoly.length; currPt++) {
    walls.push({
      x1: PlannerGlobals.modifiedPoly[currPt].x,
      y1: PlannerGlobals.modifiedPoly[currPt].y,
      x2: PlannerGlobals.modifiedPoly[(currPt + 1) % PlannerGlobals.modifiedPoly.length].x,
      y2: PlannerGlobals.modifiedPoly[(currPt + 1) % PlannerGlobals.modifiedPoly.length].y,
      id: PlannerGlobals.modifiedPoly[currPt].id
    });
  }

  return walls;
}

export function getMotionSensorRadius(height, angle) {

  // 10 méter felet nem számolunk
  if(height > 1000){
    height = 1000;
  }

  height = height - 50;
  if (height < 0) {
    height = 0;
  }
  return Math.round(Math.tan(degToRad(angle)) * height * 100) / 100;
}

export function customDevChanged(custom_device_id, iconSvg, iconColor) {
  if ($("#plannerSVG").length == 0) { return; }
  const numericId = custom_device_id.toString().replace("user_custom_item_", "");
  const svg = $('<div>').html(iconSvg).find('svg');
  if (!svg[0]) { return; }
  svg.find('path').attr('fill', iconColor);
  const newImage = "data:image/svg+xml;base64," + btoa(svg[0].outerHTML);
  PlannerGlobals.devices
    .filter(function (elem) { return elem.user_custom_item_id == numericId; })
    .forEach(function (planDev) {
      planDev.image = newImage;
      planDev.image_color = iconColor;
    });
  redrawDevices();
}
export function customDevDeleted(custom_device_id) {
  if ($("#plannerSVG").length == 0) { return; }
  // delete from plan
  PlannerGlobals.devices = PlannerGlobals.devices.filter(function (elem) {
    return elem.user_custom_item_id != custom_device_id.replace("user_custom_item_", "");
  });
  redrawDevices();
}

export function addContainerForHullTest() {
  if (!$('#hullTestGL').length) {
    PlannerGlobals.container.append('g').attr('id', 'hullTestGL');
    PlannerGlobals.container.append('g').attr('id', 'hullTestGC');
  }
}
export function getClientPlannerScaleRatio(scaleOverride = null) {
  try {
    if (isPlannerVisible() && (typeof PlannerGlobals.scalevar !== "undefined" || scaleOverride)) {

      const testScale = scaleOverride || PlannerGlobals.scalevar;

      const svgElem = document.getElementById('plannerSVG');
      if (svgElem) {
        const viewBoxWidth = svgElem.viewBox.baseVal.width;
        const viewBoxHeight = svgElem.viewBox.baseVal.height;
        const clientWidth = svgElem.width.baseVal.value;
        const clientHeight = svgElem.height.baseVal.value;

        const widthRatio = clientWidth / viewBoxWidth;
        const heightRatio = clientHeight / viewBoxHeight;

        if (widthRatio < heightRatio) {
          return testScale * widthRatio;
        }
        else {
          return testScale * heightRatio;
        }
      }
      else {
        return 1;
      }
    }
    else {
      return 1;
    }
  }
  catch (err) {
    console.debug(err);
    return 1;
  }
}

export function isPlannerVisible() {
  return $('#svgAndChat').is(":visible");
}

export function isSecretPlanner() {
  return !!$('#secret-planner').length;
}

export function isQuoteDocuBomVisible() {
  if (isPlannerVisible()) {
    return false;
  }

  var bomElem = $('.bom-h1');
  if (bomElem.length) {
    var projectId = bomElem.attr('data-projectid');
    return projectId;
  }

  var docuElem = $('.docu');
  if (docuElem.length) {
    var projectId = docuElem.attr('data-projectid');
    return projectId;
  }

  var quoteElem = $('.quote-tables');
  if (quoteElem.length) {
    var projectId = quoteElem.attr('data-projectid');
    return projectId;
  }

  return false;
}

export function isPlannerBusyWithPlacing() {
  return PlannerGlobals.plannerIsRemovingDevices || $(
      '#svgAndChat').hasClass('pulsing');
}